

(function () {

    var descCache = Object.create(null);
    var descPending = Object.create(null);
    var descScheduleTimer = null;
    var lastCardProductHandle = '';
    var SNIZE_QV_SECTION_ID = 'snize-quick-view-description';
    var klaviyoSnizeTimer = null;
    var klaviyoModalMutTimer = null;
    var SNIZE_KLAVIYO_BIS_FORM_ID = window.SNIZE_KLAVIYO_BIS_FORM_ID || 'UuSfSN';
    var SNIZE_KLAVIYO_COMPANY_ID = window.SNIZE_KLAVIYO_COMPANY_ID || 'WdLqxR';
    var snizeKlaviyoCompanyIdCache = SNIZE_KLAVIYO_COMPANY_ID || '';
    var snizeKlaviyoPendingBis = null;
    function snizeResolveVariantFromProduct(product, preferredId) {
      if (!product || !product.variants || !product.variants.length) return '';
      var pref = String(preferredId || '').trim();
      if (pref) {
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === pref) return String(product.variants[i].id);
        }
      }
      for (var j = 0; j < product.variants.length; j++) {
        if (!product.variants[j].available) return String(product.variants[j].id);
      }
      return String(product.variants[0].id);
    }

    function resolveSnizeKlaviyoCompanyId() {
      if (snizeKlaviyoCompanyIdCache) return snizeKlaviyoCompanyIdCache;
      var scripts = document.querySelectorAll('script[src*="klaviyo"]');
      for (var i = 0; i < scripts.length; i++) {
        var src = scripts[i].getAttribute('src') || '';
        var m = src.match(/\/onsite\/js\/([A-Za-z0-9]{6})\//);
        if (m) {
          snizeKlaviyoCompanyIdCache = m[1];
          return snizeKlaviyoCompanyIdCache;
        }
      }
      try {
        var html = document.documentElement.innerHTML;
        var m2 = html.match(/company_id=([A-Za-z0-9]{6})/);
        if (m2) {
          snizeKlaviyoCompanyIdCache = m2[1];
          return snizeKlaviyoCompanyIdCache;
        }
      } catch (eHtml) {}
      return '';
    }

    function snizeGetKlaviyoProductHandleOverride() {
      if (snizeKlaviyoPendingBis && snizeKlaviyoPendingBis.handle) return snizeKlaviyoPendingBis.handle;
      if (window.__snizeKlaviyoProductHandleOverride) return String(window.__snizeKlaviyoProductHandleOverride).trim();
      return '';
    }

    function snizeBuildProductJsUrl(handle) {
      if (!handle) return '';
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js';
    }

    function snizeFixKlaviyoProductJsUrl(reqUrl) {
      var handle = snizeGetKlaviyoProductHandleOverride();
      if (!handle || !reqUrl) return reqUrl;
      var urlStr = String(reqUrl);
      var needsRewrite =
        /\/collections\/[^/?#]+\.js(?:\?|#|$)/i.test(urlStr) ||
        /\/pages\/[^/?#]+\.js(?:\?|#|$)/i.test(urlStr);
      if (!needsRewrite) {
        var path = window.location && window.location.pathname ? window.location.pathname : '';
        if (path && /\/collections\/|\/pages\//.test(path)) {
          var suffix = path + '.js';
          if (urlStr === suffix || urlStr.indexOf(suffix) !== -1) needsRewrite = true;
        }
      }
      if (!needsRewrite) return reqUrl;
      var productJsPath = snizeBuildProductJsUrl(handle);
      if (!productJsPath) return reqUrl;
      if (/^https?:\/\//i.test(urlStr)) {
        var origin = window.location && window.location.origin ? window.location.origin : '';
        return origin ? origin + productJsPath : productJsPath;
      }
      return productJsPath;
    }

    function setSnizeKlaviyoBisPendingContext(context) {
      if (!context || !context.variantId) return;
      snizeKlaviyoPendingBis = {
        variantId: String(context.variantId).trim(),
        productId: context.productId ? String(context.productId).trim() : '',
        handle: context.handle ? String(context.handle).trim() : '',
        formId: context.formId || SNIZE_KLAVIYO_BIS_FORM_ID,
        ts: Date.now()
      };
      if (snizeKlaviyoPendingBis.handle) {
        window.__snizeKlaviyoProductHandleOverride = snizeKlaviyoPendingBis.handle;
      }
      snizeEnsureKlaviyoFetchRewrite();
    }

    function snizeEnsureKlaviyoFetchRewrite() {
      if (window.__snizeKlaviyoFetchRewrite) return;
      window.__snizeKlaviyoFetchRewrite = true;

      var nativeFetch = window.fetch;
      if (nativeFetch) {
        window.fetch = function (input, init) {
          try {
            var reqUrl = typeof input === 'string' ? input : input && input.url ? input.url : '';
            var fixed = snizeFixKlaviyoProductJsUrl(reqUrl);
            if (fixed && fixed !== reqUrl) {
              return nativeFetch.call(this, fixed, init);
            }
          } catch (eFetch) {}
          return nativeFetch.call(this, input, init);
        };
      }

      if (window.XMLHttpRequest && XMLHttpRequest.prototype.open) {
        var nativeOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url, async, user, password) {
          try {
            if (typeof url === 'string') url = snizeFixKlaviyoProductJsUrl(url);
          } catch (eXhr) {}
          return nativeOpen.call(this, method, url, async, user, password);
        };
      }
    }

    snizeEnsureKlaviyoFetchRewrite();

    function clearSnizeKlaviyoBisPendingContext() {
      snizeKlaviyoPendingBis = null;
      try {
        delete window.__snizeKlaviyoProductHandleOverride;
      } catch (eClr) {
        window.__snizeKlaviyoProductHandleOverride = '';
      }
    }

    function snizeReadKlaviyoBisContextFromForm(form, btn) {
      var vid = btn && btn.getAttribute('data-variant-id') ? String(btn.getAttribute('data-variant-id')).trim() : '';
      var pid = btn && btn.getAttribute('data-product-id') ? String(btn.getAttribute('data-product-id')).trim() : '';
      if (form) {
        if (!vid) {
          var vi = form.querySelector('input[name="variant_id"]');
          if (vi && vi.value) vid = String(vi.value).trim();
        }
        if (!vid) {
          var hi = form.querySelector('input[name="id"]');
          if (hi && hi.value) vid = String(hi.value).trim();
        }
        if (!pid) {
          var pi = form.querySelector('input[name="product_id"]');
          if (pi && pi.value) pid = String(pi.value).trim();
        }
      }
      return { variantId: vid, productId: pid };
    }

    function snizeIsNumericShopifyId(id) {
      return /^\d+$/.test(String(id || '').trim());
    }


    function snizeIsShopifyProductPage() {
      return /\/products\/[^/]+/.test(window.location.pathname || '');
    }

    function snizeSpoofKlaviyoProductUrl(handle, variantId) {
      if (!handle || !variantId) return null;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var productPath = root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle);
      var productUrl = productPath + '?variant=' + encodeURIComponent(String(variantId));
      var restore = {
        href: window.location.href,
        pathname: window.location.pathname,
        search: window.location.search || ''
      };
      window.__snizeKlaviyoUrlRestore = restore;
      window.__snizeKlaviyoProductHandleOverride = handle;
      try {
        history.replaceState({ snizeKlaviyoSpoof: true }, '', productUrl);
      } catch (ePush) {}
      return restore;
    }

    function snizeRestoreKlaviyoProductUrl() {
      var restore = window.__snizeKlaviyoUrlRestore;
      if (!restore) return;
      delete window.__snizeKlaviyoUrlRestore;
      try {
        history.replaceState({}, '', restore.pathname + restore.search);
      } catch (e1) {
        try {
          history.replaceState({}, '', restore.href);
        } catch (e2) {}
      }
    }

    function snizePrepareKlaviyoBisPageContext(context) {
      if (!context || !context.variantId) return;
      setSnizeKlaviyoBisPendingContext({
        variantId: context.variantId,
        productId: context.productId || '',
        handle: context.handle || '',
        formId: context.formId || SNIZE_KLAVIYO_BIS_FORM_ID
      });
      snizeInstallKlaviyoVariantShim(context.variantId);
      if (context.handle && !snizeIsShopifyProductPage()) {
        snizeSpoofKlaviyoProductUrl(context.handle, context.variantId);
      }
    }

    function snizeInjectShopifyProductMeta(product, variantId) {
      if (!product) return;
      try {
        window.meta = window.meta || {};
        window.meta.product = product;
        if (variantId) window.meta.selectedVariantId = Number(variantId);
      } catch (eMeta) {}
      try {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) {
          window.ShopifyAnalytics.meta.product = {
            id: product.id,
            gid: product.id,
            type: 'product',
            variants: product.variants
          };
          if (variantId) window.ShopifyAnalytics.meta.selectedVariantId = Number(variantId);
        }
      } catch (eSa) {}
    }

    function snizeInstallKlaviyoVariantShim(variantId) {
      if (!variantId || !snizeIsNumericShopifyId(variantId)) return;
      var idStr = String(variantId).trim();
      var shimId = 'snize-klaviyo-bis-variant-shim';
      var shim = document.getElementById(shimId);
      if (!shim) {
        shim = document.createElement('form');
        shim.id = shimId;
        shim.setAttribute('data-snize-klaviyo-variant-shim', '1');
        shim.setAttribute('action', '/cart/add');
        shim.style.cssText =
          'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'id';
        shim.appendChild(input);
        document.body.appendChild(shim);
      }
      var idInput = shim.querySelector('input[name="id"]');
      if (idInput) idInput.value = idStr;
      try {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) {
          window.ShopifyAnalytics.meta.selectedVariantId = Number(idStr);
        }
      } catch (eMeta) {}
    }

    function snizePrimeKlaviyoProductContext(variantId, productId, productHandle) {
      if (!variantId) return;
      snizeInstallKlaviyoVariantShim(variantId);
      try {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var url = productHandle
          ? root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(productHandle) + '?variant=' + variantId
          : window.location.href;
        var item = {
          Title: '',
          ItemId: productId ? String(productId) : String(variantId),
          Url: url,
          Metadata: { VariantId: String(variantId) }
        };
        if (window.klaviyo && typeof window.klaviyo.trackViewedItem === 'function') {
          window.klaviyo.trackViewedItem(item);
        } else if (window._learnq && typeof window._learnq.push === 'function') {
          window._learnq.push(['trackViewedItem', item]);
        }
      } catch (ePrime) {}
    }

    function subscribeSnizeKlaviyoBackInStock(email, variantId, productId, done) {
      var companyId = resolveSnizeKlaviyoCompanyId();
      if (!companyId || !email || !variantId || !snizeIsNumericShopifyId(variantId)) {
        if (done) done(false);
        return;
      }

      var payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + String(variantId)
              }
            }
          }
        }
      };

      fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId),
        {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-06-15'
          },
          body: JSON.stringify(payload)
        }
      )
        .then(function (res) {
          if (done) done(!!(res && (res.ok || res.status === 202)));
        })
        .catch(function () {
          if (done) done(false);
        });
    }

    function snizeOpenKlaviyoBisWithValidatedContext(context, done) {
      if (!context || !context.variantId) {
        if (done) done(false);
        return;
      }
      var handle = context.handle ? String(context.handle).trim() : '';
      function finish(ctx, product) {
        if (!ctx || !ctx.variantId || !snizeIsNumericShopifyId(ctx.variantId)) {
          if (done) done(false);
          return;
        }
        snizePrepareKlaviyoBisPageContext({
          variantId: ctx.variantId,
          productId: ctx.productId || '',
          handle: ctx.handle || handle || '',
          formId: SNIZE_KLAVIYO_BIS_FORM_ID
        });
        if (product) snizeInjectShopifyProductMeta(product, ctx.variantId);
        snizePrimeKlaviyoProductContext(ctx.variantId, ctx.productId, ctx.handle || handle);
        setTimeout(function () {
          openSnizeKlaviyoBisWithRetries(SNIZE_KLAVIYO_BIS_FORM_ID, null, done);
          scheduleSnizeKlaviyoZIndexFix();
        }, 80);
      }
      if (!handle) {
        finish(context, null);
        return;
      }
      fetchSnizeQuickViewProduct(handle, function (product) {
        if (!product) {
          finish(snizeIsNumericShopifyId(context.variantId) ? context : null, null);
          return;
        }
        var vid = snizeResolveVariantFromProduct(product, context.variantId);
        finish(
          vid
            ? {
                variantId: vid,
                productId: String(product.id),
                handle: handle
              }
            : null,
          product
        );
      });
    }


    function snizeIsElementInKlaviyoForm(el) {
      if (!el || !el.closest) return false;
      return !!el.closest(
        'motion.form-component, [data-testid="klaviyo-form"], div[class*="kl-private"], div[role="dialog"][class*="kl"], iframe[src*="klaviyo"]'
      );
    }

    function snizeFindKlaviyoFormEmail() {
      var selectors =
        'input[type="email"], input[name="email"], input[autocomplete="email"], input[placeholder*="email"], input[placeholder*="Email"]';
      var inputs = document.querySelectorAll(selectors);
      for (var i = inputs.length - 1; i >= 0; i--) {
        var inp = inputs[i];
        if (!snizeIsElementInKlaviyoForm(inp)) continue;
        var value = String(inp.value || '').trim();
        if (value) return value;
      }
      return '';
    }

    function snizeIsKlaviyoBisSubmitControl(el) {
      if (!el) return false;
      if (el.type === 'submit') return true;
      var txt = String(el.textContent || el.value || el.getAttribute('aria-label') || '').trim().toLowerCase();
      return (
        txt.indexOf('notify') !== -1 ||
        txt.indexOf('submit') !== -1 ||
        txt.indexOf('sign up') !== -1 ||
        txt.indexOf('send') !== -1 ||
        txt.indexOf('subscribe') !== -1
      );
    }

    function snizeSubmitKlaviyoBisFromCapture(email, done) {
      if (!snizeKlaviyoPendingBis || !email) {
        if (done) done(false);
        return;
      }
      subscribeSnizeKlaviyoBackInStock(
        email,
        snizeKlaviyoPendingBis.variantId,
        snizeKlaviyoPendingBis.productId,
        function (ok) {
          if (ok) {
            clearSnizeKlaviyoBisPendingContext();
            setTimeout(snizeRestoreKlaviyoProductUrl, 400);
          }
          if (done) done(ok);
        }
      );
    }

    function ensureSnizeKlaviyoBisSubmitCapture() {
      if (window.__snizeKlaviyoBisSubmitCapture) return;
      window.__snizeKlaviyoBisSubmitCapture = true;

      function maybeCaptureKlaviyoBisSubmit(ev) {
        if (!snizeKlaviyoPendingBis) return;
        if (Date.now() - snizeKlaviyoPendingBis.ts > 15 * 60 * 1000) {
          clearSnizeKlaviyoBisPendingContext();
          snizeRestoreKlaviyoProductUrl();
          return;
        }
        var target = ev.target;
        var control =
          target && target.closest
            ? target.closest('button, [role="button"], input[type="submit"]')
            : null;
        if (!control || !snizeIsElementInKlaviyoForm(control)) return;
        if (!snizeIsKlaviyoBisSubmitControl(control)) return;
        var email = snizeFindKlaviyoFormEmail();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
        ev.preventDefault();
        ev.stopPropagation();
        if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
        snizeSubmitKlaviyoBisFromCapture(email);
      }

      document.addEventListener('click', maybeCaptureKlaviyoBisSubmit, true);
      document.addEventListener(
        'submit',
        function (ev) {
          if (!snizeKlaviyoPendingBis) return;
          if (!ev.target || !snizeIsElementInKlaviyoForm(ev.target)) return;
          var email = snizeFindKlaviyoFormEmail();
          if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
          ev.preventDefault();
          ev.stopPropagation();
          if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
          snizeSubmitKlaviyoBisFromCapture(email);
        },
        true
      );
    }

    ensureSnizeKlaviyoBisSubmitCapture();

    function ensureSnizeKlaviyoBisSubmitBridge() {
      if (window.__snizeKlaviyoBisBridgeReady) return;
      window.__snizeKlaviyoBisBridgeReady = true;
      window.addEventListener('klaviyoForms', function (ev) {
        var d = ev && ev.detail;
        if (!d) return;
        if (d.companyId && !snizeKlaviyoCompanyIdCache) snizeKlaviyoCompanyIdCache = d.companyId;
        if (d.formId === SNIZE_KLAVIYO_BIS_FORM_ID && (d.type === 'close' || d.type === 'redirectedToUrl')) {
          clearSnizeKlaviyoBisPendingContext();
          snizeRestoreKlaviyoProductUrl();
          return;
        }
        if (d.type !== 'submit') return;
        if (d.formId !== SNIZE_KLAVIYO_BIS_FORM_ID) return;
        if (!snizeKlaviyoPendingBis) return;
        if (Date.now() - snizeKlaviyoPendingBis.ts > 15 * 60 * 1000) {
          clearSnizeKlaviyoBisPendingContext();
          snizeRestoreKlaviyoProductUrl();
          return;
        }
        var meta = d.metaData || {};
        var email = meta.$email || meta.email || '';
        if (!email) return;
        snizeSubmitKlaviyoBisFromCapture(email);
      });
    }

    ensureSnizeKlaviyoBisSubmitBridge();

    function nudgeKlaviyoBisBinding() {
      /* Klaviyo no longer supports refreshForms; avoid console noise from deprecated calls. */
    }

    function tryKlaviyoRefreshAfterSnizeQuickView() {
      /* Intentionally empty — openForm works without refreshForms/_klaviyo.init on QV. */
    }

    function tryOpenKlaviyoBisFormById(formId) {
      if (!formId) return false;
      try {
        if (window._klOnsite && typeof window._klOnsite.openForm === 'function') {
          try {
            window._klOnsite.openForm(formId);
            return true;
          } catch (e0) {
            window._klOnsite.openForm([formId]);
            return true;
          }
        }
      } catch (e) {}
      try {
        if (window._klOnsite && typeof window._klOnsite.push === 'function') {
          window._klOnsite.push(['openForm', formId]);
          return true;
        }
      } catch (e2) {}
      try {
        if (window.klaviyo && typeof window.klaviyo.push === 'function') {
          window.klaviyo.push(['openForm', formId]);
          return true;
        }
      } catch (e3) {}
      try {
        if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
          try {
            window.klaviyo.openForm(formId);
          } catch (inner) {
            window.klaviyo.openForm([formId]);
          }
          return true;
        }
      } catch (e4) {}
      return false;
    }

    function openSnizeKlaviyoBisWithRetries(formId, contextOrDone, maybeDone) {
      var context = null;
      var done = null;
      if (typeof contextOrDone === 'function') {
        done = contextOrDone;
      } else if (contextOrDone && typeof contextOrDone === 'object') {
        context = contextOrDone;
        done = typeof maybeDone === 'function' ? maybeDone : null;
      } else if (typeof maybeDone === 'function') {
        done = maybeDone;
      }

      if (!formId) {
        if (done) done(false);
        return;
      }

      if (context && context.variantId) {
        setSnizeKlaviyoBisPendingContext({
          variantId: context.variantId,
          productId: context.productId || '',
          formId: formId
        });
        snizeInstallKlaviyoVariantShim(context.variantId);
        snizePrimeKlaviyoProductContext(context.variantId, context.productId, context.handle || '');
      }

      if (tryOpenKlaviyoBisFormById(formId)) {
        scheduleSnizeKlaviyoZIndexFix();
        if (done) done(true);
        return;
      }
      var tries = 0;
      var t = setInterval(function () {
        if (tryOpenKlaviyoBisFormById(formId)) {
          clearInterval(t);
          scheduleSnizeKlaviyoZIndexFix();
          if (done) done(true);
          return;
        }
        if (++tries >= 12) {
          clearInterval(t);
          nudgeKlaviyoBisBinding();
          if (tryOpenKlaviyoBisFormById(formId)) {
            scheduleSnizeKlaviyoZIndexFix();
            if (done) done(true);
          } else if (done) done(false);
        }
      }, 200);
    }


    function closeSnizeQuickViewModal() {
      var modal = document.getElementById('snize-modal-product-quick-view');
      if (!modal) return;

      if (
        modal.closest('.mfp-wrap') &&
        window.jQuery &&
        window.jQuery.magnificPopup &&
        typeof window.jQuery.magnificPopup.close === 'function'
      ) {
        try {
          window.jQuery.magnificPopup.close();
          return;
        } catch (eMfp) {}
      }

      function tryClick(el) {
        if (!el) return false;
        try {
          if (typeof el.click === 'function') {
            el.click();
            return true;
          }
        } catch (e) {}
        return false;
      }

      var host = modal.closest('.mfp-container') || modal.closest('.snize-modal') || modal;
      var closeSelectors = [
        '.mfp-close',
        '.snize-modal-close',
        '.snize-quick-view-close',
        'button.snize-close',
        'a.snize-close',
        '.snize-close-button',
        '[data-snize-dismiss]',
        '[data-dismiss="modal"]'
      ];
      for (var s = 0; s < closeSelectors.length; s++) {
        var hit = host.querySelector(closeSelectors[s]);
        if (tryClick(hit)) return;
      }

      var buttons = host.querySelectorAll('button, a[href], [role="button"]');
      for (var b = 0; b < buttons.length; b++) {
        var el = buttons[b];
        var cls = el.className && el.className.toString ? el.className.toString().toLowerCase() : '';
        var al = (el.getAttribute('aria-label') || '').toLowerCase();
        if (cls.indexOf('close') !== -1 || al.indexOf('close') !== -1 || al.indexOf('dismiss') !== -1) {
          if (tryClick(el)) return;
        }
      }

      if (window.jQuery) {
        try {
          var $jq = window.jQuery;
          var $m = $jq(modal);
          if ($m.length && $m.data('magnificPopup') && typeof $m.magnificPopup === 'function') {
            $m.magnificPopup('close');
            return;
          }
          var $wrap = $m.closest('.mfp-wrap');
          if ($wrap.length) {
            var $close = $wrap.find('.mfp-close').first();
            if ($close.length && tryClick($close[0])) return;
          }
        } catch (jqErr) {}
      }

      var escOpts = { key: 'Escape', code: 'Escape', keyCode: 27, which: 27, bubbles: true, cancelable: true };
      try {
        modal.dispatchEvent(new KeyboardEvent('keydown', escOpts));
        document.dispatchEvent(new KeyboardEvent('keydown', escOpts));
        window.dispatchEvent(new KeyboardEvent('keydown', escOpts));
      } catch (ke) {}

      setTimeout(function snizeQvCloseFallback() {
        var m = document.getElementById('snize-modal-product-quick-view');
        if (!m || !m.isConnected) return;
        var disp = window.getComputedStyle(m).display;
        if (disp === 'none') return;
        try {
          var wrap = m.closest('.mfp-wrap');
          if (wrap) wrap.style.setProperty('display', 'none', 'important');
          m.style.setProperty('display', 'none', 'important');
          var bg = document.querySelector('.mfp-bg');
          if (bg) bg.style.setProperty('display', 'none', 'important');
        } catch (fe) {}
      }, 220);
    }

function bumpKlaviyoAboveSnizeQuickView() {
      var z = '2147483646';
      var sel =
        'iframe[src*="klaviyo.com"],iframe[src*="klaviyo"],body>div[id^="__klaviyo"],body>div[id^="klaviyo"],body div[class*="kl-private-position-root"]';
      var list;
      try {
        list = document.querySelectorAll(sel);
      } catch (err) {
        return;
      }
      for (var i = 0; i < list.length; i++) {
        var el = list[i];
        if (!el || !el.style) continue;
        var pos = window.getComputedStyle(el).position;
        if (pos === 'fixed' || pos === 'absolute') {
          el.style.setProperty('z-index', z, 'important');
        }
      }
    }

    function scheduleSnizeKlaviyoZIndexFix() {
      bumpKlaviyoAboveSnizeQuickView();
      if (snizeKlaviyoZFixInterval) clearInterval(snizeKlaviyoZFixInterval);
      var n = 0;
      snizeKlaviyoZFixInterval = setInterval(function () {
        bumpKlaviyoAboveSnizeQuickView();
        if (++n >= 50) {
          clearInterval(snizeKlaviyoZFixInterval);
          snizeKlaviyoZFixInterval = null;
        }
      }, 100);
    }

    function snizeFormVariantId(form) {
      if (!form) return '';
      var vi = form.querySelector('input[name="variant_id"]');
      if (vi && vi.value) return String(vi.value).trim();
      var hi = form.querySelector('input[name="id"]');
      if (hi && hi.value) return String(hi.value).trim();
      var sel = form.querySelector('select[name="id"]');
      if (sel && sel.value) return String(sel.value).trim();
      return '';
    }

    function snizeEnsureKlaviyoProductIdOnForm(modal, form, cb) {
      if (!form) {
        if (cb) cb('');
        return;
      }
      var fromForm = form.querySelector('input[name="product_id"]');
      if (fromForm && fromForm.value) {
        if (cb) cb(String(fromForm.value).trim());
        return;
      }
      var handle = resolveQuickViewHandle(modal);
      if (!handle) {
        if (cb) cb('');
        return;
      }
      fetchSnizeQuickViewProduct(handle, function (product) {
        if (!form.isConnected) {
          if (cb) cb('');
          return;
        }
        if (!product || !product.id) {
          if (cb) cb('');
          return;
        }
        var input = form.querySelector('input[name="product_id"][data-snize-klaviyo-sync="1"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'product_id';
          input.setAttribute('data-snize-klaviyo-sync', '1');
          form.appendChild(input);
        }
        input.value = String(product.id);
        if (cb) cb(String(product.id));
      });
    }

    function wireSnizeKlaviyoBisTrigger(form) {
      var vid = snizeFormVariantId(form);
      if (!vid) return;
      var oosBtn = form.querySelector('#snize-quick-view-out-of-stock');
      if (!oosBtn) return;
      var existing = form.querySelector('.snize-klaviyo-bis-wrap');
      if (existing && existing.getAttribute('data-variant-id') === vid) return;
      if (existing) {
        existing.setAttribute('data-variant-id', vid);
        var prevBtn = existing.querySelector('.snize-klaviyo-bis-anchor');
        if (prevBtn) {
          prevBtn.setAttribute('data-variant-id', vid);
          var pidInputU = form.querySelector('input[name="product_id"]');
          var pidU = pidInputU && pidInputU.value ? String(pidInputU.value).trim() : '';
          if (pidU) prevBtn.setAttribute('data-product-id', pidU);
          else prevBtn.removeAttribute('data-product-id');
          return;
        }
        existing.remove();
      }

      oosBtn.classList.add('snize-klaviyo-bis-replaced');

      var wrap = document.createElement('div');
      wrap.className = 'snize-klaviyo-bis-wrap';
      wrap.setAttribute('data-variant-id', vid);

      var pidInput = form.querySelector('input[name="product_id"]');
      var pid = pidInput && pidInput.value ? String(pidInput.value).trim() : '';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'button snize-button snize-klaviyo-bis-anchor';
      btn.textContent = 'Notify me when available';
      btn.setAttribute('data-variant-id', vid);
      if (pid) btn.setAttribute('data-product-id', pid);

      btn.addEventListener(
        'click',
        function (ev) {
          if (!ev.isTrusted) return;
          var modal = document.getElementById('snize-modal-product-quick-view');
          if (!modal || !modal.contains(btn)) return;
          ev.preventDefault();
          if (!SNIZE_KLAVIYO_BIS_FORM_ID) return;
          var ctx = snizeReadKlaviyoBisContextFromForm(form, btn);
          ctx.handle = resolveQuickViewHandle(modal) || lastCardProductHandle || ctx.handle || '';
          if (!ctx.variantId) return;
          snizePrepareKlaviyoBisPageContext({
            variantId: ctx.variantId,
            productId: ctx.productId || '',
            handle: ctx.handle,
            formId: SNIZE_KLAVIYO_BIS_FORM_ID
          });
          // Drop stock UI cache so the next Quick View open re-applies ATC/OOS cleanly.
          modal.removeAttribute('data-snize-qv-stock-applied-vid');
          modal.removeAttribute('data-snize-qv-stock-state');
          modal.removeAttribute('data-snize-qv-stock-pending');
          clearSnizeKlaviyoBisUi(modal);
          closeSnizeQuickViewModal();
          setTimeout(function () {
            snizeOpenKlaviyoBisWithValidatedContext(ctx);
          }, 320);
        },
        false
      );

      wrap.appendChild(btn);
      oosBtn.parentNode.insertBefore(wrap, oosBtn.nextSibling);

      nudgeKlaviyoBisBinding();
    }

    function clearSnizeKlaviyoBisUi(modal) {
      var wraps = modal.querySelectorAll('.snize-klaviyo-bis-wrap');
      for (var w = 0; w < wraps.length; w++) wraps[w].remove();
      var nodes = modal.querySelectorAll('.snize-klaviyo-bis-anchor');
      for (var x = 0; x < nodes.length; x++) {
        if (!nodes[x].closest('.snize-klaviyo-bis-wrap')) nodes[x].remove();
      }
      var oosBtns = modal.querySelectorAll('#snize-quick-view-out-of-stock.snize-klaviyo-bis-replaced');
      for (var b = 0; b < oosBtns.length; b++) {
        oosBtns[b].classList.remove('snize-klaviyo-bis-replaced');
      }
    }

    function wireSnizeKlaviyoBisInModal(modal) {
      var forms = modal.querySelectorAll('form.snize-add-to-cart-form-out-of-stock[action*="/cart/add"]');
      if (!forms.length) {
        clearSnizeKlaviyoBisUi(modal);
        return;
      }
      for (var i = 0; i < forms.length; i++) {
        wireSnizeKlaviyoBisTrigger(forms[i]);
      }
    }

    function syncSnizeQuickViewForKlaviyo() {
      var modal = document.getElementById('snize-modal-product-quick-view');
      if (!modal) return;
      if (modal.getAttribute('data-snize-qv-stock-pending') === '1') return;
      if (modal.getAttribute('data-snize-qv-stock-state') !== 'oos') {
        clearSnizeKlaviyoBisUi(modal);
        return;
      }
      var forms = modal.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        var form = forms[i];
        var vid = snizeFormVariantId(form);
        if (!vid) continue;
        var idField = form.querySelector('input[name="id"]');
        if (!idField) {
          idField = document.createElement('input');
          idField.type = 'hidden';
          idField.name = 'id';
          idField.setAttribute('data-snize-klaviyo-sync', '1');
          form.appendChild(idField);
      }
        idField.value = vid;
      var oosBtn = form.querySelector('#snize-quick-view-out-of-stock');
        if (oosBtn) {
          oosBtn.classList.add('button');
        }
      }
      var primaryForm = forms[0];
      if (!primaryForm) {
        clearSnizeKlaviyoBisUi(modal);
        return;
        }
      snizeEnsureKlaviyoProductIdOnForm(modal, primaryForm, function () {
        wireSnizeKlaviyoBisInModal(modal);
      });
    }

    function scheduleSnizeQuickViewKlaviyoSync() {
      if (klaviyoSnizeTimer) clearTimeout(klaviyoSnizeTimer);
      klaviyoSnizeTimer = setTimeout(function () {
        klaviyoSnizeTimer = null;
        syncSnizeQuickViewForKlaviyo();
      }, 72);
    }

        function productHandleFromHref(href) {
      if (!href || typeof href !== 'string') return '';
      var m = href.match(/\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)/i);
      return m ? decodeURIComponent(m[1]) : '';
    }

    function firstProductLink(scope) {
      if (!scope || !scope.querySelectorAll) return null;
      var links = scope.querySelectorAll('a[href*="/products/"]');
      for (var i = 0; i < links.length; i++) {
        var h = productHandleFromHref(links[i].getAttribute('href'));
        if (h) return links[i];
      }
      return null;
    }

    function handleFromModalData(modal) {
      if (!modal || !modal.querySelector) return '';
      var nodes = modal.querySelectorAll(
        '[data-product-handle],[data-snize-product-handle],[data-product-url]'
      );
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var h =
          el.getAttribute('data-product-handle') ||
          el.getAttribute('data-snize-product-handle');
        if (h) return String(h).trim();
        var u = el.getAttribute('data-product-url');
        h = productHandleFromHref(u);
        if (h) return h;
      }
      return '';
    }

    function resolveQuickViewHandle(modal) {
      var link = firstProductLink(modal);
      if (link) return productHandleFromHref(link.getAttribute('href'));
      var fromData = handleFromModalData(modal);
      if (fromData) return fromData;
      if (lastCardProductHandle) return lastCardProductHandle;
      return '';
    }

    window.snizeResolveQuickViewHandle = resolveQuickViewHandle;

    var snizeQvProductByHandle = Object.create(null);
    var snizeQvImgTimer = null;

    function snizeQuickViewCurrentVariantId(form) {
      if (!form) return '';
      var sel = form.querySelector('select[name="id"]');
      if (sel && sel.value) return String(sel.value).trim();
      var idHidden = form.querySelector('input[name="id"][type="hidden"]');
      if (idHidden && idHidden.value) return String(idHidden.value).trim();
      var vidInput = form.querySelector('input[name="variant_id"]');
      if (vidInput && vidInput.value) return String(vidInput.value).trim();
      return '';
    }

    function snizeQuickViewNormalizeImgUrl(u) {
      if (!u) return '';
      var s = String(u).trim();
      if (s.indexOf('//') === 0) s = 'https:' + s;
      return s;
    }

    function snizeQuickViewTryActivateVariantInGallery(wrap, vid) {
      if (!wrap || !vid) return false;
      var idStr = String(vid);
      var attrs = ['data-variant-id', 'data-snize-variant-id', 'data-variant', 'data-snize-variant'];
      for (var a = 0; a < attrs.length; a++) {
        var attr = attrs[a];
        try {
          var nodes = wrap.querySelectorAll('[' + attr + ']');
          for (var i = 0; i < nodes.length; i++) {
            var el = nodes[i];
            var val = el.getAttribute(attr);
            if (!val || String(val).trim() !== idStr) continue;
            var clickTarget = el.querySelector('a,button,[role="button"]') || el;
            if (clickTarget && typeof clickTarget.click === 'function') {
              clickTarget.click();
              return true;
            }
          }
        } catch (e) {}
      }
      var links = wrap.querySelectorAll('a[href*="variant="]');
      for (var j = 0; j < links.length; j++) {
        var href = links[j].getAttribute('href') || '';
        if (href.indexOf('variant=' + idStr) !== -1 || href.indexOf('variant%3D' + idStr) !== -1) {
          links[j].click();
          return true;
        }
      }
      return false;
    }

    function snizeQuickViewPickMainImg(wrap) {
      if (!wrap) return null;
      var byClass =
        wrap.querySelector('.snize-quick-view-main-image img') ||
        wrap.querySelector('.snize-quick-view-image-main img') ||
        wrap.querySelector('.snize-quick-view-image:not(.snize-hidden) img') ||
        wrap.querySelector('.snize-quick-view-image.active img') ||
        wrap.querySelector('.snize-quick-view-image.snize-active img') ||
        wrap.querySelector('.snize-quick-view-image img') ||
        wrap.querySelector('picture img');
      if (byClass) return byClass;
      var imgs = wrap.querySelectorAll('img[src]');
      var best = null;
      var bestArea = 0;
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        if (!img.getAttribute('src')) continue;
        var r = img.getBoundingClientRect();
        var area = r.width * r.height;
        if (area < 25) continue;
        if (area > bestArea) {
          bestArea = area;
          best = img;
        }
      }
      return best || wrap.querySelector('img');
    }

    function snizeQuickViewImageFromSelectOption(form, vid) {
      if (!form || !vid) return '';
      var idStr = String(vid);
      var selects = form.querySelectorAll('select[name="id"], select[name="variant_id"], select.snize-select-variant');
      for (var s = 0; s < selects.length; s++) {
        var sel = selects[s];
        if (!sel) continue;
        var opt = null;
        for (var o = 0; o < sel.options.length; o++) {
          if (String(sel.options[o].value) === idStr) {
            opt = sel.options[o];
            break;
          }
        }
        if (!opt) continue;
        return (
          opt.getAttribute('data-featured-image') ||
          opt.getAttribute('data-variant-image') ||
          opt.getAttribute('data-image') ||
          opt.getAttribute('data-img-url') ||
          opt.getAttribute('data-image-url') ||
          (opt.dataset && (opt.dataset.featuredImage || opt.dataset.variantImage)) ||
          ''
        );
      }
      return '';
    }

    function snizeQuickViewImageUrlForVariantEntry(v, product) {
      if (!v) return '';
      var fi = v.featured_image;
      if (fi) {
        if (typeof fi === 'string') return snizeQuickViewNormalizeImgUrl(fi);
        if (fi.src) return snizeQuickViewNormalizeImgUrl(fi.src);
      }
      var fm = v.featured_media;
      if (fm) {
        if (fm.preview_image && fm.preview_image.src) return snizeQuickViewNormalizeImgUrl(fm.preview_image.src);
        if (fm.src) return snizeQuickViewNormalizeImgUrl(fm.src);
        if (fm.image && fm.image.src) return snizeQuickViewNormalizeImgUrl(fm.image.src);
      }
      if (v.image_id != null && product && product.images && product.images.length) {
        var iid = String(v.image_id);
        var media = product.media;
        if (media && media.length) {
          for (var m = 0; m < media.length; m++) {
            var med = media[m];
            if (!med) continue;
            if (String(med.id) !== iid && String(med.image_id) !== iid) continue;
            if (med.src) return snizeQuickViewNormalizeImgUrl(med.src);
            if (med.preview_image && med.preview_image.src) return snizeQuickViewNormalizeImgUrl(med.preview_image.src);
          }
        }
      }
      return '';
    }

    function snizeQuickViewVariantImageUrl(product, variantId) {
      if (!product || !product.variants || !variantId) return '';
      var idStr = String(variantId);
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) !== idStr) continue;
        var u = snizeQuickViewImageUrlForVariantEntry(product.variants[i], product);
        if (u) return u;
        break;
      }
      if (product.featured_image) {
        if (typeof product.featured_image === 'string') return snizeQuickViewNormalizeImgUrl(product.featured_image);
        if (product.featured_image.src) return snizeQuickViewNormalizeImgUrl(product.featured_image.src);
      }
      if (product.images && product.images[0]) {
        var im0 = product.images[0];
        return snizeQuickViewNormalizeImgUrl(typeof im0 === 'string' ? im0 : im0 && im0.src ? im0.src : '');
      }
      return '';
    }

    function snizeQuickViewSetMainImageSrc(mainImg, url) {
      if (!mainImg || !url) return;
      var abs = snizeQuickViewNormalizeImgUrl(url);
      try {
        var cur = snizeQuickViewNormalizeImgUrl(mainImg.currentSrc || mainImg.src || '');
        if (cur && cur.split('?')[0] === abs.split('?')[0]) return;
      } catch (e0) {}
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = abs;
      var pic = mainImg.closest('picture');
      if (pic) {
        var sources = pic.querySelectorAll('source');
        for (var si = 0; si < sources.length; si++) sources[si].remove();
      }
    }


    function snizeQuickViewImageBasename(url) {
      if (!url) return '';
      var clean = String(url).split('#')[0].split('?')[0];
      var last = clean.substring(clean.lastIndexOf('/') + 1).toLowerCase();
      if (!last) return '';
      var dot = last.lastIndexOf('.');
      var ext = dot >= 0 ? last.slice(dot) : '';
      var name = dot >= 0 ? last.slice(0, dot) : last;

      name = name.replace(
        /_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)$/i,
        ''
      );
      return name + ext;
    }


    function snizeQuickViewVariantImageBases(v) {
      var bases = [];
      if (!v) return bases;
      function add(u) {
        var b = snizeQuickViewImageBasename(u);
        if (b) bases.push(b);
      }
      if (v.featured_image) {
        add(typeof v.featured_image === 'string' ? v.featured_image : v.featured_image.src);
      }
      if (v.featured_media) {
        var fm = v.featured_media;
        add(fm.src);
        if (fm.preview_image) add(fm.preview_image.src);
        if (fm.image) add(fm.image.src);
      }
      return bases;
    }


    function snizeQuickViewBuildVariantMediaMap(product) {
      var variantBases = Object.create(null);
      var claimedBases = Object.create(null);
      if (!product || !product.variants) return { variantBases: variantBases, claimedBases: claimedBases };

      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var bs = snizeQuickViewVariantImageBases(v);
        var set = Object.create(null);
        for (var j = 0; j < bs.length; j++) {
          set[bs[j]] = true;
          claimedBases[bs[j]] = true;
        }
        variantBases[String(v.id)] = set;
      }
      return { variantBases: variantBases, claimedBases: claimedBases };
    }


    function snizeQuickViewMediaSlot(img, wrap) {
      if (!img) return null;
      var slot =
        img.closest('[data-snize-media-slot]') ||
        img.closest('.snize-quick-view-thumbnail') ||
        img.closest('.snize-quick-view-thumbnails a') ||
        img.closest('.snize-quick-view-thumbnails li') ||
        img.closest('.snize-quick-view-image') ||
        img.closest('.snize-quick-view-image-item') ||
        img.closest('li') ||
        img.parentElement;
      if (!slot || slot === wrap) return null;
      return slot;
    }


    function snizeQuickViewBasesFromImg(img) {
      if (!img) return [];
      var seen = Object.create(null);
      function add(u) {
        var b = snizeQuickViewImageBasename(u);
        if (b) seen[b] = true;
      }
      try {
        add(img.src);
        if (img.currentSrc && img.currentSrc !== img.src) add(img.currentSrc);
      } catch (e) {}
      add(img.getAttribute('data-src'));
      var ss = img.getAttribute('srcset') || img.getAttribute('data-srcset');
      if (ss) {
        var parts = ss.split(',');
        for (var p = 0; p < parts.length; p++) {
          var piece = parts[p].trim().split(/\s+/)[0];
          if (piece) add(piece);
        }
      }
      return Object.keys(seen);
    }


    function snizeQuickViewResetMediaFilter(modal) {
      if (!modal) return;
      var nodes = modal.querySelectorAll('[data-snize-qv-media-hidden="1"]');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.hasAttribute('data-snize-qv-pdp-extra-thumb')) continue;
        if (el.hasAttribute('data-snize-qv-supplement-facts-thumb')) continue;
        el.removeAttribute('data-snize-qv-media-hidden');
        el.style.removeProperty('display');
      }
    }

    function snizeQuickViewCollectMediaRegions(modal) {
      if (!modal) return [];
      var selectors = [
        '.snize-quick-view-image-wrapper',
        '.snize-quick-view-thumbnails',
        '.snize-quick-view-thumbnail',
        '.snize-quick-view-content-left'
      ];
      var found = [];
      for (var i = 0; i < selectors.length; i++) {
        var nodes = modal.querySelectorAll(selectors[i]);
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (!n || found.indexOf(n) !== -1) continue;
          found.push(n);
        }
      }
      return found;
    }

    function snizeQuickViewMarkThumbsReady(modal) {
      if (!modal) return;
      var strips = modal.querySelectorAll('.snize-quick-view-thumbnails');
      for (var i = 0; i < strips.length; i++) {
        strips[i].setAttribute('data-snize-qv-ready', '1');
      }
    }

    function snizeQuickViewFilterMediaForVariant(modal, product, vid, mainImg) {
      if (!modal || !product || !vid) {
        snizeQuickViewMarkThumbsReady(modal);
        return;
      }
      snizeQuickViewResetMediaFilter(modal);

      var map = snizeQuickViewBuildVariantMediaMap(product);
      var claimed = map.claimedBases;
      var claimedKeys = Object.keys(claimed);
      if (!claimedKeys.length) {
        snizeQuickViewMarkThumbsReady(modal);
        return;
      }

      var allowed = map.variantBases[String(vid)] || Object.create(null);
      var wrap = modal.querySelector('.snize-quick-view-image-wrapper');
      var main = mainImg || (wrap ? snizeQuickViewPickMainImg(wrap) : null);

      var regions = snizeQuickViewCollectMediaRegions(modal);
      var processed = [];
      for (var r = 0; r < regions.length; r++) {
        var region = regions[r];
        var imgs = region.querySelectorAll('img');
        for (var i = 0; i < imgs.length; i++) {
          var img = imgs[i];
          if (processed.indexOf(img) !== -1) continue;
          processed.push(img);
          if (img === main) continue;

          var bases = snizeQuickViewBasesFromImg(img);
          if (!bases.length) continue;
          try {
            img.setAttribute('data-snize-qv-base', bases.join(','));
          } catch (eDbg) {}

          var isClaimedElsewhere = false;
          var matchesAllowed = false;
          for (var b = 0; b < bases.length; b++) {
            var base = bases[b];
            if (allowed[base]) {
              matchesAllowed = true;
              break;
            }
            if (claimed[base]) isClaimedElsewhere = true;
          }
          if (matchesAllowed || !isClaimedElsewhere) continue;

          var slot = snizeQuickViewMediaSlot(img, region) || snizeQuickViewMediaSlot(img, modal);
          if (!slot || slot === region || slot === modal) continue;
          if (slot.hasAttribute('data-snize-qv-pdp-extra-thumb')) continue;
          if (slot.hasAttribute('data-snize-qv-supplement-facts-thumb')) continue;
          if (main && slot.contains(main)) continue;

          slot.setAttribute('data-snize-qv-media-hidden', '1');
          slot.style.setProperty('display', 'none', 'important');
        }
      }
      snizeQuickViewMarkThumbsReady(modal);
    }

    window.__snizeQuickViewMediaDebug = function () {
      var modal = document.getElementById('snize-modal-product-quick-view');
      if (!modal) return console.warn('snize: quick view modal not open');
      var form = modal.querySelector('form[action*="/cart/add"]');
      var vid = snizeQuickViewCurrentVariantId(form);
      var handle = resolveQuickViewHandle(modal);
      var product = handle ? snizeQvProductByHandle[handle] : null;
      console.group('snize quick view media debug');
      console.log('handle:', handle, '| variant_id:', vid);
      if (!product) {
        console.warn('product json not cached yet — open the modal and try again in ~1s');
        console.groupEnd();
        return;
      }
      var map = snizeQuickViewBuildVariantMediaMap(product);
      console.log('claimed bases:', Object.keys(map.claimedBases));
      console.log('variant bases:', map.variantBases);
      console.log('allowed for selected:', Object.keys(map.variantBases[String(vid)] || {}));
      var regions = snizeQuickViewCollectMediaRegions(modal);
      console.log('media regions:', regions);
      var seen = [];
      regions.forEach(function (region) {
        region.querySelectorAll('img').forEach(function (img) {
          if (seen.indexOf(img) !== -1) return;
          seen.push(img);
          console.log(
            'thumb base:',
            snizeQuickViewBasesFromImg(img),
            '| hidden:',
            (img.closest('[data-snize-qv-media-hidden="1"]') ? 'yes' : 'no'),
            img
          );
        });
      });
      console.groupEnd();
    };

    function fetchSnizeQuickViewProduct(handle, cb) {
      if (!handle) {
        cb(null);
        return;
      }
      if (snizeQvProductByHandle[handle] !== undefined) {
        cb(snizeQvProductByHandle[handle]);
        return;
      }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('snize qv product');
          return r.json();
        })
        .then(function (p) {
          snizeQvProductByHandle[handle] = p;
          cb(p);
        })
        .catch(function () {
          cb(null);
        });
    }

    function snizeQuickViewApplyVariantImage(modal) {
      if (!modal) return;
      var form = modal.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var vid = snizeQuickViewCurrentVariantId(form);
      if (!vid) return;
      var wrap = modal.querySelector('.snize-quick-view-image-wrapper');
      if (!wrap) return;

      snizeQuickViewTryActivateVariantInGallery(wrap, vid);

      var mainImg = snizeQuickViewPickMainImg(wrap);
      if (!mainImg) return;

      var appliedVid = modal.getAttribute('data-snize-qv-applied-vid') || '';
      var heroSwapNeeded = appliedVid !== String(vid);

      var fromOpt = snizeQuickViewImageFromSelectOption(form, vid);
      if (heroSwapNeeded && fromOpt) {
        snizeQuickViewSetMainImageSrc(mainImg, fromOpt);
        modal.setAttribute('data-snize-qv-applied-vid', String(vid));
      }

      var handle = resolveQuickViewHandle(modal);
      if (!handle) return;
      fetchSnizeQuickViewProduct(handle, function (product) {
        var modalLive = document.getElementById('snize-modal-product-quick-view');
        var wrapLive = modalLive && modalLive.querySelector('.snize-quick-view-image-wrapper');
        if (!wrapLive) return;
        var mainImgLive = snizeQuickViewPickMainImg(wrapLive);
        if (!mainImgLive || !mainImgLive.isConnected) return;
        var vidLive = snizeQuickViewCurrentVariantId(modalLive.querySelector('form[action*="/cart/add"]'));
        if (vidLive !== vid) return;

        var appliedVidLive = modalLive.getAttribute('data-snize-qv-applied-vid') || '';
        if (!fromOpt && appliedVidLive !== String(vidLive)) {
          var url = snizeQuickViewVariantImageUrl(product, vid);
          if (url) {
            snizeQuickViewSetMainImageSrc(mainImgLive, url);
            modalLive.setAttribute('data-snize-qv-applied-vid', String(vidLive));
          }
        }
        snizeQuickViewFilterMediaForVariant(modalLive, product, vidLive, mainImgLive);
        ensureSnizeQuickViewAttributeUnderTitle(modalLive);
        ensureSnizeQuickViewShowMoreAfterDescription(modalLive);
        ensureSnizeQuickViewPriceAfterVariant(modalLive);
        ensureSnizeQuickViewFreeShipping(modalLive);
        ensureSnizeQuickViewQtyRow(modalLive);
      });
    }


    var SNIZE_QV_FREE_SHIPPING_SVG =
      '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<path d="M1 5.16667V16.1667C1 16.5704 1.24274 16.9345 1.61538 17.0897L11 21M1 5.16667L10.2308 1.32051C10.7231 1.11538 11.2769 1.11538 11.7692 1.32051L16 3.08333M1 5.16667L6 7.25M11 9.33333V21M11 9.33333L21 5.16667M11 9.33333L6 7.25M11 21L20.3846 17.0897C20.7573 16.9345 21 16.5704 21 16.1667V5.16667M21 5.16667L16 3.08333M6 7.25L16 3.08333" ' +
      'stroke="#21232D" stroke-width="1.5" stroke-linejoin="round"></path>' +
      '</svg>';



    function ensureSnizeQuickViewQtyRow(modal) {
      if (!modal) return;
      var forms = modal.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        var form = forms[i];

        var existing = form.querySelector('[data-snize-qv-qty-row]');
        var qty = form.querySelector('.snize-quick-view-add-to-cart-quantity');
        var atcWrap = form.querySelector('.snize-quick-view-add-to-cart-wrapper');
        if (!qty || !atcWrap) continue;

        var alreadyWrapped =
          existing && existing.contains(qty) && existing.contains(atcWrap);

        if (!alreadyWrapped) {

          if (atcWrap.contains(qty)) {
            atcWrap.parentNode.insertBefore(qty, atcWrap);
          }
          if (qty.contains(atcWrap)) {
            qty.parentNode.insertBefore(atcWrap, qty.nextSibling);
          }

          var row = existing;
          if (!row) {
            row = document.createElement('div');
            row.className = 'snize-qv-qty-row';
            row.setAttribute('data-snize-qv-qty-row', '1');
            qty.parentNode.insertBefore(row, qty);
          }
          row.appendChild(qty);
          row.appendChild(atcWrap);
        }
      }
    }

    function ensureSnizeQuickViewAttributeUnderTitle(modal) {
      if (!modal) return;
      var title = modal.querySelector('.snize-quick-view-title');
      if (!title || !title.parentNode) return;
      var attrs = modal.querySelectorAll('.snize-quick-view-attribute');
      var insertAfter = title;
      for (var i = 0; i < attrs.length; i++) {
        var el = attrs[i];
        if (el.previousElementSibling === insertAfter && el.parentNode === title.parentNode) {
          insertAfter = el;
          continue;
        }
        title.parentNode.insertBefore(el, insertAfter.nextSibling);
        insertAfter = el;
      }
    }

    function ensureSnizeQuickViewPriceAfterVariant(modal) {
      if (!modal) return;
      var price = modal.querySelector('.snize-quick-view-price-wrapper');
      if (!price || !price.parentNode) return;
      var variant =
        modal.querySelector('.snize-size-select-box') ||
        modal.querySelector('.snize-product-swatches');
      if (!variant || !variant.parentNode) return;
      if (variant.parentNode !== price.parentNode) {
        variant.parentNode.insertBefore(price, variant.nextSibling);
        return;
      }
      if (price.previousElementSibling === variant) return;
      variant.parentNode.insertBefore(price, variant.nextSibling);
    }

    function ensureSnizeQuickViewShowMoreAfterDescription(modal) {
      if (!modal) return;
      var desc =
        modal.querySelector('.snize-quick-view-description--rte') ||
        modal.querySelector('.snize-quick-view-description');
      if (!desc || !desc.parentNode) return;
      var showMores = modal.querySelectorAll('.snize-quick-view-show-more');
      var insertAfter = desc;
      for (var i = 0; i < showMores.length; i++) {
        var sm = showMores[i];
        if (
          sm.previousElementSibling === insertAfter &&
          sm.parentNode === desc.parentNode
        ) {
          insertAfter = sm;
          continue;
        }
        desc.parentNode.insertBefore(sm, insertAfter.nextSibling);
        insertAfter = sm;
      }
      if (typeof window.snizeEnsureQvMetaRowShell === 'function') {
        window.snizeEnsureQvMetaRowShell(modal);
      }
      if (typeof window.snizeQvTryMountReviews === 'function') {
        window.snizeQvTryMountReviews(modal);
      }
      if (typeof window.snizeScheduleQuickViewShare === 'function') {
        window.snizeScheduleQuickViewShare();
      }
    }

    function ensureSnizeQuickViewFreeShipping(modal) {
      if (!modal) return;
      if (modal.querySelector('[data-snize-qv-free-shipping]')) return;

      var anchor =
        modal.querySelector('.snize-quick-view-price-wrapper') ||
        modal.querySelector('.snize-size-select-box') ||
        modal.querySelector('.snize-product-swatches');
      if (!anchor || !anchor.parentNode) return;

      var badge = document.createElement('div');
      badge.className = 'snize-qv-free-shipping';
      badge.setAttribute('data-snize-qv-free-shipping', '1');
      badge.innerHTML =
        SNIZE_QV_FREE_SHIPPING_SVG + '<span>FREE SHIPPING (1-4 Business Days)</span>';
      anchor.parentNode.insertBefore(badge, anchor.nextSibling);
    }

    function scheduleSnizeQuickViewVariantImage() {
      var modal = document.getElementById('snize-modal-product-quick-view');
      if (!modal) return;

      if (snizeQvImgTimer) clearTimeout(snizeQvImgTimer);
      snizeQvImgTimer = setTimeout(function () {
        snizeQvImgTimer = null;
        var delays = [0, 140, 320, 700, 1100, 1600];
        for (var d = 0; d < delays.length; d++) {
          (function (ms) {
            setTimeout(function () {
              var m = document.getElementById('snize-modal-product-quick-view');
              if (m) snizeQuickViewApplyVariantImage(m);
            }, ms);
          })(delays[d]);
        }
      }, 60);
    }

    function descriptionLooksPlain(desc) {
      if (!desc) return true;
      var html = desc.innerHTML || '';
      if (/<\s*(p|ul|ol|li|table|h[1-6]|blockquote)\b/i.test(html)) return false;
      if (/class=["'][^"']*rte/i.test(html) && /<\s*div\b/i.test(html)) return false;
      return true;
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function hasRealMarkup(s) {
      return /<\s*(p|ul|ol|li|table|h[1-6]|div\b[^>]*\brte\b)/i.test(s || '');
    }

    function htmlFromPlainBulletText(text) {
      var t = String(text || '')
        .replace(/\u00a0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      if (!t) return '';
      var hasBullet = /[\u2022\u00B7\u25AA\u2023·▪]|\s[•]\s/.test(t) || t.indexOf('•') !== -1;
      if (!hasBullet) {
        return '<p>' + escapeHtml(t) + '</p>';
      }
      var parts = t.split(/\s*[•\u2022\u00B7\u25AA\u2023·▪]\s*/i).map(function (x) {
        return x.replace(/\s+/g, ' ').trim();
      }).filter(Boolean);
      if (!parts.length) return '';
      if (parts.length === 1) return '<p>' + escapeHtml(parts[0]) + '</p>';
      var intro = '<p>' + escapeHtml(parts[0]) + '</p>';
      var lis = parts
        .slice(1)
        .map(function (line) {
          return '<li>' + escapeHtml(line) + '</li>';
        })
        .join('');
      return intro + '<ul>' + lis + '</ul>';
    }

    function pickQuickViewRteHtml(snippetText, apiHtml) {
      var api = (apiHtml != null ? String(apiHtml) : '').trim();
      var snip = (snippetText != null ? String(snippetText) : '').trim();
      if (hasRealMarkup(api)) return api;
      if (snip && /[\u2022\u00B7\u25AA\u2023·▪•]/.test(snip)) return htmlFromPlainBulletText(snip);
      if (api && !hasRealMarkup(api)) return htmlFromPlainBulletText(api.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim());
      return '';
    }

    function applyQuickViewHtml(modal, desc, handle, html) {
      if (!html || !desc || !desc.isConnected) return;
      if (handle != null && handle !== '') {
        var resolved = modal ? resolveQuickViewHandle(modal) : '';
        if (resolved && resolved !== handle) return;
        if (!resolved && lastCardProductHandle && lastCardProductHandle !== handle) return;
        desc.setAttribute('data-snize-html-handle', handle);
      }
      desc.classList.add('rte', 'snize-quick-view-description--rte');
      desc.innerHTML = html;
    }

    function enhanceSnizeQuickViewDescription() {
      var descNodes = document.querySelectorAll('.snize-quick-view-description');
      if (!descNodes.length) return;

      for (var n = 0; n < descNodes.length; n++) {
        (function (desc) {
          if (!desc || !desc.isConnected) return;
          var snippet = (desc.textContent || '').trim();

          var modal =
            desc.closest('#snize-modal-product-quick-view') ||
            document.getElementById('snize-modal-product-quick-view');

          var handle = '';
          if (modal) handle = resolveQuickViewHandle(modal);
          if (!handle) handle = lastCardProductHandle;

          var instant = pickQuickViewRteHtml(snippet, '');
          if (instant && descriptionLooksPlain(desc)) {
            applyQuickViewHtml(modal, desc, null, instant);
          }

          if (!handle) return;

          fetchProductBodyHtml(handle, function (html) {
            var descLive = document.querySelector('.snize-quick-view-description');
            if (!descLive || !descLive.isConnected) return;
            var modalLive =
              descLive.closest('#snize-modal-product-quick-view') ||
              document.getElementById('snize-modal-product-quick-view');
            var snip = (descLive.textContent || '').trim();
            var out = pickQuickViewRteHtml(snip, html);
            if (!out) return;
            applyQuickViewHtml(modalLive, descLive, handle, out);
          });
        })(descNodes[n]);
      }
    }

    function extractSectionInnerHtml(sectionJson, sectionId) {
      if (!sectionJson || typeof sectionJson !== 'object') return '';
      var raw = sectionJson[sectionId];
      if (!raw || typeof raw !== 'string') {
        for (var key in sectionJson) {
          if (!Object.prototype.hasOwnProperty.call(sectionJson, key)) continue;
          if (key === sectionId || key.indexOf(sectionId) !== -1) {
            raw = sectionJson[key];
            break;
          }
        }
      }
      if (!raw || typeof raw !== 'string') return '';
      var wrap = document.createElement('div');
      wrap.innerHTML = raw;
      var root = wrap.querySelector('[data-snize-qv-root]');
      if (root) return root.innerHTML;
      return raw;
    }

    function fetchProductBodyHtml(handle, cb) {
      if (!handle) {
        cb('');
        return;
      }
      if (descCache[handle] !== undefined) {
        cb(descCache[handle]);
        return;
      }
      if (descPending[handle]) {
        descPending[handle].push(cb);
        return;
      }
      descPending[handle] = [cb];

      function finish(html) {
        var h = html != null ? String(html) : '';
        descCache[handle] = h;
        var list = descPending[handle];
        delete descPending[handle];
        for (var i = 0; i < list.length; i++) list[i](h);
      }

      function fetchJsonBodyHtml() {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var url = root + 'products/' + encodeURIComponent(handle) + '.js';
        fetch(url, { credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) throw new Error('snize product fetch');
            return r.json();
          })
          .then(function (p) {
            finish(p && p.body_html ? String(p.body_html) : '');
          })
          .catch(function () {
            finish('');
          });
      }

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var sectionUrl =
        root +
        'products/' +
        encodeURIComponent(handle) +
        '?sections=' +
        encodeURIComponent(SNIZE_QV_SECTION_ID) +
        '&_snize_qv=' +
        String(Date.now());

      fetch(sectionUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('snize section fetch');
          return r.json();
        })
        .then(function (json) {
          var inner = extractSectionInnerHtml(json, SNIZE_QV_SECTION_ID);
          if (inner && inner.replace(/\s/g, '').length) {
            finish(inner);
          } else {
            fetchJsonBodyHtml();
          }
        })
        .catch(function () {
          fetchJsonBodyHtml();
        });
    }

    function runSnizeQuickViewHtmlDescription() {
      ensureQuickViewModalObserver();
      enhanceSnizeQuickViewDescription();
    }

    function scheduleSnizeQuickViewHtmlDescription() {
      if (descScheduleTimer) clearTimeout(descScheduleTimer);
      descScheduleTimer = setTimeout(function () {
        descScheduleTimer = null;
        runSnizeQuickViewHtmlDescription();
      }, 150);
    }

    function prewarmSnizeQuickViewProduct(handle) {
      if (!handle) return;
      fetchSnizeQuickViewProduct(handle, function () {});
    }

    document.addEventListener(
      'click',
      function (ev) {
        var t = ev.target;
        if (!t || !t.closest) return;
        var card = t.closest('li.snize-product') || t.closest('.snize-product');
        if (!card) return;
        var link = firstProductLink(card);
        var h = link ? productHandleFromHref(link.getAttribute('href')) : '';
        if (h) {
          lastCardProductHandle = h;
          prewarmSnizeQuickViewProduct(h);
          setTimeout(scheduleSnizeQuickViewVariantImage, 0);
          setTimeout(scheduleSnizeQuickViewVariantImage, 180);
        }
      },
      true
    );

    function snizeQvHoverPrewarm(ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var card = t.closest('li.snize-product') || t.closest('.snize-product');
      if (!card) return;
      var link = firstProductLink(card);
      var h = link ? productHandleFromHref(link.getAttribute('href')) : '';
      if (h) prewarmSnizeQuickViewProduct(h);
    }
    document.addEventListener('mouseover', snizeQvHoverPrewarm, true);
    document.addEventListener('focusin', snizeQvHoverPrewarm, true);
    document.addEventListener('touchstart', snizeQvHoverPrewarm, { capture: true, passive: true });

    document.addEventListener('change', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var modal = document.getElementById('snize-modal-product-quick-view');
      if (!modal || !modal.contains(t)) return;
      var tag = (t.nodeName || '').toUpperCase();
      if (
        tag === 'SELECT' ||
        (tag === 'INPUT' && (t.name === 'variant_id' || t.name === 'id'))
      ) {
        scheduleSnizeQuickViewVariantImage();
        if (t.value) modal.setAttribute('data-snize-qv-selected-vid', String(t.value).trim());
        snizeQvOnVariantChange(modal);
      }
    });

    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var modal = document.getElementById('snize-modal-product-quick-view');
      if (!modal || !modal.contains(t)) return;
      if (
        t.closest('.snize-size-select-box') ||
        t.closest('.snize-size') ||
        t.closest('.snize-product-swatches-option') ||
        t.closest('[data-snize-variant]')
      ) {
        scheduleSnizeQuickViewVariantImage();
      } else if (t.getAttribute && t.getAttribute('data-variant-id')) {
        scheduleSnizeQuickViewVariantImage();
      }
    });

    document.addEventListener('DOMContentLoaded', scheduleSnizeQuickViewHtmlDescription);
    window.addEventListener('load', scheduleSnizeQuickViewHtmlDescription);

    var watchedQuickViewModal = null;
    function ensureQuickViewModalObserver() {
      var modal = document.getElementById('snize-modal-product-quick-view');
      if (!modal || watchedQuickViewModal === modal) return;
      watchedQuickViewModal = modal;
      var modalObs = new MutationObserver(function (records) {
        var imageOnly = records.length > 0;
        for (var r = 0; r < records.length; r++) {
          var t = records[r].target;
          if (t && typeof t.closest === 'function' && t.closest('.snize-quick-view-image-wrapper')) continue;
          imageOnly = false;
          break;
        }
        if (!imageOnly) {
          if (klaviyoModalMutTimer) clearTimeout(klaviyoModalMutTimer);
          klaviyoModalMutTimer = null;
        }

        var m = document.getElementById('snize-modal-product-quick-view');
        if (m) {
          snizeQuickViewApplyVariantImage(m);
          ensureSnizeQuickViewAttributeUnderTitle(m);
          ensureSnizeQuickViewShowMoreAfterDescription(m);
          ensureSnizeQuickViewPriceAfterVariant(m);
          ensureSnizeQuickViewFreeShipping(m);
          ensureSnizeQuickViewQtyRow(m);
          scheduleSnizeQvSyncStockState(m);
          if (typeof window.snizeEnsureQvMetaRowShell === 'function') {
            window.snizeEnsureQvMetaRowShell(m);
          }
          if (typeof window.snizeQvTryMountReviews === 'function') {
            window.snizeQvTryMountReviews(m);
          }
          if (typeof window.snizeScheduleQuickViewShare === 'function') {
            window.snizeScheduleQuickViewShare();
          }
        }
        scheduleSnizeQuickViewHtmlDescription();
      });
      modalObs.observe(modal, { childList: true, subtree: true });
      requestAnimationFrame(function () {
        scheduleSnizeQuickViewVariantImage();
        snizeQvSyncStockState(modal);

        ensureSnizeQuickViewAttributeUnderTitle(modal);
        ensureSnizeQuickViewShowMoreAfterDescription(modal);
        ensureSnizeQuickViewPriceAfterVariant(modal);
        ensureSnizeQuickViewFreeShipping(modal);
        ensureSnizeQuickViewQtyRow(modal);
      });


      setTimeout(function () {
        var m = document.getElementById('snize-modal-product-quick-view');
        if (m) snizeQuickViewMarkThumbsReady(m);
      }, 1500);
    }

    function scheduleQuickViewRetries() {
      var delays = [200, 500, 1000, 2000];
      for (var i = 0; i < delays.length; i++) {
        (function (ms) {
          setTimeout(scheduleSnizeQuickViewHtmlDescription, ms);
        })(delays[i]);
      }
    }

    var bootTries = 0;
    var bootInterval = setInterval(function () {
      ensureQuickViewModalObserver();
      scheduleSnizeQuickViewHtmlDescription();
      if (++bootTries >= 48) {
        clearInterval(bootInterval);
      }
    }, 250);

    document.addEventListener('DOMContentLoaded', scheduleQuickViewRetries);
    window.addEventListener('load', scheduleQuickViewRetries);

    function snizeQvLabelFromSizePill(pill) {
      if (!pill) return '';
      var label =
        pill.getAttribute('data-value') ||
        pill.getAttribute('aria-label') ||
        pill.textContent ||
        '';
      label = String(label).trim();
      var parts = label.split(':');
      if (parts.length > 1) label = parts[parts.length - 1].trim();
      return label.toLowerCase();
    }

    function snizeHandleFromCard(card) {
      var link = firstProductLink(card);
      return link ? productHandleFromHref(link.getAttribute('href')) : '';
    }

    function snizeFindViewProductButton(card) {
      if (!card) return null;
      var btns = card.querySelectorAll('.snize-buttons .snize-button, .snize-button');
      var fallback = null;
      for (var i = 0; i < btns.length; i++) {
        var btn = btns[i];
        var label = String(btn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (label.indexOf('quick view') !== -1) continue;
        if (label.indexOf('add to cart') !== -1 || label.indexOf('add to bag') !== -1) continue;
        if (label.indexOf('view product') !== -1 || label.indexOf('notify') !== -1) return btn;
        if (!fallback) fallback = btn;
      }
      return fallback;
    }

    function snizeCardHasActiveVariantPill(card) {
      return !!card.querySelector(
        '.snize-size-select-box .snize-size-active, .snize-size.snize-active, .snize-product-swatches-option.snize-active, .snize-product-swatches-option.active'
      );
    }

    function snizeCardVariantIdFromProduct(card, product) {
      if (!card || !product || !product.variants || !product.variants.length) return '';
      var active = card.querySelector(
        '.snize-size-select-box .snize-size-active, .snize-size.snize-active, .snize-product-swatches-option.snize-active, .snize-product-swatches-option.active'
      );
      if (!active && product.variants.length === 1) return String(product.variants[0].id);
      if (!active) {
        for (var d = 0; d < product.variants.length; d++) {
          if (product.variants[d].available) return String(product.variants[d].id);
        }
        return String(product.variants[0].id);
      }
      var fromAttr =
        active.getAttribute('data-variant-id') ||
        active.getAttribute('data-snize-variant-id') ||
        active.getAttribute('data-variant');
      if (fromAttr) return String(fromAttr).trim();
      var label = snizeQvLabelFromSizePill(active);
      if (!label) return '';
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var fields = [v.title, v.option1, v.option2, v.option3];
        for (var f = 0; f < fields.length; f++) {
          if (!fields[f]) continue;
          if (String(fields[f]).trim().toLowerCase() === label) return String(v.id);
        }
      }
      return '';
    }

    function snizeVariantAvailableById(product, variantId) {
      if (!product || !product.variants || !product.variants.length) return !!product.available;
      if (!variantId) return !!product.available;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(variantId)) return !!product.variants[i].available;
      }
      return !!product.available;
    }

    function snizeCardIsSoldOut(product, card) {
      if (!product) return false;
      if (product.available === false) return true;
      if (!product.variants || !product.variants.length) return product.available === false;

      if (card) {
        if (
          card.classList.contains('snize-sold-out') ||
          card.classList.contains('snize-out-of-stock') ||
          card.querySelector('.snize-sold-out, .snize-out-of-stock, .snize-product-sold-out')
        ) {
          return true;
        }
        var btn = snizeFindViewProductButton(card);
        var btnLabel = btn ? String(btn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase() : '';
        var hasAtc = false;
        var allBtns = card.querySelectorAll('.snize-button');
        for (var b = 0; b < allBtns.length; b++) {
          var l = String(allBtns[b].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
          if (l.indexOf('add to cart') !== -1 || l.indexOf('add to bag') !== -1) {
            hasAtc = true;
            break;
          }
        }
        // Searchanise swaps ATC for "View product" when unavailable
        if (!hasAtc && btnLabel.indexOf('view product') !== -1) {
          if (snizeCardHasActiveVariantPill(card)) {
            var activeVidHint = snizeCardVariantIdFromProduct(card, product);
            if (activeVidHint) return !snizeVariantAvailableById(product, activeVidHint);
          }
          if (product.available === false) return true;
          var anyAvail = false;
          for (var a = 0; a < product.variants.length; a++) {
            if (product.variants[a].available) {
              anyAvail = true;
              break;
            }
          }
          if (!anyAvail) return true;
        }
      }

      if (snizeCardHasActiveVariantPill(card)) {
        var activeVid = snizeCardVariantIdFromProduct(card, product);
        return activeVid ? !snizeVariantAvailableById(product, activeVid) : false;
      }

      for (var j = 0; j < product.variants.length; j++) {
        if (product.variants[j].available) return false;
      }
      return true;
    }

    function snizeApplyPlpNotifyButton(btn, product, variantId) {
      if (!btn) return;
      if (!btn.getAttribute('data-snize-vp-original-html')) {
        btn.setAttribute('data-snize-vp-original-html', btn.innerHTML);
        if (btn.tagName === 'A') {
          btn.setAttribute('data-snize-vp-original-href', btn.getAttribute('href') || '');
          btn.removeAttribute('href');
          btn.setAttribute('role', 'button');
        }
      }
      btn.setAttribute('data-snize-plp-notify', '1');
      btn.setAttribute('data-variant-id', variantId ? String(variantId) : '');
      if (product && product.id) btn.setAttribute('data-product-id', String(product.id));
      if (product && product.handle) btn.setAttribute('data-product-handle', String(product.handle));
      while (btn.firstChild) btn.removeChild(btn.firstChild);
      btn.appendChild(document.createTextNode('Notify Me'));
      if (!btn._snizePlpNotifyClick) {
        btn._snizePlpNotifyClick = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
          if (!SNIZE_KLAVIYO_BIS_FORM_ID) return;
          var ctx = {
            variantId: btn.getAttribute('data-variant-id') || '',
            productId: btn.getAttribute('data-product-id') || '',
            handle: btn.getAttribute('data-product-handle') || ''
          };
          if (!ctx.variantId) return;
          snizePrepareKlaviyoBisPageContext({
            variantId: ctx.variantId,
            productId: ctx.productId || '',
            handle: ctx.handle,
            formId: SNIZE_KLAVIYO_BIS_FORM_ID
          });
          snizeOpenKlaviyoBisWithValidatedContext(ctx);
        };
        btn.addEventListener('click', btn._snizePlpNotifyClick, true);
      }
    }

    function snizeRestorePlpViewProductButton(btn) {
      if (!btn || btn.getAttribute('data-snize-plp-notify') !== '1') return;
      var html = btn.getAttribute('data-snize-vp-original-html');
      if (html) btn.innerHTML = html;
      var href = btn.getAttribute('data-snize-vp-original-href');
      if (href && btn.tagName === 'A') btn.setAttribute('href', href);
      if (btn._snizePlpNotifyClick) {
        btn.removeEventListener('click', btn._snizePlpNotifyClick, true);
        btn.removeEventListener('click', btn._snizePlpNotifyClick, false);
        btn._snizePlpNotifyClick = null;
      }
      btn.removeAttribute('data-snize-plp-notify');
      btn.removeAttribute('data-snize-vp-original-html');
      btn.removeAttribute('data-snize-vp-original-href');
      btn.removeAttribute('data-variant-id');
      btn.removeAttribute('data-product-id');
      btn.removeAttribute('data-product-handle');
      btn.removeAttribute('role');
    }

    function snizeSyncPlpViewProductButton(card) {
      if (!card || !card.isConnected) return;
      var btn = snizeFindViewProductButton(card);
      if (!btn) return;
      var handle = snizeHandleFromCard(card);
      if (!handle) return;
      fetchSnizeQuickViewProduct(handle, function (product) {
        if (!card.isConnected) return;
        var btnLive = snizeFindViewProductButton(card);
        if (!btnLive) return;
        if (!product) {
          snizeRestorePlpViewProductButton(btnLive);
          return;
        }
        if (snizeCardIsSoldOut(product, card)) {
          var vid = snizeCardVariantIdFromProduct(card, product);
          snizeApplyPlpNotifyButton(btnLive, product, vid);
        } else {
          snizeRestorePlpViewProductButton(btnLive);
        }
        if (window.__oosBadgeSnize && typeof window.__oosBadgeSnize.injectCard === 'function') {
          window.__oosBadgeSnize.injectCard(card);
        }
        if (window.__pureSurplusSnize && typeof window.__pureSurplusSnize.injectCard === 'function') {
          window.__pureSurplusSnize.injectCard(card);
        }
      });
    }

    var snizePlpNotifyTimer = null;
    function snizePlpNotifyMeEnhanceAll() {
      var cards = document.querySelectorAll(
        '#snize-search-results-grid-mode li.snize-product, #snize-search-results-list-mode li.snize-product, #snize_results li.snize-product'
      );
      for (var i = 0; i < cards.length; i++) snizeSyncPlpViewProductButton(cards[i]);
    }

    function scheduleSnizePlpNotifyMeEnhance() {
      snizePlpNotifyMeEnhanceAll();
      if (snizePlpNotifyTimer) clearTimeout(snizePlpNotifyTimer);
      snizePlpNotifyTimer = setTimeout(function () {
        snizePlpNotifyTimer = null;
        snizePlpNotifyMeEnhanceAll();
      }, 100);
    }

    function scheduleSnizePlpNotifyMeEnhanceBurst() {
      scheduleSnizePlpNotifyMeEnhance();
      [200, 600, 1200, 2500].forEach(function (ms) {
        setTimeout(scheduleSnizePlpNotifyMeEnhance, ms);
      });
    }

    document.addEventListener(
      'click',
      function (ev) {
        var t = ev.target;
        if (!t || !t.closest) return;
        if (t.closest('#snize-modal-product-quick-view')) return;
        var card = t.closest('li.snize-product') || t.closest('.snize-product');
        if (!card || !card.closest('#snize_results')) return;
        if (
          t.closest('.snize-size-select-box') ||
          t.closest('.snize-size') ||
          t.closest('.snize-product-swatches-option')
        ) {
          setTimeout(function () {
            snizeSyncPlpViewProductButton(card);
          }, 0);
          setTimeout(function () {
            snizeSyncPlpViewProductButton(card);
          }, 150);
        }
      },
      true
    );

    document.addEventListener('DOMContentLoaded', scheduleSnizePlpNotifyMeEnhanceBurst);
    window.addEventListener('load', scheduleSnizePlpNotifyMeEnhanceBurst);
    document.addEventListener('Searchanise.Loaded', scheduleSnizePlpNotifyMeEnhanceBurst);
    if (window.__snizePlpReady && typeof window.__snizePlpReady.onReady === 'function') {
      window.__snizePlpReady.onReady(scheduleSnizePlpNotifyMeEnhanceBurst);
    }

        var SNIZE_ATC_ICON_SVG =
      '<svg class="snize-custom-atc-icon" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<path d="M7.16699 10L7.16699 6.66667C7.16699 4.82572 8.65938 3.33333 10.5003 3.33333V3.33333C12.3413 3.33333 13.8337 4.82572 13.8337 6.66667L13.8337 10" stroke="currentColor" stroke-linecap="round"></path>' +
      '<path d="M3.52768 11.1678C3.67276 9.42692 3.74529 8.55647 4.31938 8.02824C4.89347 7.5 5.76693 7.5 7.51386 7.5H13.4861C15.2331 7.5 16.1065 7.5 16.6806 8.02824C17.2547 8.55647 17.3272 9.42692 17.4723 11.1678L17.8195 15.3339C17.904 16.3474 17.9462 16.8542 17.6491 17.1771C17.352 17.5 16.8435 17.5 15.8264 17.5H5.1736C4.15655 17.5 3.64802 17.5 3.35092 17.1771C3.05382 16.8542 3.09605 16.3474 3.18051 15.3339L3.52768 11.1678Z" stroke="currentColor"></path>' +
      '</svg>';

    function snizeIsAddToCartButtonEl(btn) {
      if (!btn) return false;
      if (btn.getAttribute('data-snize-plp-notify') === '1') return false;
      if (!btn.classList || !btn.classList.contains('snize-button')) return false;
      if (!btn.closest('li.snize-product')) return false;
      var label = String(btn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (label.indexOf('quick view') !== -1 || label.indexOf('view product') !== -1) return false;
      if (label.indexOf('notify me') !== -1) return false;
      if (label.indexOf('add to cart') !== -1 || label.indexOf('add to bag') !== -1) return true;
      if (/snize-action-add|add-to-cart|snize-add-to-cart/i.test(btn.className || '')) return true;
      var wrap = btn.closest('.snize-buttons');
      if (wrap) {
        var btns = wrap.querySelectorAll('.snize-button');
        if (btns.length >= 2 && btn !== btns[0]) return true;
      }
      return false;
    }

    function snizeStripForeignAtcIcons(btn) {
      var custom = btn.querySelector('.snize-custom-atc-icon');
      var foreign = btn.querySelectorAll(
        'svg:not(.snize-custom-atc-icon), img, picture, i, .snize-cta-icon, .snize-button-icon, [class*="snize-icon"]'
      );
      for (var i = 0; i < foreign.length; i++) {
        var node = foreign[i];
        if (custom && (node === custom || node.contains(custom))) continue;
        node.remove();
      }
      var spans = btn.querySelectorAll('span');
      for (var j = 0; j < spans.length; j++) {
        var sp = spans[j];
        if (sp.classList.contains('snize-custom-atc-icon') || sp.querySelector('.snize-custom-atc-icon')) continue;
        if (sp.querySelector('svg, img, i, [class*="icon"]')) sp.remove();
      }
    }

    function snizeReplaceAtcButtonIcon(btn) {
      if (!snizeIsAddToCartButtonEl(btn)) return;
      btn.setAttribute('data-snize-atc-icon', '1');
      btn.style.setProperty('background-image', 'none', 'important');
      snizeStripForeignAtcIcons(btn);
      if (!btn.querySelector('.snize-custom-atc-icon')) {
        btn.insertAdjacentHTML('afterbegin', SNIZE_ATC_ICON_SVG);
      }
      snizeStripForeignAtcIcons(btn);
    }

    function snizeReplaceAllPlpAtcIcons() {
      var root = document.getElementById('snize_results');
      if (!root) return;
      var plpBtns = root.querySelectorAll(
        'li.snize-product .snize-buttons .snize-button, li.snize-product .snize-button'
      );
      for (var i = 0; i < plpBtns.length; i++) snizeReplaceAtcButtonIcon(plpBtns[i]);
    }

    var snizeAtcIconTimer = null;
    function scheduleSnizeAtcIconReplace() {
      if (snizeAtcIconTimer) clearTimeout(snizeAtcIconTimer);
      snizeAtcIconTimer = setTimeout(function () {
        snizeAtcIconTimer = null;
        snizeReplaceAllPlpAtcIcons();
      }, 50);
    }

    function scheduleSnizeAtcIconReplaceBurst() {
      scheduleSnizeAtcIconReplace();
      [150, 400, 800, 1500].forEach(function (ms) {
        setTimeout(scheduleSnizeAtcIconReplace, ms);
      });
    }

    document.addEventListener('DOMContentLoaded', scheduleSnizeAtcIconReplaceBurst);
    window.addEventListener('load', scheduleSnizeAtcIconReplaceBurst);
    document.addEventListener('Searchanise.Loaded', scheduleSnizeAtcIconReplaceBurst);

    var snizeRootEl = document.getElementById('snize_results');
    if (snizeRootEl) {
      var snizeObs = new MutationObserver(function () {
        scheduleSnizeQuickViewHtmlDescription();
        scheduleSnizePlpNotifyMeEnhance();
        scheduleSnizeAtcIconReplaceBurst();
      });
      snizeObs.observe(snizeRootEl, { childList: true, subtree: true });
      scheduleSnizePlpNotifyMeEnhance();
      scheduleSnizeAtcIconReplaceBurst();
    }

    var SNIZE_MOBILE_FILTER_CHEVRON_DOWN =
      'M1.5 2L8 8.5L14.5 2';
    var SNIZE_MOBILE_FILTER_CHEVRON_UP =
      'M1.5 8.5L8 2L14.5 8.5';
    var SNIZE_MOBILE_FILTER_CHEVRON_SVG =
      '<svg class="snize-mobile-filter-chevron" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="' + SNIZE_MOBILE_FILTER_CHEVRON_DOWN + '" stroke="#14328c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function snizeNormalizeFilterTitleLabel(el) {
      if (!el) return '';
      var clone = el.cloneNode(true);
      var chevron = clone.querySelector('.snize-mobile-filter-chevron');
      if (chevron) chevron.remove();
      var inlineClose = clone.querySelector('.snize-mobile-filters-inline-close');
      if (inlineClose) inlineClose.remove();
      return String(clone.textContent || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function snizeIsFiltersDialogHeaderTitle(titleEl) {
      if (!titleEl) return false;
      var label = snizeNormalizeFilterTitleLabel(titleEl);
      return (
        label === 'filters' ||
        label === 'filter' ||
        label === 'filter options' ||
        label.indexOf('filters') === 0
      );
    }

    function snizeFindMobileFiltersHeaderHost(dialog) {
      if (!dialog) return null;

      var titles = dialog.querySelectorAll('.snize-product-filters-title');
      for (var i = 0; i < titles.length; i++) {
        if (snizeIsFiltersDialogHeaderTitle(titles[i])) return titles[i];
      }

      var firstBlockTitle = dialog.querySelector(
        '.snize-filters-sidebar > .snize-product-filters-block:first-child .snize-product-filters-title'
      );
      if (firstBlockTitle && snizeIsFiltersDialogHeaderTitle(firstBlockTitle)) return firstBlockTitle;

      var chrome = dialog.querySelectorAll('[class*="title"], [class*="header"], h1, h2, h3, h4');
      for (var c = 0; c < chrome.length; c++) {
        var el = chrome[c];
        if (!el.closest('.snize-product-filters-list')) {
          var text = String(el.textContent || '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();
          if (text === 'filters' || text === 'filter' || text === 'filter options') return el;
        }
      }

      return dialog.querySelector('.snize-product-filters-title[data-snize-filter-header="1"]');
    }

    function snizeWrapMobileFiltersHeaderLabel(headerTitle) {
      if (!headerTitle || headerTitle.querySelector('.snize-mobile-filters-header-label')) return;

      var closeBtn = headerTitle.querySelector('.snize-mobile-filters-inline-close');
      var label = document.createElement('span');
      label.className = 'snize-mobile-filters-header-label';

      var child = headerTitle.firstChild;
      while (child) {
        var next = child.nextSibling;
        if (
          child !== closeBtn &&
          !(child.nodeType === 1 && child.classList && child.classList.contains('snize-mobile-filter-chevron'))
        ) {
          label.appendChild(child);
        }
        child = next;
      }

      if (!label.textContent.replace(/\s+/g, '').length) {
        label.textContent = 'Filters';
      }

      if (closeBtn) headerTitle.insertBefore(label, closeBtn);
      else headerTitle.insertBefore(label, headerTitle.firstChild);
    }

    function snizeStyleMobileFiltersInlineClose(btn) {
      if (!btn) return;
      btn.style.setProperty('display', 'flex', 'important');
      btn.style.setProperty('visibility', 'visible', 'important');
      btn.style.setProperty('opacity', '1', 'important');
      btn.style.setProperty('position', 'static', 'important');
      btn.style.setProperty('top', 'auto', 'important');
      btn.style.setProperty('right', 'auto', 'important');
      btn.style.setProperty('width', '32px', 'important');
      btn.style.setProperty('height', '32px', 'important');
      btn.style.setProperty('min-width', '32px', 'important');
      btn.style.setProperty('margin-left', 'auto', 'important');
      btn.style.setProperty('padding', '0', 'important');
      btn.style.setProperty('border', '0', 'important');
      btn.style.setProperty('background', 'transparent', 'important');
      btn.style.setProperty('color', '#14328c', 'important');
      btn.style.setProperty('font-size', '26px', 'important');
      btn.style.setProperty('line-height', '1', 'important');
      btn.style.setProperty('cursor', 'pointer', 'important');
      btn.style.setProperty('z-index', '3', 'important');
      btn.style.setProperty('align-items', 'center', 'important');
      btn.style.setProperty('justify-content', 'center', 'important');
      btn.style.setProperty('flex-shrink', '0', 'important');
      btn.style.setProperty('-webkit-appearance', 'none', 'important');
      btn.style.setProperty('appearance', 'none', 'important');
    }

    function snizeShouldHaveFilterChevron(titleEl) {
      if (!titleEl || !titleEl.classList || !titleEl.classList.contains('snize-product-filters-title')) {
        return false;
      }
      if (snizeIsFiltersDialogHeaderTitle(titleEl)) return false;
      if (titleEl.classList.contains('snize-no-filter-chevron')) return false;
      if (titleEl.getAttribute('data-snize-filter-header') === '1') return false;
      return true;
    }

    function snizeFilterBlockIsExpanded(titleEl) {
      var block = titleEl && titleEl.closest ? titleEl.closest('.snize-product-filters-block') : null;
      if (!block) return false;
      if (titleEl.getAttribute('aria-expanded') === 'true') return true;
      if (titleEl.getAttribute('aria-expanded') === 'false') return false;
      if (block.classList) {
        if (block.classList.contains('snize-open') || block.classList.contains('open')) return true;
        if (block.classList.contains('snize-collapsed') || block.classList.contains('collapsed')) {
          return false;
        }
      }
      if (titleEl.classList && titleEl.classList.contains('snize-open')) return true;
      var list = block.querySelector('.snize-product-filters-list');
      if (!list) return false;
      var style = window.getComputedStyle(list);
      if (style.display === 'none' || style.visibility === 'hidden' || style.maxHeight === '0px') {
        return false;
      }
      return list.offsetHeight > 0;
    }

    function snizeSetMobileFilterChevronDirection(chevron, expanded) {
      if (!chevron) return;
      var path = chevron.querySelector('path');
      if (path) {
        path.setAttribute('d', expanded ? SNIZE_MOBILE_FILTER_CHEVRON_UP : SNIZE_MOBILE_FILTER_CHEVRON_DOWN);
      }
      chevron.classList.toggle('snize-mobile-filter-chevron--up', expanded);
      chevron.classList.toggle('snize-mobile-filter-chevron--down', !expanded);
    }

    function snizeSyncMobileFilterChevron(titleEl) {
      if (!titleEl) return;
      var chevron = titleEl.querySelector('.snize-mobile-filter-chevron');
      if (!chevron) return;
      var expanded = snizeFilterBlockIsExpanded(titleEl);
      snizeSetMobileFilterChevronDirection(chevron, expanded);
      titleEl.classList.toggle('snize-filter-title-expanded', expanded);
      titleEl.setAttribute('data-snize-chevron', expanded ? 'up' : 'down');
    }

    function snizeSyncAllMobileFilterChevrons(root) {
      root = root || document;
      var dialogs = root.querySelectorAll
        ? root.querySelectorAll('#snize-modal-mobile-filters-dialog, #snize-modal-mobile-sortby-dialog')
        : [];
      for (var d = 0; d < dialogs.length; d++) {
        var titles = dialogs[d].querySelectorAll('.snize-product-filters-title');
        for (var i = 0; i < titles.length; i++) snizeSyncMobileFilterChevron(titles[i]);
      }
    }

    function snizeHideDefaultFilterTitleIcons(titleEl) {
      if (!titleEl) return;
      var svgs = titleEl.querySelectorAll('svg:not(.snize-mobile-filter-chevron)');
      for (var i = 0; i < svgs.length; i++) {
        var svg = svgs[i];
        if (svg.closest('.snize-close-button, [class*="close"]')) continue;
        svg.style.display = 'none';
        svg.setAttribute('aria-hidden', 'true');
      }
    }

    function snizeEnhanceMobileFilterTitle(titleEl) {
      if (!titleEl) return;
      if (snizeIsFiltersDialogHeaderTitle(titleEl)) {
        titleEl.classList.add('snize-no-filter-chevron');
        titleEl.setAttribute('data-snize-filter-header', '1');
        var oldChevron = titleEl.querySelector('.snize-mobile-filter-chevron');
        if (oldChevron) oldChevron.remove();
        snizeEnsureMobileFiltersInlineClose(titleEl);
        return;
      }
      if (!snizeShouldHaveFilterChevron(titleEl)) return;
      titleEl.classList.remove('snize-no-filter-chevron');
      titleEl.classList.add('snize-mobile-filter-accordion-row');
      if (!titleEl.querySelector('.snize-mobile-filter-chevron')) {
        titleEl.insertAdjacentHTML('beforeend', SNIZE_MOBILE_FILTER_CHEVRON_SVG);
      }
      snizeHideDefaultFilterTitleIcons(titleEl);
      snizeSyncMobileFilterChevron(titleEl);
    }

    function closeSnizeMobileFiltersModal() {
      var dialog = document.getElementById('snize-modal-mobile-filters-dialog');
      if (!dialog) return;

      if (
        dialog.closest('.mfp-wrap') &&
        window.jQuery &&
        window.jQuery.magnificPopup &&
        typeof window.jQuery.magnificPopup.close === 'function'
      ) {
        try {
          window.jQuery.magnificPopup.close();
          return;
        } catch (eMfp) {}
      }

      var wrap = dialog.closest('.mfp-wrap') || dialog.closest('.mfp-container') || dialog;
      var closeSelectors = [
        '.mfp-close',
        '.snize-close-button',
        '.snize-modal-close',
        'button.snize-close',
        'a.snize-close',
      ];
      for (var s = 0; s < closeSelectors.length; s++) {
        var btn = wrap.querySelector(closeSelectors[s]);
        if (btn && typeof btn.click === 'function') {
          btn.click();
          return;
        }
      }
    }

    function snizeEnsureMobileFiltersInlineClose(headerTitle) {
      if (!headerTitle) return null;

      if (!headerTitle.classList.contains('snize-product-filters-title')) {
        headerTitle.classList.add('snize-product-filters-title');
      }

      headerTitle.setAttribute('data-snize-filter-header', '1');
      headerTitle.classList.add('snize-no-filter-chevron');
      headerTitle.style.display = 'flex';
      headerTitle.style.alignItems = 'center';
      headerTitle.style.justifyContent = 'space-between';
      headerTitle.style.gap = '12px';

      var staleNative = headerTitle.querySelector(
        '.mfp-close:not([data-snize-custom-close="1"]), .snize-close-button:not([data-snize-custom-close="1"])'
      );
      if (staleNative) staleNative.remove();

      var btn = headerTitle.querySelector('.snize-mobile-filters-inline-close[data-snize-custom-close="1"]');
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'snize-mobile-filters-inline-close';
        btn.setAttribute('data-snize-custom-close', '1');
        btn.setAttribute('data-snize-close-in-header', '1');
        btn.setAttribute('aria-label', 'Close filters');
        btn.innerHTML =
          '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">' +
          '<path d="M4 4L14 14M14 4L4 14" stroke="#14328c" stroke-width="2" stroke-linecap="round"/></svg>';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          closeSnizeMobileFiltersModal();
        });
        headerTitle.appendChild(btn);
      }

      snizeStyleMobileFiltersInlineClose(btn);
      snizeWrapMobileFiltersHeaderLabel(headerTitle);
      return btn;
    }

    function snizeRelocateMobileFiltersCloseButton() {
      var dialog = document.getElementById('snize-modal-mobile-filters-dialog');
      if (!dialog) return;

      var headerTitle = snizeFindMobileFiltersHeaderHost(dialog);
      if (!headerTitle) {
        var sidebar = dialog.querySelector('.snize-filters-sidebar') || dialog;
        var bar = document.createElement('div');
        bar.className = 'snize-mobile-filters-header-bar';
        bar.innerHTML =
          '<div class="snize-product-filters-title snize-no-filter-chevron" data-snize-filter-header="1">' +
          '<span class="snize-mobile-filters-header-label">Filters</span></div>';
        sidebar.insertBefore(bar, sidebar.firstChild);
        headerTitle = bar.querySelector('.snize-product-filters-title');
      }

      if (!headerTitle) return;

      snizeEnsureMobileFiltersInlineClose(headerTitle);

      var wrap = dialog.closest('.mfp-wrap') || dialog;
      var externalCloses = wrap.querySelectorAll('.mfp-close, .snize-close-button');
      for (var c = 0; c < externalCloses.length; c++) {
        var closeEl = externalCloses[c];
        if (headerTitle.contains(closeEl)) continue;
        closeEl.style.display = 'none';
      }
    }

    function snizeApplyMobileFiltersPanelStyles() {
      var dialog = document.getElementById('snize-modal-mobile-filters-dialog');
      if (!dialog) return;

      var panelBg = '#F7F8FA';
      var whiteBg = '#ffffff';

      var setBg = function (el, color) {
        if (!el) return;
        el.style.setProperty('background-color', color, 'important');
        el.style.setProperty('background', color, 'important');
      };

      setBg(dialog, whiteBg);
      setBg(dialog.querySelector('.snize-filters-sidebar'), whiteBg);

      var mfpContent = dialog.closest('.mfp-content');
      if (mfpContent) setBg(mfpContent, whiteBg);

      var headerBar = dialog.querySelector('.snize-mobile-filters-header-bar');
      if (headerBar) {
        setBg(headerBar, whiteBg);
      }

      var titles = dialog.querySelectorAll('.snize-product-filters-title');
      for (var i = 0; i < titles.length; i++) {
        var title = titles[i];
        var isHeader =
          title.getAttribute('data-snize-filter-header') === '1' ||
          snizeIsFiltersDialogHeaderTitle(title);

        if (isHeader) {
          title.setAttribute('data-snize-filter-header', '1');
          setBg(title, whiteBg);
          var headerBlock = title.closest('.snize-product-filters-block');
          if (headerBlock) setBg(headerBlock, whiteBg);
          continue;
        }

        title.classList.add('snize-mobile-filter-accordion-row');
        setBg(title, panelBg);
        title.style.removeProperty('padding');

        var block = title.closest('.snize-product-filters-block');
        if (block) {
          setBg(block, whiteBg);
        }
      }

      var lists = dialog.querySelectorAll('.snize-product-filters-list');
      for (var l = 0; l < lists.length; l++) {
        setBg(lists[l], whiteBg);
        lists[l].style.setProperty('padding', '8px 16px 12px', 'important');
      }

      var footer = dialog.querySelector('.snize-product-filters-buttons-container');
      var showCount = dialog.querySelector('.snize-product-filters-show-count');
      if (footer) setBg(footer, whiteBg);
      if (showCount) setBg(showCount, whiteBg);
    }

    function snizeApplyMobileFilterChevrons() {
      var dialogs = document.querySelectorAll(
        '#snize-modal-mobile-filters-dialog, #snize-modal-mobile-sortby-dialog'
      );
      for (var d = 0; d < dialogs.length; d++) {
        var titles = dialogs[d].querySelectorAll('.snize-product-filters-title');
        for (var i = 0; i < titles.length; i++) snizeEnhanceMobileFilterTitle(titles[i]);
      }
      snizeSyncAllMobileFilterChevrons();
      snizeRelocateMobileFiltersCloseButton();
      snizeApplyMobileFiltersPanelStyles();
    }

    var snizeMobileFilterChevronTimer = null;
    function scheduleSnizeMobileFilterChevrons() {
      if (snizeMobileFilterChevronTimer) clearTimeout(snizeMobileFilterChevronTimer);
      snizeMobileFilterChevronTimer = setTimeout(function () {
        snizeMobileFilterChevronTimer = null;
        snizeApplyMobileFilterChevrons();
      }, 50);
    }

    function scheduleSnizeMobileFilterChevronBurst() {
      scheduleSnizeMobileFilterChevrons();
      [120, 450, 900, 1500].forEach(function (ms) {
        setTimeout(scheduleSnizeMobileFilterChevrons, ms);
      });
    }

    document.addEventListener('DOMContentLoaded', scheduleSnizeMobileFilterChevronBurst);
    window.addEventListener('load', scheduleSnizeMobileFilterChevronBurst);
    document.addEventListener('Searchanise.Loaded', scheduleSnizeMobileFilterChevronBurst);

    if (!window.__snizeMobileFilterChevronClickBound) {
      window.__snizeMobileFilterChevronClickBound = true;
      document.body.addEventListener(
        'click',
        function (e) {
          if (e.target.closest('.snize-main-panel-mobile-filters')) {
            scheduleSnizeMobileFilterChevronBurst();
            return;
          }
          var title = e.target.closest(
            '#snize-modal-mobile-filters-dialog .snize-product-filters-title, #snize-modal-mobile-sortby-dialog .snize-product-filters-title'
          );
          if (!title) return;
          var dialog = title.closest('#snize-modal-mobile-filters-dialog, #snize-modal-mobile-sortby-dialog');
          var syncDialogChevrons = function () {
            if (dialog) snizeSyncAllMobileFilterChevrons(dialog);
            else snizeSyncAllMobileFilterChevrons();
          };
          setTimeout(syncDialogChevrons, 0);
          setTimeout(syncDialogChevrons, 120);
          setTimeout(syncDialogChevrons, 320);
        },
        true
      );
    }

    if (!window.__snizeMobileFilterChevronObs) {
      window.__snizeMobileFilterChevronObs = new MutationObserver(function (mutations) {
        var relevant = false;
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          var check = function (node) {
            if (!node || node.nodeType !== 1) return false;
            return (
              node.id === 'snize-modal-mobile-filters-dialog' ||
              (node.closest && node.closest('#snize-modal-mobile-filters-dialog'))
            );
          };
          if (check(m.target)) {
            relevant = true;
            break;
          }
          var added = m.addedNodes;
          for (var j = 0; j < added.length; j++) {
            if (check(added[j])) {
              relevant = true;
              break;
            }
          }
          if (relevant) break;
        }
        if (relevant) scheduleSnizeMobileFilterChevrons();
      });
      window.__snizeMobileFilterChevronObs.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style'],
      });
    }

    scheduleSnizeMobileFilterChevronBurst();


    var qvWatchStarted = Date.now();
    var qvPlainRetries = 0;
    setInterval(function () {
      if (Date.now() - qvWatchStarted > 30000) return;
      var d = document.querySelector('.snize-quick-view-description');
      if (!d || !d.isConnected || !descriptionLooksPlain(d)) return;
      if (qvPlainRetries++ > 40) return;
      var h = lastCardProductHandle || d.getAttribute('data-snize-html-handle');
      if (h) delete descCache[h];
      scheduleSnizeQuickViewHtmlDescription();
    }, 450);

    var snizeQvAtcRelabelTimer = null;
    var snizeQvAtcRelabelBusy = false;
    var snizeQvAtcFeedbackTimer = null;
    var snizeQvAddInFlight = false;
    var snizeQvStockSyncGen = 0;
    var snizeQvVariantChangeTimer = null;
    var snizeQvStockMutTimer = null;
    var snizeQvVariantChangeUntil = 0;

    function snizeQvSetStockCheckingUi(modal, checking) {
      if (!modal) return;
      var form = modal.querySelector('form[action*="/cart/add"]');
      if (checking) {
        if (modal.getAttribute('data-snize-qv-stock-pending') === '1') return;
        modal.setAttribute('data-snize-qv-stock-pending', '1');
        modal.removeAttribute('data-snize-qv-stock-state');
        clearSnizeKlaviyoBisUi(modal);
        if (form) form.classList.remove('snize-add-to-cart-form-out-of-stock');
        return;
      }
      if (!modal.hasAttribute('data-snize-qv-stock-pending')) return;
      modal.removeAttribute('data-snize-qv-stock-pending');
    }

    function snizeQvButtonLooksReady(btn) {
      if (!btn || btn.getAttribute('data-snize-qv-suppressed') === '1') return false;
      if (btn.classList.contains('snize-hidden')) return false;
      var label = String(btn.textContent || '').trim().toLowerCase();
      if (!label || label.indexOf('notify') !== -1) return false;
      if (label.indexOf('sold out') !== -1) return false;
      return label.indexOf('add to cart') !== -1;
    }

    function snizeQvResolveVariantForProduct(modal, product) {
      if (!modal || !product) return '';
      var vid = '';
      if (product.variants && product.variants.length) {
        vid = snizeQvResolveVariantIdForAdd(modal);
        if (!vid) {
          var pill = snizeQvFindActivePill(modal);
          var fromPillAttr = pill
            ? pill.getAttribute('data-variant-id') ||
              pill.getAttribute('data-snize-variant-id') ||
              pill.getAttribute('data-variant') ||
              ''
            : '';
          vid = String(fromPillAttr || '').trim();
          if (!vid && pill) vid = snizeQvVariantIdFromPillLabel(product, pill);
        }
        if (!vid) vid = snizeResolveVariantFromProduct(product, '');
      }
      return vid ? String(vid).trim() : '';
    }

    function snizeQvApplyStockFromProduct(modal, form, product) {
      if (!modal || !form || !product) return;
      var vid = snizeQvResolveVariantForProduct(modal, product);
      if (product.variants && product.variants.length && vid) {
        snizeQvSyncFormVariantId(modal, vid, true);
        modal.setAttribute('data-snize-qv-selected-vid', String(vid));
        snizeQvApplyStockUi(modal, form, snizeQvVariantIsInStock(product, vid), vid);
        return;
      }
      snizeQvApplyStockUi(modal, form, !!product.available, vid);
    }

    function snizeQvCollectAtcButtons(modal) {
      if (!modal || !modal.querySelectorAll) return [];
      var list = [];
      var seen = [];
      function push(el) {
        if (!el || seen.indexOf(el) !== -1) return;
        if (el.id === 'snize-quick-view-out-of-stock') return;
        if (el.classList && el.classList.contains('snize-klaviyo-bis-anchor')) return;
        if (el.closest && el.closest('.snize-klaviyo-bis-wrap')) return;
        seen.push(el);
        list.push(el);
      }
      push(modal.querySelector('#snize-quick-view-add-to-cart'));
      var scope =
        modal.querySelector('.snize-qv-qty-row') ||
        modal.querySelector('.snize-quick-view-cart-block') ||
        modal.querySelector('.snize-quick-view-add-to-cart-wrapper') ||
        modal;
      var buttons = scope.querySelectorAll('button.snize-button, a.snize-button, button, a[role="button"]');
      for (var i = 0; i < buttons.length; i++) {
        var btn = buttons[i];
        var label = String(btn.textContent || '')
          .trim()
          .toLowerCase();
        if (
          label.indexOf('add to cart') !== -1 ||
          label.indexOf('adding') !== -1 ||
          label.indexOf('added') !== -1 ||
          btn.getAttribute('data-snize-qv-atc-add-only') === '1' ||
          btn.id === 'snize-quick-view-add-to-cart'
        ) {
          push(btn);
        }
      }
      return list;
    }

    function snizeQvStockUiMatchesDom(modal, form, inStock) {
      if (!modal || !form) return false;
      var atcButtons = snizeQvCollectAtcButtons(modal);
      var oosBtn = form.querySelector('#snize-quick-view-out-of-stock');
      var notify = form.querySelector('.snize-klaviyo-bis-wrap');
      var i;
      if (inStock) {
        if (notify) return false;
        if (oosBtn) {
          var oosHidden =
            oosBtn.getAttribute('aria-hidden') === 'true' ||
            (oosBtn.style && oosBtn.style.display === 'none');
          if (!oosHidden) return false;
        }
        for (i = 0; i < atcButtons.length; i++) {
          if (atcButtons[i].getAttribute('data-snize-qv-suppressed') === '1') return false;
          if (atcButtons[i].classList.contains('snize-hidden')) return false;
        }
        return atcButtons.length > 0;
      }
      // OOS: every ATC must stay suppressed; Notify Me (or OOS) must be present.
      for (i = 0; i < atcButtons.length; i++) {
        var atc = atcButtons[i];
        if (atc.getAttribute('data-snize-qv-suppressed') !== '1') return false;
        if (atc.style && atc.style.display !== 'none') return false;
      }
      if (notify && notify.isConnected) return true;
      if (oosBtn && oosBtn.getAttribute('aria-hidden') !== 'true') return true;
      return false;
    }

    function snizeQvApplyStockUi(modal, form, inStock, vid) {
      vid = vid ? String(vid) : snizeQvResolveVariantIdForAdd(modal);
      var nextState = inStock ? 'in-stock' : 'oos';
      var lastVid = modal.getAttribute('data-snize-qv-stock-applied-vid') || '';
      var lastState = modal.getAttribute('data-snize-qv-stock-state') || '';
      // Searchanise rebuilds QV after Notify Me — attrs can match while ATC/OOS DOM drifted.
      if (lastVid === vid && lastState === nextState && snizeQvStockUiMatchesDom(modal, form, inStock)) {
        return;
      }

      modal.setAttribute('data-snize-qv-stock-applied-vid', vid);
      var atcButtons = snizeQvCollectAtcButtons(modal);
      var oosBtn = snizeQvEnsureOosButton(form);
      var a;

      if (inStock) {
        modal.setAttribute('data-snize-qv-stock-state', 'in-stock');
        form.classList.remove('snize-add-to-cart-form-out-of-stock');
        if (oosBtn) {
          oosBtn.style.setProperty('display', 'none', 'important');
          oosBtn.setAttribute('aria-hidden', 'true');
        }
        for (a = 0; a < atcButtons.length; a++) {
          var atcIn = atcButtons[a];
          atcIn.classList.remove('snize-hidden');
          atcIn.removeAttribute('data-snize-qv-suppressed');
          atcIn.style.removeProperty('display');
        }
        clearSnizeKlaviyoBisUi(modal);
        snizeQvSetStockCheckingUi(modal, false);
        if (!snizeQvButtonLooksReady(snizeQvGetAtcButton(modal))) {
          scheduleSnizeQvAtcRelabelBurst();
        }
        return;
      }

      modal.setAttribute('data-snize-qv-stock-state', 'oos');
      form.classList.add('snize-add-to-cart-form-out-of-stock');
      if (oosBtn) {
        oosBtn.classList.add('button');
        oosBtn.style.removeProperty('display');
        oosBtn.removeAttribute('aria-hidden');
      }
      for (a = 0; a < atcButtons.length; a++) {
        var atcOut = atcButtons[a];
        atcOut.classList.add('snize-hidden');
        atcOut.setAttribute('data-snize-qv-suppressed', '1');
        atcOut.style.setProperty('display', 'none', 'important');
      }
      snizeQvSetStockCheckingUi(modal, false);
      scheduleSnizeQuickViewKlaviyoSync();
    }

    function snizeQvButtonSaysViewCart(btn) {
      if (!btn) return false;
      var t = String(btn.textContent || '').trim().toLowerCase();
      return t.indexOf('view cart') !== -1 || t.indexOf('go to cart') !== -1;
    }

    function snizeQvSetButtonTextKeepMarkup(btn, text) {
      var spans = btn.querySelectorAll('span');
      var done = false;
      for (var i = 0; i < spans.length; i++) {
        var sp = spans[i];
        if (sp.querySelector('svg, img, i')) continue;
        var st = String(sp.textContent || '').trim().toLowerCase();
        if (
          st.indexOf('view cart') !== -1 ||
          st.indexOf('go to cart') !== -1 ||
          st.indexOf('add to cart') !== -1 ||
          st === 'added' ||
          st.indexOf('adding') !== -1
        ) {
          sp.textContent = text;
          done = true;
        }
      }
      if (!done) {
        var nodes = btn.childNodes;
        for (var j = nodes.length - 1; j >= 0; j--) {
          if (nodes[j].nodeType === 3) {
            nodes[j].textContent = ' ' + text;
            done = true;
            break;
          }
        }
      }
      if (!done) btn.appendChild(document.createTextNode(' ' + text));
    }

    function snizeQvSyncFormVariantId(modal, vid, silent) {
      if (!modal || !vid) return;
      var idStr = String(vid);
      modal.setAttribute('data-snize-qv-selected-vid', idStr);
      var form = modal.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var sel = form.querySelector('select[name="id"]');
      if (sel && sel.value !== idStr) {
        sel.value = idStr;
        if (!silent) {
          try {
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          } catch (eCh) {}
        }
      }
      var hidden = form.querySelector('input[name="id"][type="hidden"]');
      if (hidden) hidden.value = idStr;
      var vidInput = form.querySelector('input[name="variant_id"]');
      if (vidInput) vidInput.value = idStr;
    }

    function snizeQvResolveVariantIdForAdd(modal) {
      if (!modal) return '';
      var form = modal.querySelector('form[action*="/cart/add"]');
      var vid = snizeQuickViewCurrentVariantId(form);
      if (!vid) {
        var active = modal.querySelector(
          '.snize-size-select-box .snize-size-active, .snize-size.snize-active, .snize-product-swatches-option.snize-active'
        );
        if (active) {
          vid =
            active.getAttribute('data-variant-id') ||
            active.getAttribute('data-snize-variant-id') ||
            active.getAttribute('data-variant') ||
            '';
        }
      }
      if (!vid) vid = modal.getAttribute('data-snize-qv-selected-vid') || '';
      return vid ? String(vid).trim() : '';
    }

    function snizeQvVariantIdFromPillLabel(product, pill) {
      if (!product || !product.variants || !product.variants.length || !pill) return '';
      var label = snizeQvLabelFromSizePill(pill);
      if (!label) return '';
      var norm = String(label)
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var fields = [v.title, v.option1, v.option2, v.option3];
        for (var f = 0; f < fields.length; f++) {
          if (!fields[f]) continue;
          var fieldNorm = String(fields[f])
            .trim()
            .toLowerCase()
            .replace(/\s+/g, ' ');
          if (fieldNorm === norm) return String(v.id);
        }
      }
      return '';
    }

    function snizeQvFindActivePill(modal) {
      if (!modal || !modal.querySelectorAll) return null;
      var pills = modal.querySelectorAll(
        '.snize-size-select-box .snize-size, .snize-size, .snize-product-swatches-option'
      );
      for (var i = 0; i < pills.length; i++) {
        var p = pills[i];
        if (
          p.classList.contains('snize-size-active') ||
          p.classList.contains('snize-active') ||
          p.classList.contains('active') ||
          p.getAttribute('aria-checked') === 'true'
        ) {
          return p;
        }
      }
      return pills.length ? pills[0] : null;
    }

    function snizeQvVariantIsInStock(product, variantId) {
      if (!product || !product.variants || !product.variants.length) return !!(product && product.available);
      var idStr = String(variantId || '').trim();
      if (!idStr) return !!product.available;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (String(v.id) !== idStr) continue;
        if (v.available === false) return false;
        if (v.inventory_management && String(v.inventory_policy || '') === 'deny') {
          var qty = parseInt(v.inventory_quantity, 10);
          if (!isNaN(qty) && qty <= 0) return false;
        }
        return true;
      }
      return !!product.available;
    }

    function snizeQvEnsureOosButton(form) {
      if (!form) return null;
      var oosBtn = form.querySelector('#snize-quick-view-out-of-stock');
      if (oosBtn) return oosBtn;
      oosBtn = document.createElement('button');
      oosBtn.type = 'button';
      oosBtn.id = 'snize-quick-view-out-of-stock';
      oosBtn.className = 'button snize-button';
      oosBtn.disabled = true;
      oosBtn.textContent = 'Out of stock';
      var atcWrap = form.querySelector('.snize-quick-view-add-to-cart-wrapper');
      if (atcWrap) atcWrap.appendChild(oosBtn);
      else form.appendChild(oosBtn);
      return oosBtn;
    }

    function snizeQvResetStockStateIfProductChanged(modal) {
      if (!modal) return;
      var handle = resolveQuickViewHandle(modal) || '';
      var lastHandle = modal.getAttribute('data-snize-qv-stock-handle') || '';
      if (!handle || handle === lastHandle) return;
      modal.setAttribute('data-snize-qv-stock-handle', handle);
      modal.removeAttribute('data-snize-qv-stock-applied-vid');
      modal.removeAttribute('data-snize-qv-stock-state');
      modal.removeAttribute('data-snize-qv-stock-pending');
    }

    function snizeQvSyncStockState(modal) {
      if (!modal) return;
      snizeQvResetStockStateIfProductChanged(modal);
      var form = modal.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var handle = resolveQuickViewHandle(modal);
      if (!handle) return;

      var syncGen = ++snizeQvStockSyncGen;
      var cached = snizeQvProductByHandle[handle];
      if (cached) {
        if (syncGen === snizeQvStockSyncGen) {
          snizeQvSetStockCheckingUi(modal, false);
          snizeQvApplyStockFromProduct(modal, form, cached);
        }
        return;
      }

      snizeQvSetStockCheckingUi(modal, true);
      fetchSnizeQuickViewProduct(handle, function (product) {
        if (!modal.isConnected || syncGen !== snizeQvStockSyncGen) return;
        snizeQvSetStockCheckingUi(modal, false);
        if (!product) return;
        snizeQvApplyStockFromProduct(modal, form, product);
      });
    }

    function scheduleSnizeQvSyncStockState(modal) {
      if (!modal) return;
      if (Date.now() < snizeQvVariantChangeUntil) return;
      if (snizeQvStockMutTimer) clearTimeout(snizeQvStockMutTimer);
      snizeQvStockMutTimer = setTimeout(function () {
        snizeQvStockMutTimer = null;
        if (Date.now() < snizeQvVariantChangeUntil) return;
        var m = document.getElementById('snize-modal-product-quick-view');
        if (!m) return;
        var form = m.querySelector('form[action*="/cart/add"]');
        var vid = snizeQvResolveVariantIdForAdd(m);
        var lastVid = m.getAttribute('data-snize-qv-stock-applied-vid') || '';
        var lastState = m.getAttribute('data-snize-qv-stock-state') || '';
        // Skip only when in-stock attrs + live DOM still agree (Notify Me reopen often drifts).
        if (
          vid &&
          vid === lastVid &&
          lastState === 'in-stock' &&
          form &&
          snizeQvStockUiMatchesDom(m, form, true)
        ) {
          return;
        }
        if (
          vid &&
          vid === lastVid &&
          lastState === 'oos' &&
          form &&
          snizeQvStockUiMatchesDom(m, form, false)
        ) {
          return;
        }
        snizeQvSyncStockState(m);
      }, 180);
    }

    function snizeQvOnVariantChange(modal) {
      if (!modal) return;
      snizeQvResetStockStateIfProductChanged(modal);
      snizeQvVariantChangeUntil = Date.now() + 500;
      snizeQvAddInFlight = false;
      if (snizeQvAtcFeedbackTimer) {
        clearTimeout(snizeQvAtcFeedbackTimer);
        snizeQvAtcFeedbackTimer = null;
      }

      var form = modal.querySelector('form[action*="/cart/add"]');
      var handle = resolveQuickViewHandle(modal);
      var cached = handle ? snizeQvProductByHandle[handle] : null;
      if (cached && form) {
        snizeQvApplyStockFromProduct(modal, form, cached);
        if (snizeQvVariantChangeTimer) clearTimeout(snizeQvVariantChangeTimer);
        snizeQvVariantChangeTimer = setTimeout(function () {
          snizeQvVariantChangeTimer = null;
          var m = document.getElementById('snize-modal-product-quick-view');
          if (!m || !m.isConnected || m.getAttribute('data-snize-qv-stock-state') !== 'in-stock') return;
          if (!snizeQvButtonLooksReady(snizeQvGetAtcButton(m))) {
            m.removeAttribute('data-snize-qv-stock-applied-vid');
            var f = m.querySelector('form[action*="/cart/add"]');
            var h = resolveQuickViewHandle(m);
            var c = h ? snizeQvProductByHandle[h] : null;
            if (c && f) snizeQvApplyStockFromProduct(m, f, c);
          }
        }, 130);
        return;
      }

      if (snizeQvVariantChangeTimer) clearTimeout(snizeQvVariantChangeTimer);
      snizeQvVariantChangeTimer = setTimeout(function () {
        snizeQvVariantChangeTimer = null;
        var m = document.getElementById('snize-modal-product-quick-view');
        if (m) snizeQvSyncStockState(m);
      }, 90);
    }

    function snizeQvStripButtonListeners(btn) {
      if (!btn || !btn.parentNode) return btn;
      var clone = btn.cloneNode(true);
      btn.parentNode.replaceChild(clone, btn);
      return clone;
    }

    function snizeQvGetAtcButton(modal) {
      if (!modal) return null;
      return (
        modal.querySelector('#snize-quick-view-add-to-cart') ||
        modal.querySelector('.snize-quick-view-cart-block [data-snize-qv-atc-add-only]') ||
        modal.querySelector('.snize-quick-view-cart-block button.snize-button') ||
        modal.querySelector('.snize-quick-view-cart-block button')
      );
    }

    function snizeQvPrepareAtcButton(btn) {
      if (!btn) return btn;
      var fb = btn.getAttribute('data-snize-qv-atc-feedback');
      if (fb === 'added' || fb === 'loading') return btn;
      if (snizeQvButtonLooksReady(btn)) {
        btn.setAttribute('data-snize-qv-atc-add-only', '1');
        btn._snizeQvListenersStripped = true;
        return btn;
      }
      if (!btn._snizeQvListenersStripped) {
        var fresh = snizeQvStripButtonListeners(btn);
        if (fresh) btn = fresh;
        btn._snizeQvListenersStripped = true;
      }
      btn.classList.remove('snize-hidden', 'snize-go-to-cart', 'snize-action-checkout', 'snize-checkout');
      btn.removeAttribute('data-snize-qv-in-cart');
      btn.style.removeProperty('display');
      btn.style.removeProperty('visibility');
      btn.style.removeProperty('opacity');
      btn.style.removeProperty('background');
      btn.style.removeProperty('background-color');
      btn.removeAttribute('href');
      btn.removeAttribute('onclick');
      if (typeof btn.onclick === 'function') btn.onclick = null;
      snizeQvSetButtonTextKeepMarkup(btn, 'ADD TO CART');
      if (btn.tagName === 'BUTTON') btn.setAttribute('type', 'button');
      if (btn.tagName === 'A') btn.setAttribute('role', 'button');
      btn.setAttribute('data-snize-qv-atc-add-only', '1');
      btn.style.cursor = 'pointer';
      return btn;
    }

    function snizeQvRelabelAllAtcButtons(modal) {
      modal = modal || document.getElementById('snize-modal-product-quick-view');
      if (!modal) return;
      if (modal.getAttribute('data-snize-qv-stock-pending') === '1') return;
      if (modal.getAttribute('data-snize-qv-stock-state') === 'oos') return;
      var btn = snizeQvGetAtcButton(modal);
      if (snizeQvButtonLooksReady(btn)) return;
      snizeQvAtcRelabelBusy = true;
      var vid = snizeQvResolveVariantIdForAdd(modal);
      if (vid) snizeQvSyncFormVariantId(modal, vid, true);
      if (btn) snizeQvPrepareAtcButton(btn);
      snizeQvAtcRelabelBusy = false;
    }

    function snizeQvSetAtcButtonState(modal, state) {
      var btn = snizeQvGetAtcButton(modal);
      if (!btn) return null;
      if (snizeQvAtcFeedbackTimer) {
        clearTimeout(snizeQvAtcFeedbackTimer);
        snizeQvAtcFeedbackTimer = null;
      }
      if (state === 'loading') {
        snizeQvSetButtonTextKeepMarkup(btn, 'Adding...');
        btn.setAttribute('data-snize-qv-atc-feedback', 'loading');
        btn.setAttribute('aria-busy', 'true');
        if (btn.tagName === 'BUTTON') btn.disabled = true;
        else btn.style.pointerEvents = 'none';
        return btn;
      }
      if (state === 'added') {
        snizeQvSetButtonTextKeepMarkup(btn, 'Added');
        btn.setAttribute('data-snize-qv-atc-feedback', 'added');
        btn.removeAttribute('aria-busy');
        if (btn.tagName === 'BUTTON') btn.disabled = false;
        else btn.style.pointerEvents = '';
        snizeQvAtcFeedbackTimer = setTimeout(function () {
          snizeQvAtcFeedbackTimer = null;
          if (!modal.isConnected) return;
          snizeQvSetAtcButtonState(modal, 'idle');
          scheduleSnizeQvAtcRelabel();
        }, 2000);
        return btn;
      }
      btn.removeAttribute('data-snize-qv-atc-feedback');
      btn.removeAttribute('aria-busy');
      if (btn.tagName === 'BUTTON') btn.disabled = false;
      else btn.style.pointerEvents = '';
      snizeQvPrepareAtcButton(btn);
      return btn;
    }

    function scheduleSnizeQvAtcRelabel() {
      if (snizeQvAtcRelabelTimer) clearTimeout(snizeQvAtcRelabelTimer);
      snizeQvAtcRelabelTimer = setTimeout(function () {
        snizeQvAtcRelabelTimer = null;
        snizeQvRelabelAllAtcButtons();
      }, 60);
    }

    function scheduleSnizeQvAtcRelabelBurst() {
      var modal = document.getElementById('snize-modal-product-quick-view');
      if (modal && modal.getAttribute('data-snize-qv-stock-pending') === '1') return;
      scheduleSnizeQvAtcRelabel();
    }

    function snizeQvGetCartSectionIds() {
      var ids = [];
      var nodes = document.querySelectorAll('cart-items-component[data-section-id]');
      for (var i = 0; i < nodes.length; i++) {
        var sid = nodes[i].getAttribute('data-section-id');
        if (sid && ids.indexOf(sid) === -1) ids.push(sid);
      }
      return ids;
    }

    function snizeQvDispatchHorizonCartUpdate(sections, vid, qtyAdded) {
      var qty = qtyAdded || 1;
      try {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: {},
              data: {
                itemCount: qty,
                source: 'product-form-component',
                variantId: vid ? String(vid) : '',
                sections: sections || {},
                quantity: qty
              }
            }
          })
        );
      } catch (eEv) {}
    }

    function snizeQvAddToCartAjax(modal) {
      if (!modal || snizeQvAddInFlight) return;
      var vid = snizeQvResolveVariantIdForAdd(modal);
      if (!vid) return;
      snizeQvSyncFormVariantId(modal, vid);
      var form = modal.querySelector('form[action*="/cart/add"]');
      var qty = 1;
      if (form) {
        var q =
          form.querySelector('input[name="quantity"]') ||
          form.querySelector('.snize-quick-view-add-to-cart-quantity input');
        if (q && q.value) qty = Math.max(1, parseInt(q.value, 10) || 1);
      }
      snizeQvSetAtcButtonState(modal, 'loading');
      snizeQvAddInFlight = true;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = root.replace(/\/?$/, '/') + 'cart/add.js';
      var sectionIds = snizeQvGetCartSectionIds();
      var payload = { id: parseInt(vid, 10), quantity: qty };
      if (sectionIds.length) {
        payload.sections = sectionIds.join(',');
        payload.sections_url = window.location.pathname + window.location.search;
      }
      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (res) {
          snizeQvAddInFlight = false;
          if (!res.ok || (res.data && res.data.status)) {
            snizeQvSetAtcButtonState(modal, 'idle');
            return;
          }
          var sections = res.data && res.data.sections ? res.data.sections : null;
          snizeQvDispatchHorizonCartUpdate(sections, vid, qty);
          snizeQvSetAtcButtonState(modal, 'added');
          setTimeout(function () {
            closeSnizeQuickViewModal();
          }, 120);
        })
        .catch(function () {
          snizeQvAddInFlight = false;
          snizeQvSetAtcButtonState(modal, 'idle');
        });
    }

    function snizeQvAtcFromClickTarget(target, modal) {
      if (!target || !target.closest || !modal) return null;
      if (target.closest('.snize-quick-view-add-to-cart-quantity')) return null;
      if (target.closest('.snize-klaviyo-bis-wrap')) return null;
      var hit =
        target.closest('#snize-quick-view-add-to-cart') ||
        target.closest('[data-snize-qv-atc-add-only]');
      if (!hit || hit.getAttribute('data-snize-qv-suppressed') === '1') return null;
      return hit;
    }

    function snizeQvHandleCartBlockClick(e) {
      var modal = document.getElementById('snize-modal-product-quick-view');
      if (!modal || !modal.isConnected) return;
      var atc = snizeQvAtcFromClickTarget(e.target, modal);
      if (!atc || !modal.contains(atc)) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (snizeQvButtonSaysViewCart(atc)) snizeQvRelabelAllAtcButtons(modal);
      snizeQvAddToCartAjax(modal);
    }

    if (!window.__snizeQvAtcAddOnly) {
      window.__snizeQvAtcAddOnly = true;
      document.addEventListener('click', snizeQvHandleCartBlockClick, true);
      document.addEventListener(
        'submit',
        function (e) {
          var form = e.target;
          if (!form || !form.closest) return;
          var modal = form.closest('#snize-modal-product-quick-view');
          if (!modal) return;
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          snizeQvAddToCartAjax(modal);
        },
        true
      );
      document.addEventListener('cart:update', scheduleSnizeQvAtcRelabelBurst);
    }

    document.addEventListener(
      'click',
      function (e) {
        var pill = e.target.closest(
          '#snize-modal-product-quick-view .snize-size-select-box .snize-size, #snize-modal-product-quick-view .snize-size, #snize-modal-product-quick-view .snize-product-swatches-option'
        );
        if (!pill) return;
        var modal = document.getElementById('snize-modal-product-quick-view');
        if (!modal || !modal.contains(pill)) return;
        var vid =
          pill.getAttribute('data-variant-id') ||
          pill.getAttribute('data-snize-variant-id') ||
          pill.getAttribute('data-variant') ||
          '';
        if (vid) {
          modal.setAttribute('data-snize-qv-selected-vid', String(vid).trim());
          snizeQvSyncFormVariantId(modal, vid, true);
        } else {
          var handle = resolveQuickViewHandle(modal);
          if (handle) {
            fetchSnizeQuickViewProduct(handle, function (product) {
              if (!modal.isConnected || !product) return;
              var fromLabel = snizeQvVariantIdFromPillLabel(product, pill);
              if (!fromLabel) return;
              modal.setAttribute('data-snize-qv-selected-vid', String(fromLabel));
              snizeQvSyncFormVariantId(modal, fromLabel, true);
              snizeQvOnVariantChange(modal);
            });
            return;
          }
        }
        snizeQvOnVariantChange(modal);
      },
      true
    );


    window.__snizeKlaviyoBis = {
      formId: SNIZE_KLAVIYO_BIS_FORM_ID,
      companyId: resolveSnizeKlaviyoCompanyId,
      open: function (context) {
        if (context && context.variantId) {
          snizeOpenKlaviyoBisWithValidatedContext(context);
          return;
        }
        openSnizeKlaviyoBisWithRetries(SNIZE_KLAVIYO_BIS_FORM_ID, null);
      },
      subscribe: subscribeSnizeKlaviyoBackInStock,
      pending: function () {
        return snizeKlaviyoPendingBis;
      },
      pathname: function () {
        return window.location.pathname;
      },
      closeQuickView: closeSnizeQuickViewModal,
      bumpZ: bumpKlaviyoAboveSnizeQuickView,
      lowerSnizeModal: scheduleSnizeKlaviyoZIndexFix,
      syncQuickViewVariantImage: scheduleSnizeQuickViewVariantImage,
      syncPlpNotifyButtons: scheduleSnizePlpNotifyMeEnhance,
      syncQvAtcButton: scheduleSnizeQvAtcRelabelBurst
    };

  })();

/* === plp-ready === */

(function () {
  var queue = [];

  function snizeResultsRoot() {
    return document.getElementById('snize_results');
  }

  function snizeProductCardSelector() {
    return '#snize-search-results-grid-mode li.snize-product, #snize-search-results-list-mode li.snize-product, #snize_results li.snize-product, #snize_results .snize-product';
  }

  function snizeHasProductCards() {
    var root = snizeResultsRoot();
    return !!(root && root.querySelector(snizeProductCardSelector()));
  }

  function snizeFlushPlpReadyQueue() {
    if (!snizeHasProductCards()) return;
    while (queue.length) {
      var fn = queue.shift();
      try {
        fn();
      } catch (e) {}
    }
    if (typeof window.snizeApplyPlpPriceReviewsRows === 'function') {
      window.snizeApplyPlpPriceReviewsRows();
    }
  }

  function snizeOnPlpProductsReady(fn) {
    if (typeof fn !== 'function') return;
    if (snizeHasProductCards()) {
      try {
        fn();
      } catch (e2) {}
      return;
    }
    queue.push(fn);
    snizeFlushPlpReadyQueue();
  }

  document.addEventListener('Searchanise.Loaded', snizeFlushPlpReadyQueue);

  var watchedRoot = null;
  function snizeAttachPlpReadyObserver() {
    var root = snizeResultsRoot();
    if (!root || root === watchedRoot) return false;
    watchedRoot = root;
    new MutationObserver(snizeFlushPlpReadyQueue).observe(root, { childList: true, subtree: true });
    snizeFlushPlpReadyQueue();
    return true;
  }

  snizeAttachPlpReadyObserver();
  if (document.body) {
    new MutationObserver(function () {
      snizeAttachPlpReadyObserver();
      if (queue.length) snizeFlushPlpReadyQueue();
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.__snizePlpReady = {
    onReady: snizeOnPlpProductsReady,
    flush: snizeFlushPlpReadyQueue
  };

  window.__snizePlp = window.__snizePlp || {};
  window.__snizePlp.getCards = function (rootEl) {
    if (rootEl && rootEl.querySelectorAll) {
      return Array.prototype.slice.call(rootEl.querySelectorAll('li.snize-product, .snize-product'));
    }
    return Array.prototype.slice.call(document.querySelectorAll(snizeProductCardSelector()));
  };

  function snizeFindCardReviewsEl(card) {
    if (!card) return null;
    var block = card.querySelector('.snize-reviews');
    if (block) return block;
    var stars = card.querySelector('.stars-container');
    if (!stars) return null;
    var parent = stars.parentElement;
    if (parent && parent !== card) {
      if (parent.classList.contains('snize-reviews') || parent.querySelector('.total-reviews')) {
        return parent;
      }
    }
    return stars;
  }

  function snizeFindCardPriceEl(card) {
    if (!card) return null;
    return (
      card.querySelector('.snize-price-list') ||
      card.querySelector('.snize-price-wrapper') ||
      card.querySelector('.snize-price')
    );
  }

  function snizeUnwrapPlpPriceReviewsRow(card) {
    if (!card) return;
    var row = card.querySelector('[data-snize-plp-price-reviews="1"]');
    if (!row || !row.parentNode) return;
    var parent = row.parentNode;
    while (row.firstChild) {
      parent.insertBefore(row.firstChild, row);
    }
    parent.removeChild(row);
  }

  function snizeWrapPlpPriceReviewsRow(card) {
    if (!card || !card.querySelector) return;

    var price = snizeFindCardPriceEl(card);
    var reviews = snizeFindCardReviewsEl(card);
    if (!price || !reviews || price.contains(reviews)) return;
    if (reviews.closest && reviews.closest('#snize-modal-product-quick-view')) return;

    var row = card.querySelector('[data-snize-plp-price-reviews="1"]');
    if (!row) {
      row = document.createElement('div');
      row.className = 'snize-plp-price-reviews-row';
      row.setAttribute('data-snize-plp-price-reviews', '1');
      price.parentNode.insertBefore(row, price);
      row.appendChild(price);
      row.appendChild(reviews);
      return;
    }
    if (price.parentNode !== row) row.insertBefore(price, row.firstChild);
    if (reviews.parentNode !== row) row.appendChild(reviews);
  }

  function snizeApplyPlpPriceReviewsRows() {
    var cards = window.__snizePlp.getCards();
    for (var i = 0; i < cards.length; i++) snizeWrapPlpPriceReviewsRow(cards[i]);
  }

  function snizeSchedulePlpPriceReviewsRows() {
    snizeApplyPlpPriceReviewsRows();
    [80, 200, 450, 900, 1600, 2800].forEach(function (ms) {
      setTimeout(snizeApplyPlpPriceReviewsRows, ms);
    });
  }

  snizeOnPlpProductsReady(snizeSchedulePlpPriceReviewsRows);
  document.addEventListener('Searchanise.Loaded', snizeSchedulePlpPriceReviewsRows);
  document.addEventListener('DOMContentLoaded', snizeSchedulePlpPriceReviewsRows);
  window.addEventListener('load', snizeSchedulePlpPriceReviewsRows);
  window.addEventListener('resize', function () {
    snizeApplyPlpPriceReviewsRows();
  });
  window.snizeApplyPlpPriceReviewsRows = snizeApplyPlpPriceReviewsRows;
})();

/* === navigation-categories === */

(function () {
  var TAG_CATEGORY_MAP = [
    { tags: ['blood-sugar'], title: 'Blood Sugar Support', className: 'collection-blood-sugar-support' },
    { tags: ['bones'], title: 'Bone, Joints & Muscles', className: 'collection-bones-musculoskeletal-health' },
    {
      tags: ['heart'],
      title: 'Cardiometabolic Health & Metabolism',
      className: 'collection-cardiovascular-health'
    },
    {
      tags: ['cellular'],
      title: 'Cellular Health & Longevity',
      className: 'collection-cellular-health-longevity'
    },
    { tags: ['childrens-formulas'], title: "Children's Formulas", className: 'collection-childrens-formulas' },
    { tags: ['cognitive'], title: 'Cognitive Health', className: 'collection-cognitive-health' },
    { tags: ['energy'], title: 'Energy & Fitness', className: 'collection-energy-fitness' },
    { tags: ['fish-oils'], title: 'Fish Oils & Omegas', className: 'collection-fish-oils-omegas' },
    { tags: ['digestive'], title: 'Gastrointestinal', className: 'collection-gut-health' },
    { tags: ['hormone'], title: 'Hormone', className: 'collection-hormone' },
    { tags: ['immune'], title: 'Immune Support', className: 'collection-immune-support' },
    { tags: ['liver'], title: 'Liver & Detoxification', className: 'collection-liver-detoxification' },
    { tags: ['mens-formulas'], title: "Men's Formula's", className: 'collection-mens-formulas' },
    { tags: ['mental-health'], title: 'Memory & Mood', className: 'collection-mental-health-stress-support' },
    {
      tags: ['vitamins'],
      title: 'Multivitamins, Vitamins, Minerals',
      className: 'collection-multivitamins'
    },
    { tags: ['new'], title: 'NEW IN', className: 'collection-new-in' },
    { tags: ['sleep'], title: 'Sleep', className: 'collection-sleep-support' },
    { tags: ['eyes', 'vision'], title: 'Vision', className: 'collection-vision-support' },
    { tags: ['minerals'], title: 'Vitamins & Minerals', className: 'collection-vitamins-minerals' },
    { tags: ['weight'], title: 'Weight Management', className: 'collection-weight-management' },
    { tags: ['womens-formulas'], title: "Women's Formula's", className: 'collection-womens-formulas' }
  ];

  var productTagsCache = Object.create(null);
  var productTagsPending = Object.create(null);
  var collectionHandleMap = null;

  function normalizeTag(tag) {
    return String(tag || '')
      .trim()
      .toLowerCase();
  }

  function getCategoryFromTags(tags) {
    if (!tags || !tags.length) return null;
    var tagSet = Object.create(null);
    for (var i = 0; i < tags.length; i++) {
      var t = normalizeTag(tags[i]);
      if (t) tagSet[t] = true;
    }
    for (var j = 0; j < TAG_CATEGORY_MAP.length; j++) {
      var entry = TAG_CATEGORY_MAP[j];
      for (var k = 0; k < entry.tags.length; k++) {
        if (tagSet[normalizeTag(entry.tags[k])]) return entry;
      }
    }
    return null;
  }

  function getCollectionHandleMap() {
    if (collectionHandleMap) return collectionHandleMap;
    collectionHandleMap = Object.create(null);
    for (var i = 0; i < TAG_CATEGORY_MAP.length; i++) {
      var entry = TAG_CATEGORY_MAP[i];
      for (var t = 0; t < entry.tags.length; t++) {
        collectionHandleMap[normalizeTag(entry.tags[t])] = entry;
      }
      var slug = entry.className.replace(/^collection-/, '');
      collectionHandleMap[normalizeTag(slug)] = entry;
    }
    collectionHandleMap['blood-sugar-support'] = collectionHandleMap['blood-sugar'];
    collectionHandleMap['bones-joints-muscles'] = collectionHandleMap['bones'];
    collectionHandleMap['bones-musculoskeletal-health'] = collectionHandleMap['bones'];
    collectionHandleMap['gastrointestinal'] = collectionHandleMap['digestive'];
    collectionHandleMap['gut-health'] = collectionHandleMap['digestive'];
    collectionHandleMap['cardiometabolic-health-metabolism'] = collectionHandleMap['heart'];
    collectionHandleMap['cardiovascular-health'] = collectionHandleMap['heart'];
    collectionHandleMap['heart-metabolism'] = collectionHandleMap['heart'];
    collectionHandleMap['cellular-health-and-longevity'] = collectionHandleMap['cellular'];
    collectionHandleMap['children-s-formulas'] = collectionHandleMap['childrens-formulas'];
    collectionHandleMap['energy-and-fatigue'] = collectionHandleMap['energy'];
    collectionHandleMap['energy-fitness'] = collectionHandleMap['energy'];
    collectionHandleMap['fish-oils-omegas'] = collectionHandleMap['fish-oils'];
    collectionHandleMap['hormone-support'] = collectionHandleMap['hormone'];
    collectionHandleMap['immune-support'] = collectionHandleMap['immune'];
    collectionHandleMap['memory-mood'] = collectionHandleMap['mental-health'];
    collectionHandleMap['multivitamins-vitamins-minerals'] = collectionHandleMap['vitamins'];
    collectionHandleMap['new-products'] = collectionHandleMap['new'];
    collectionHandleMap['new-in'] = collectionHandleMap['new'];
    collectionHandleMap['vision'] = collectionHandleMap['vision'];
    return collectionHandleMap;
  }

  function formatSnizeCategoryTitle(title, handle) {
    var h = normalizeTag(handle);
    var t = normalizeTag(title);
    if (h === 'new' || h === 'new-products' || h === 'new-in' || t === 'new') {
      return 'NEW IN';
    }
    return title;
  }

  function getCategoryFromCollectionHandle(handle) {
    if (!handle) return null;
    var h = normalizeTag(handle);
    var map = getCollectionHandleMap();
    if (map[h]) return map[h];
    var keys = Object.keys(map).sort(function (a, b) {
      return b.length - a.length;
    });
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (key.length < 4) continue;
      if (h === key || h.indexOf(key + '-') === 0) return map[key];
    }
    return null;
  }

  function getCollectionTitleFromPage() {
    var selectors = [
      '.custom-collection-title-block',
      '.collection-title',
      'h1.collection-title',
      '[class*="collection-title"]',
      'h1'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (!el || !el.textContent) continue;
      var text = String(el.textContent).trim();
      if (text) return text;
    }
    return '';
  }

  function resolveSnizeCollectionContext() {
    var ctx = window.__snizeCollectionContext || { mode: 'tags', handle: '', title: '' };
    if (ctx.mode === 'collection' && ctx.handle) return ctx;
    var match = String(window.location.pathname || '').match(/\/collections\/([^/?#]+)/i);
    if (!match) return ctx;
    var handle = decodeURIComponent(match[1]).toLowerCase();
    if (handle === 'all' || handle === 'frontpage') {
      return { mode: 'tags', handle: '', title: '' };
    }
    return {
      mode: 'collection',
      handle: handle,
      title: (ctx.title && String(ctx.title).trim()) || getCollectionTitleFromPage() || ''
    };
  }

  function getSnizeCollectionPageCategory() {
    var ctx = resolveSnizeCollectionContext();
    if (!ctx || ctx.mode !== 'collection' || !ctx.handle) return null;
    var mapped = getCategoryFromCollectionHandle(ctx.handle);
    var title = formatSnizeCategoryTitle(
      (ctx.title && String(ctx.title).trim()) ||
        getCollectionTitleFromPage() ||
        (mapped && mapped.title) ||
        ctx.handle,
      ctx.handle
    );
    var handleClass =
      'collection-' + String(ctx.handle).toLowerCase().replace(/[^a-z0-9-]/g, '');
    return {
      title: title,
      className: (mapped && mapped.className) || handleClass || 'collection-default'
    };
  }

  function applyCategoryToCard(card, titleNode, parent, category) {
    if (!category || !category.title) {
      var existingEmpty = parent.querySelector('.custom-snize-collection-title');
      if (existingEmpty) existingEmpty.remove();
      return;
    }
    var existing = parent.querySelector('.custom-snize-collection-title');
    var node = existing;
    if (!node) {
      node = document.createElement('div');
      parent.insertBefore(node, titleNode);
    }
    node.className = 'custom-snize-collection-title ' + (category.className || 'collection-default');
    node.textContent = category.title;
  }

  function productHandleFromCard(card) {
    if (!card) return '';
    var links = card.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var m = String(links[i].getAttribute('href') || '').match(
        /\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)/i
      );
      if (m && m[1]) return decodeURIComponent(m[1]);
    }
    return '';
  }

  function fetchProductTags(handle, cb) {
    if (!handle) {
      cb([]);
      return;
    }
    if (productTagsCache[handle] !== undefined) {
      cb(productTagsCache[handle]);
      return;
    }
    if (productTagsPending[handle]) {
      productTagsPending[handle].push(cb);
      return;
    }
    productTagsPending[handle] = [cb];
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (product) {
        var tags = [];
        if (product && product.tags) {
          if (Array.isArray(product.tags)) {
            tags = product.tags;
          } else if (typeof product.tags === 'string') {
            tags = product.tags.split(',').map(function (t) {
              return t.trim();
            });
          }
        }
        productTagsCache[handle] = tags;
        var cbs = productTagsPending[handle];
        delete productTagsPending[handle];
        if (cbs) {
          for (var i = 0; i < cbs.length; i++) {
            try {
              cbs[i](tags);
            } catch (e) {}
          }
        }
      })
      .catch(function () {
        productTagsCache[handle] = [];
        var cbs = productTagsPending[handle];
        delete productTagsPending[handle];
        if (cbs) {
          for (var j = 0; j < cbs.length; j++) {
            try {
              cbs[j]([]);
            } catch (e2) {}
          }
        }
      });
  }

  function injectCardCategoryTitle(card) {
    var titleNode = card.querySelector('.snize-title');
    if (!titleNode || !titleNode.parentNode) return;

    var parent = titleNode.parentNode;
    var collectionCategory = getSnizeCollectionPageCategory();
    if (collectionCategory) {
      applyCategoryToCard(card, titleNode, parent, collectionCategory);
      return;
    }

    var handle = productHandleFromCard(card);
    if (!handle) return;

    fetchProductTags(handle, function (tags) {
      if (!card.isConnected || !titleNode.parentNode) return;
      var category = getCategoryFromTags(tags);
      if (category && category.title) {
        category = {
          title: formatSnizeCategoryTitle(category.title, ''),
          className: category.className
        };
      }
      applyCategoryToCard(card, titleNode, parent, category);
    });
  }

  function injectAllCategoryTitles() {
    var cards = document.querySelectorAll(
      '#snize-search-results-grid-mode li.snize-product, #snize-search-results-list-mode li.snize-product, #snize_results li.snize-product'
    );
    for (var i = 0; i < cards.length; i++) {
      injectCardCategoryTitle(cards[i]);
    }
  }

  function scheduleInjectAllCategoryTitles() {
    injectAllCategoryTitles();
    [100, 300, 700, 1400, 2500].forEach(function (ms) {
      setTimeout(injectAllCategoryTitles, ms);
    });
  }

  function initSnizeProductCategoryTitles() {
    scheduleInjectAllCategoryTitles();

    var snizeRoot = document.getElementById('snize_results');
    if (!snizeRoot || snizeRoot.__snizeCategoryTitlesObs) return;
    snizeRoot.__snizeCategoryTitlesObs = true;

    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        injectAllCategoryTitles();
      }, 80);
    });

    observer.observe(snizeRoot, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', initSnizeProductCategoryTitles);
  window.addEventListener('load', initSnizeProductCategoryTitles);
  document.addEventListener('Searchanise.Loaded', initSnizeProductCategoryTitles);
  if (window.__snizePlpReady && typeof window.__snizePlpReady.onReady === 'function') {
    window.__snizePlpReady.onReady(scheduleInjectAllCategoryTitles);
  }
})();




    document.addEventListener('Searchanise.Loaded', function () {
  (function ($) {

    $(document).on('Searchanise.AddToCartSuccess', function (event, add_to_cart_id, product) {
      // Fetch updated cart state, then fire Horizon's cart:update event
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                data: {
                  itemCount: cart.item_count,
                  source: 'product-form-component'
                }
              }
            })
          );
        });
    });

  })(window.Searchanise.$);
});

/* === product-unit === */

(function () {
  var QTY_SECTION = 'snize-qty-metafields';
  var QTY_FALLBACK = 'snize-variant-metafields';
  var LS_KEY = 'snize_qty_meta_v2';
  var LS_TTL_MS = 86400000;
  var FETCH_CONCURRENCY = 6;

  var metaCache = Object.create(null);
  var pendingCbs = Object.create(null);
  var lsSaveTimer = null;

  function shopifyRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/');
  }

  function loadMetaFromStorage() {
    try {
      localStorage.removeItem('snize_qty_meta_v1');
      var raw = localStorage.getItem(LS_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      if (!data || !data.handles || Date.now() - (data.ts || 0) > LS_TTL_MS) return;
      var map = data.handles;
      for (var h in map) {
        if (!Object.prototype.hasOwnProperty.call(map, h)) continue;
        if (map[h] && map[h].pillLabel) metaCache[h] = map[h];
      }
    } catch (e) {}
  }

  function scheduleMetaStorageSave() {
    if (lsSaveTimer) clearTimeout(lsSaveTimer);
    lsSaveTimer = setTimeout(function () {
      lsSaveTimer = null;
      try {
        var handles = Object.create(null);
        for (var k in metaCache) {
          if (!Object.prototype.hasOwnProperty.call(metaCache, k)) continue;
          if (metaCache[k] && metaCache[k].pillLabel) handles[k] = metaCache[k];
        }
        localStorage.setItem(LS_KEY, JSON.stringify({ ts: Date.now(), handles: handles }));
      } catch (e2) {}
    }, 250);
  }

  loadMetaFromStorage();

  function productHandleFromHref(href) {
    if (!href || typeof href !== 'string') return '';
    var m = href.match(/\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)/i);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function firstProductLink(scope) {
    if (!scope || !scope.querySelectorAll) return null;
    var links = scope.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      if (productHandleFromHref(links[i].getAttribute('href'))) return links[i];
    }
    return null;
  }

  function extractSectionInnerHtml(json, sectionId) {
    if (!json || typeof json !== 'object') return '';
    var raw = json[sectionId];
    if (!raw || typeof raw !== 'string') {
      for (var k in json) {
        if (!Object.prototype.hasOwnProperty.call(json, k)) continue;
        if (k === sectionId || k.indexOf(sectionId) !== -1) {
          raw = json[k];
          break;
        }
      }
    }
    if (!raw || typeof raw !== 'string') return '';
    var wrap = document.createElement('div');
    wrap.innerHTML = raw;
    var root = wrap.querySelector('[data-snize-qv-root]');
    return root ? root.innerHTML : raw;
  }

  function qtyHeading(units) {
    var u = String(units || '').trim();
    return u || 'Capsules';
  }

  function qtyPillLabel(qty, units) {
    var q = String(qty || '').trim();
    if (!q) return '';
    var u = qtyHeading(units);
    try {
      if (new RegExp('\\b' + u.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'i').test(q)) return q;
    } catch (e) {}
    return q + ' ' + u;
  }

  function parseQtyMeta(html) {
    if (!html) return null;
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var el = wrap.querySelector('[data-snize-qv-qty-metafield]');
    if (!el) return null;
    var qty = String(el.getAttribute('data-qty-text') || '').trim();
    var units = String(
      el.getAttribute('data-units-text') ||
        el.getAttribute('data-product-unit') ||
        el.getAttribute('data-units-heading') ||
        ''
    ).trim();
    if (!qty && !units) return null;
    return {
      qty: qty,
      units: units,
      heading: qtyHeading(units),
      pillLabel: qtyPillLabel(qty, units) || qtyHeading(units)
    };
  }

  function fetchSection(handle, sectionId) {
    var url =
      shopifyRoot() +
      'products/' +
      encodeURIComponent(handle) +
      '?sections=' +
      encodeURIComponent(sectionId);
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : {};
      })
      .then(function (json) {
        return extractSectionInnerHtml(json, sectionId) || '';
      })
      .catch(function () {
        return '';
      });
  }

function fetchProductPageHtml(handle) {
  var url = shopifyRoot() + 'products/' + encodeURIComponent(handle);
  var tid = (window.location.search.match(/[?&]preview_theme_id=(\d+)/) || [])[1];
  if (tid) url += (url.indexOf('?') === -1 ? '?' : '&') + 'preview_theme_id=' + tid;
  return fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
    .then(function (r) {
      return r.ok ? r.text() : '';
    })
    .catch(function () {
      return '';
    });
}

  function fetchQtyMetaNetwork(handle) {
    return fetchSection(handle, QTY_SECTION).then(function (html) {
      var meta = parseQtyMeta(html);
      if (meta && meta.pillLabel) return meta;
      return fetchSection(handle, QTY_FALLBACK).then(function (html2) {
        meta = parseQtyMeta(html2);
        if (meta && meta.pillLabel) return meta;
        return fetchProductPageHtml(handle).then(function (pageHtml) {
          return parseQtyMeta(pageHtml);
        });
      });
    });
  }

  function finishQtyFetch(handle, meta) {
    if (meta && meta.pillLabel) {
      metaCache[handle] = meta;
      scheduleMetaStorageSave();
      applyMetaToAllCards(handle, meta);
    }
    var list = pendingCbs[handle];
    delete pendingCbs[handle];
    var result = meta && meta.pillLabel ? meta : null;
    if (list) {
      for (var i = 0; i < list.length; i++) {
        try {
          list[i](result);
        } catch (e) {}
      }
    }
    return result;
  }

  function requestQtyMeta(handle) {
    if (!handle) return Promise.resolve(null);
    if (metaCache[handle]) return Promise.resolve(metaCache[handle]);
    if (pendingCbs[handle]) {
      return new Promise(function (resolve) {
        pendingCbs[handle].push(resolve);
      });
    }
    pendingCbs[handle] = [];
    return fetchQtyMetaNetwork(handle)
      .then(function (meta) {
        return finishQtyFetch(handle, meta);
      })
      .catch(function () {
        return finishQtyFetch(handle, null);
      });
  }

  function prewarmHandles(handles) {
    var queue = [];
    for (var i = 0; i < handles.length; i++) {
      var h = handles[i];
      if (!h || metaCache[h] || pendingCbs[h]) continue;
      queue.push(h);
    }
    var idx = 0;
    function runBatch() {
      var batch = queue.slice(idx, idx + FETCH_CONCURRENCY);
      idx += FETCH_CONCURRENCY;
      if (!batch.length) return;
      Promise.all(batch.map(requestQtyMeta)).then(function () {
        if (idx < queue.length) runBatch();
      });
    }
    runBatch();
  }

  function countRealPills(box) {
    if (!box || box.getAttribute('data-snize-qty-variant') === '1') return 0;
    var nodes = box.querySelectorAll('.snize-size, .snize-product-swatches-option');
    var n = 0;
    for (var i = 0; i < nodes.length; i++) {
      if (String(nodes[i].textContent || '').trim()) n++;
    }
    return n;
  }

  function cardHasMultiVariants(card) {
    if (!card) return false;
    var boxes = card.querySelectorAll('.snize-size-select-box');
    var total = 0;
    for (var i = 0; i < boxes.length; i++) {
      total += countRealPills(boxes[i]);
      if (total > 1) return true;
    }
    return false;
  }

  function ensureQtyBox(card) {
    var box = card.querySelector('.snize-size-select-box[data-snize-qty-variant="1"]');
    if (box) return box;
    var empty = card.querySelector('.snize-size-select-box.snize-option-count-0');
    if (empty && countRealPills(empty) === 0) {
      empty.setAttribute('data-snize-qty-variant', '1');
      return empty;
    }
    box = document.createElement('div');
    box.className = 'snize-size-select-box snize-shape-square';
    box.setAttribute('data-snize-qty-variant', '1');
    box.setAttribute('role', 'radiogroup');
    var anchor =
      card.querySelector('.snize-buttons') ||
      card.querySelector('.snize-price-list') ||
      card.querySelector('.snize-price');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor);
    else card.appendChild(box);
    return box;
  }

  function fillQtyBox(box, meta) {
    if (!box || !meta || !meta.pillLabel) return;
    box.classList.remove('snize-option-count-0');
    box.classList.add('snize-option-count-1', 'snize-shape-square');
    box.setAttribute('aria-label', 'Select ' + meta.heading);
    box.innerHTML = '';
    var pill = document.createElement('div');
    pill.className = 'snize-size snize-size-active snize-active';
    pill.setAttribute('data-snize-qty-pill', '1');
    pill.setAttribute('role', 'radio');
    pill.setAttribute('aria-checked', 'true');
    pill.textContent = meta.pillLabel;
    box.appendChild(pill);
    box.setAttribute('data-snize-qty-ready', '1');
  }

  function injectCardQty(card, handle, meta) {
    if (!card || !meta || !meta.pillLabel || cardHasMultiVariants(card)) return;
    var existing = card.querySelector('[data-snize-qty-pill]');
    if (existing && String(existing.textContent || '').trim() === meta.pillLabel) return;
    fillQtyBox(ensureQtyBox(card), meta);
    card.setAttribute('data-snize-qty-done', handle);
  }

  function getCards() {
    return document.querySelectorAll(
      '#snize-search-results-grid-mode li.snize-product, #snize-search-results-list-mode li.snize-product, #snize_results li.snize-product'
    );
  }

  function snizeHandleFromCard(card) {
    var link = firstProductLink(card);
    return link ? productHandleFromHref(link.getAttribute('href')) : '';
  }

  function applyMetaToAllCards(handle, meta) {
    if (!meta || !meta.pillLabel) return;
    var cards = getCards();
    for (var i = 0; i < cards.length; i++) {
      var h = snizeHandleFromCard(cards[i]);
      if (h === handle) injectCardQty(cards[i], handle, meta);
    }
    injectQuickViewQty(handle, meta);
  }

  function injectQuickViewQty(handle, meta) {
    var modal = document.getElementById('snize-modal-product-quick-view');
    if (!modal || !meta || !meta.pillLabel) return;
    var h = snizeHandleFromCard(modal);
    if (h && h !== handle) return;
    var realCount = 0;
    var boxes = modal.querySelectorAll('.snize-size-select-box:not([data-snize-qty-variant])');
    for (var i = 0; i < boxes.length; i++) realCount += countRealPills(boxes[i]);
    if (realCount > 1) return;
    var box =
      modal.querySelector('.snize-size-select-box[data-snize-qty-variant="1"]') ||
      modal.querySelector('.snize-size-select-box.snize-option-count-0') ||
      modal.querySelector('.snize-size-select-box');
    if (!box) {
      box = document.createElement('div');
      box.className = 'snize-size-select-box snize-shape-square';
      box.setAttribute('data-snize-qty-variant', '1');
      var price = modal.querySelector('.snize-quick-view-price-wrapper');
      if (price && price.parentNode) price.parentNode.insertBefore(box, price);
      else {
        var qvRight = modal.querySelector('.snize-quick-view-content-right');
        if (qvRight) qvRight.appendChild(box);
      }
    }
    box.setAttribute('data-snize-qty-variant', '1');
    var labelEl = document.createElement('label');
    labelEl.textContent = meta.heading;
    box.innerHTML = '';
    box.appendChild(labelEl);
    var pillsWrap = document.createElement('div');
    pillsWrap.className = 'snize-qv-qty-pills';
    box.appendChild(pillsWrap);
    var pill = document.createElement('div');
    pill.className = 'snize-size snize-size-active snize-active';
    pill.setAttribute('data-snize-qty-pill', '1');
    pill.textContent = meta.pillLabel;
    pillsWrap.appendChild(pill);
    box.setAttribute('data-snize-qty-ready', '1');
  }

  function collectQtyHandles() {
    var cards = getCards();
    var need = [];
    var seen = Object.create(null);
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (cardHasMultiVariants(card)) continue;
      var handle = snizeHandleFromCard(card);
      if (!handle || seen[handle]) continue;
      seen[handle] = true;
      var cached = metaCache[handle];
      if (cached) {
        injectCardQty(card, handle, cached);
        continue;
      }
      need.push(handle);
    }
    return need;
  }

  function enhanceQtyCards() {
    var need = collectQtyHandles();
    if (need.length) prewarmHandles(need);
    var modal = document.getElementById('snize-modal-product-quick-view');
    if (modal) {
      var mh = snizeHandleFromCard(modal);
      if (mh) {
        if (metaCache[mh]) injectQuickViewQty(mh, metaCache[mh]);
        else requestQtyMeta(mh);
      }
    }
  }

  var timer = null;
  function scheduleEnhance() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      enhanceQtyCards();
    }, 60);
  }

  function runEnhancePasses() {
    enhanceQtyCards();
    setTimeout(enhanceQtyCards, 400);
    setTimeout(enhanceQtyCards, 1200);
  }

  document.addEventListener('DOMContentLoaded', runEnhancePasses);
  window.addEventListener('load', runEnhancePasses);
  document.addEventListener('Searchanise.Loaded', runEnhancePasses);

  var root = document.getElementById('snize_results');
  if (root) new MutationObserver(scheduleEnhance).observe(root, { childList: true, subtree: true });

  document.addEventListener(
    'mouseover',
    function (e) {
      var card = e.target && e.target.closest && e.target.closest('li.snize-product, .snize-product');
      if (!card || cardHasMultiVariants(card)) return;
      var handle = snizeHandleFromCard(card);
      if (!handle || metaCache[handle] || pendingCbs[handle]) return;
      requestQtyMeta(handle);
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      if (e.target && e.target.closest && e.target.closest('li.snize-product, .snize-product')) {
        scheduleEnhance();
      }
    },
    true
  );
})();

/* === qv-extra-images === */

(function () {
  'use strict';

  var MODAL_ID = 'snize-modal-product-quick-view';
  var EXTRAS_LS_KEY = 'snize_pdp_extras_v1';
  var EXTRAS_SECTION = 'snize-pdp-extra-images-config';
  var THUMB_SIZE = 60;
  var THUMB_GAP = 10;
  var THUMB_VISIBLE = 4;
  var THUMB_STEP = THUMB_SIZE + THUMB_GAP;

  var THUMB_PREV_SVG =
    '<svg viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M1 8.5 9 1.5l8 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var THUMB_NEXT_SVG =
    '<svg viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M1 1.5 9 8.5l8-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var extrasCache = null;
  var extrasPending = null;
  var applyTimer = null;
  var modalObserver = null;
  var watchedModal = null;
  var applyGen = 0;
  var layoutLock = false;
  var suppressScheduleUntil = 0;
  var observerDebounce = null;

  function normalizeUrl(u) {
    if (!u) return '';
    var s = String(u).trim();
    if (s.indexOf('//') === 0) s = 'https:' + s;
    return s;
  }

  function thumbUrl(u) {
    var abs = normalizeUrl(u);
    if (!abs || abs.indexOf('cdn.shopify.com') === -1) return abs;
    if (/[?&]width=/.test(abs)) return abs;
    return abs + (abs.indexOf('?') >= 0 ? '&' : '?') + 'width=120';
  }

  function previewUrl(u, width) {
    var abs = normalizeUrl(u);
    if (!abs) return '';
    if (abs.indexOf('cdn.shopify.com') === -1) return abs;
    try {
      var parsed = new URL(abs);
      parsed.searchParams.delete('width');
      parsed.searchParams.delete('height');
      parsed.searchParams.set('width', String(width || 900));
      return parsed.toString();
    } catch (e) {
      var base = abs.split('?')[0];
      return base + '?width=' + (width || 900);
    }
  }

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function resolveHandle(modal) {
    if (!modal) return '';
    var link = modal.querySelector('a[href*="/products/"]');
    if (link) {
      var href = link.getAttribute('href') || '';
      var m = href.match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    return '';
  }

  function extrasFromStorage() {
    try {
      var raw = localStorage.getItem(EXTRAS_LS_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function saveExtrasToStorage(items) {
    if (!items || !items.length) return;
    try {
      localStorage.setItem(EXTRAS_LS_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function parseSectionHtml(html) {
    var doc = new DOMParser().parseFromString(html || '', 'text/html');
    var node = doc.querySelector('[data-snize-pdp-extra-images]');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent || '[]');
      return Array.isArray(parsed) ? parsed.filter(function (x) { return x && x.url; }) : [];
    } catch (e) {
      return [];
    }
  }

  function parseProductPageHtml(html) {
    var out = [];
    var seen = Object.create(null);
    if (!html) return out;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nodes = doc.querySelectorAll('[data-snize-pdp-extra-url]');
    for (var i = 0; i < nodes.length; i++) {
      var u = normalizeUrl(nodes[i].getAttribute('data-snize-pdp-extra-url') || '');
      if (!u || seen[u]) continue;
      seen[u] = true;
      var img = nodes[i].querySelector('img');
      out.push({ url: u, alt: (img && img.alt) || '' });
    }
    return out;
  }

  function fetchFromSectionApi(cb) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?sections=' + encodeURIComponent(EXTRAS_SECTION), { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : {};
      })
      .then(function (json) {
        cb(parseSectionHtml(json[EXTRAS_SECTION] || ''));
      })
      .catch(function () {
        cb([]);
      });
  }

  function fetchFromProductPage(handle, cb) {
    if (!handle) {
      cb([]);
      return;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        cb(parseProductPageHtml(html));
      })
      .catch(function () {
        cb([]);
      });
  }

  function deliverExtras(items, queue) {

    if (items && items.length) extrasCache = items;
    var payload = items && items.length ? items : [];
    for (var i = 0; i < queue.length; i++) {
      try {
        queue[i](payload);
      } catch (e) {}
    }
  }

  function fetchExtraImages(handle, cb) {
    if (typeof handle === 'function') {
      cb = handle;
      handle = '';
    }
    if (typeof cb !== 'function') {
      cb = function () {};
    }

    if (extrasCache && extrasCache.length) {
      cb(extrasCache);
      return;
    }
    var fromLs = extrasFromStorage();
    if (fromLs && fromLs.length) {
      extrasCache = fromLs;
      cb(fromLs);
      return;
    }
    if (extrasPending) {
      extrasPending.push({ handle: handle, cb: cb });
      return;
    }
    extrasPending = [{ handle: handle, cb: cb }];

    function finish(items) {
      var queue = extrasPending || [];
      extrasPending = null;
      if (items && items.length) saveExtrasToStorage(items);
      deliverExtras(items, queue.map(function (q) { return q.cb; }));
    }

    function trySectionFallback() {
      fetchFromSectionApi(function (fromSection) {
        finish(fromSection && fromSection.length ? fromSection : []);
      });
    }

    if (handle) {
      fetchFromProductPage(handle, function (fromPdp) {
        if (fromPdp && fromPdp.length) {
          finish(fromPdp);
          return;
        }
        trySectionFallback();
      });
      return;
    }

    trySectionFallback();
  }

  function isMobile() {
    try {
      return window.matchMedia('(max-width: 766px)').matches;
    } catch (e) {
      return window.innerWidth <= 766;
    }
  }

  function ensureMobileImageSlot(wrap) {
    if (!wrap || !isMobile()) return;
    wrap.setAttribute('data-snize-qv-mobile-slot', '1');
  }

  function cleanupMobileStrays(modal, gallery) {
    if (!modal || !gallery) return;
    var keepScroller = gallery.querySelector('[data-snize-qv-thumb-scroller]');
    var stripInGallery = keepScroller
      ? keepScroller.querySelector('.snize-quick-view-thumbnails')
      : gallery.querySelector('.snize-quick-view-thumbnails');

    modal.querySelectorAll('.snize-quick-view-thumbnails').forEach(function (strip) {
      if (strip === stripInGallery) return;
      if (!stripInGallery) {
        if (keepScroller) {
          var vp = keepScroller.querySelector('.snize-qv-thumb-scroller__viewport');
          (vp || keepScroller).appendChild(strip);
        } else {
          gallery.appendChild(strip);
        }
        stripInGallery = strip;
        return;
      }
      while (strip.firstChild) stripInGallery.appendChild(strip.firstChild);
      var orphanScroller = strip.closest('[data-snize-qv-thumb-scroller]');
      strip.remove();
      if (orphanScroller && !gallery.contains(orphanScroller)) orphanScroller.remove();
    });

    modal.querySelectorAll('[data-snize-qv-thumb-scroller]').forEach(function (scroller) {
      if (gallery.contains(scroller)) return;
      var orphanStrip = scroller.querySelector('.snize-quick-view-thumbnails');
      if (orphanStrip && stripInGallery && orphanStrip !== stripInGallery) {
        while (orphanStrip.firstChild) stripInGallery.appendChild(orphanStrip.firstChild);
      } else if (orphanStrip && !stripInGallery) {
        gallery.appendChild(scroller);
        return;
      }
      scroller.remove();
    });
  }

  function ensureMobileGallery(modal) {
    if (!modal) return null;
    var left = modal.querySelector('.snize-quick-view-content-left');
    if (!left) return null;

    var gallery = left.querySelector('[data-snize-qv-mobile-gallery]');
    if (!gallery) {
      gallery = document.createElement('div');
      gallery.className = 'snize-qv-mobile-gallery';
      gallery.setAttribute('data-snize-qv-mobile-gallery', '');
      left.insertBefore(gallery, left.firstChild);
    }

    var wrap = modal.querySelector('.snize-quick-view-image-wrapper');
    if (wrap && wrap.parentNode !== gallery) gallery.appendChild(wrap);

    var scroller = modal.querySelector('[data-snize-qv-thumb-scroller]');
    if (scroller && scroller.parentNode !== gallery) gallery.appendChild(scroller);

    cleanupMobileStrays(modal, gallery);
    return gallery;
  }

  function getThumbScrollerEl(modal) {
    if (!modal) return null;
    return (
      modal.querySelector('.snize-qv-mobile-gallery [data-snize-qv-thumb-scroller]') ||
      modal.querySelector('[data-snize-qv-thumb-scroller]')
    );
  }

  function getThumbViewportEl(modal) {
    var scroller = getThumbScrollerEl(modal);
    return scroller ? getViewport(scroller) : null;
  }

  function getThumbViewportScroll(modal) {
    var vp = getThumbViewportEl(modal);
    if (!vp) return 0;
    return isMobile() ? vp.scrollLeft : vp.scrollTop;
  }

  function restoreThumbViewportScroll(modal, scrollPos) {
    if (!modal || scrollPos == null || scrollPos < 0) return;
    var vp = getThumbViewportEl(modal);
    if (!vp) return;
    if (isMobile()) {
      vp.scrollLeft = scrollPos;
    } else {
      vp.scrollTop = scrollPos;
    }
  }

  function scrollThumbIntoView(li) {
    if (!li || !isMobile()) return;
    var vp = li.closest('.snize-qv-thumb-scroller__viewport');
    if (!vp) return;
    try {
      var target = li.offsetLeft - (vp.clientWidth - li.offsetWidth) / 2;
      var maxScroll = Math.max(0, vp.scrollWidth - vp.clientWidth);
      vp.scrollLeft = Math.max(0, Math.min(target, maxScroll));
    } catch (e) {
      try {
        li.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'auto' });
      } catch (e2) {}
    }
  }

  function syncMobileMainPreview(modal, skipLayout) {
    if (!modal || !isMobile()) return;
    var url = modal.getAttribute('data-snize-qv-custom-preview-url') || '';
    if (!url) return;
    if (modal.getAttribute('data-snize-qv-custom-preview') === '1') {
      showMobileMainPreview(modal, url, null, skipLayout);
    }
  }

  function applyMobileLayout(modal) {
    if (!modal || layoutLock) return;
    var mobile = isMobile();
    modal.classList.toggle('snize-qv-mobile-layout', mobile);
    if (!mobile) return;

    var savedScroll = getThumbViewportScroll(modal);

    layoutLock = true;
    try {
      var strip = modal.querySelector('.snize-quick-view-thumbnails');
      if (strip && !modal.querySelector('[data-snize-qv-thumb-scroller]')) {
        ensureThumbScroller(modal);
      }

      var gallery = ensureMobileGallery(modal);
      if (gallery) {
        var wrap = modal.querySelector('.snize-quick-view-image-wrapper');
        if (wrap) {
          ensureMobileImageSlot(wrap);
          gallery.appendChild(wrap);
        }
        var scroller = modal.querySelector('[data-snize-qv-thumb-scroller]');
        if (scroller) gallery.appendChild(scroller);
        cleanupMobileStrays(modal, gallery);
      }
      restoreThumbViewportScroll(modal, savedScroll);
      syncMobileMainPreview(modal, true);
      updateScrollerState(modal);
      requestAnimationFrame(function () {
        restoreThumbViewportScroll(modal, savedScroll);
        updateScrollerState(modal);
      });
    } finally {
      layoutLock = false;
    }
  }

  function countVisibleThumbs(strip) {
    var n = 0;
    var kids = strip.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el.nodeType !== 1) continue;
      if (el.getAttribute('data-snize-qv-media-hidden') === '1') continue;
      try {
        if (window.getComputedStyle(el).display === 'none') continue;
      } catch (e2) {}
      n++;
    }
    return n;
  }

  function normalizeThumbLi(li) {
    if (!li || li.getAttribute('data-snize-qv-media-hidden') === '1') return;
    li.style.setProperty('position', 'relative', 'important');
    li.style.setProperty('top', 'auto', 'important');
    li.style.setProperty('left', 'auto', 'important');
    li.style.setProperty('float', 'none', 'important');
    li.style.setProperty('display', 'flex', 'important');
    li.style.setProperty('width', THUMB_SIZE + 'px', 'important');
    li.style.setProperty('height', THUMB_SIZE + 'px', 'important');
    li.style.setProperty('min-height', THUMB_SIZE + 'px', 'important');
    li.style.setProperty('margin', '0', 'important');
    li.style.setProperty('visibility', 'visible', 'important');
    li.style.setProperty('opacity', '1', 'important');
  }

  function normalizeStrip(strip) {
    if (!strip) return;
    strip.style.setProperty('transform', 'none', 'important');
    strip.style.setProperty('height', 'auto', 'important');
    strip.style.setProperty('position', 'relative', 'important');
    var kids = strip.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].nodeType === 1) normalizeThumbLi(kids[i]);
    }
  }

  function getViewport(scroller) {
    return scroller ? scroller.querySelector('.snize-qv-thumb-scroller__viewport') : null;
  }

  function updateScrollerState(modal) {
    var scroller = modal.querySelector('[data-snize-qv-thumb-scroller]');
    if (!scroller) return;
    var strip = scroller.querySelector('.snize-quick-view-thumbnails');
    var vp = getViewport(scroller);
    var prev = scroller.querySelector('.snize-qv-thumb-scroller__btn--prev');
    var next = scroller.querySelector('.snize-qv-thumb-scroller__btn--next');
    if (!strip) return;

    var mobile = isMobile();
    scroller.classList.toggle('snize-qv-thumb-scroller--horizontal', mobile);
    var count = countVisibleThumbs(strip);
    var needsArrows = count > THUMB_VISIBLE;
    scroller.classList.toggle('snize-qv-thumb-scroller--no-arrows', !needsArrows);

    if (!vp) {
      if (prev) prev.disabled = !needsArrows;
      if (next) next.disabled = !needsArrows;
      return;
    }

    if (mobile) {
      var maxX = Math.max(0, vp.scrollWidth - vp.clientWidth);
      if (prev) prev.disabled = !needsArrows || vp.scrollLeft <= 1;
      if (next) next.disabled = !needsArrows || vp.scrollLeft >= maxX - 1;
    } else {
      var maxY = Math.max(0, vp.scrollHeight - vp.clientHeight);
      if (prev) prev.disabled = !needsArrows || vp.scrollTop <= 1;
      if (next) next.disabled = !needsArrows || vp.scrollTop >= maxY - 1;
    }
  }

  function ensureThumbScroller(modal) {
    var strip = modal.querySelector('.snize-quick-view-thumbnails');
    if (!strip) return;

    var scroller = strip.closest('[data-snize-qv-thumb-scroller]');
    if (!scroller) {
      scroller = document.createElement('div');
      scroller.className = 'snize-qv-thumb-scroller';
      scroller.setAttribute('data-snize-qv-thumb-scroller', '');

      var btnPrev = document.createElement('button');
      btnPrev.type = 'button';
      btnPrev.className = 'snize-qv-thumb-scroller__btn snize-qv-thumb-scroller__btn--prev';
      btnPrev.setAttribute('aria-label', 'Previous thumbnails');
      btnPrev.innerHTML = THUMB_PREV_SVG;

      var viewport = document.createElement('div');
      viewport.className = 'snize-qv-thumb-scroller__viewport';

      var btnNext = document.createElement('button');
      btnNext.type = 'button';
      btnNext.className = 'snize-qv-thumb-scroller__btn snize-qv-thumb-scroller__btn--next';
      btnNext.setAttribute('aria-label', 'Next thumbnails');
      btnNext.innerHTML = THUMB_NEXT_SVG;

      var parent = strip.parentNode;
      if (!parent) return;
      parent.insertBefore(scroller, strip);
      scroller.appendChild(btnPrev);
      scroller.appendChild(viewport);
      viewport.appendChild(strip);
      scroller.appendChild(btnNext);

      viewport.scrollTop = 0;
      viewport.scrollLeft = 0;
    }

    if (scroller.getAttribute('data-snize-qv-extra-scroller-bound') !== '1') {
      scroller.setAttribute('data-snize-qv-extra-scroller-bound', '1');
      var btnPrevBound = scroller.querySelector('.snize-qv-thumb-scroller__btn--prev');
      var btnNextBound = scroller.querySelector('.snize-qv-thumb-scroller__btn--next');
      var vpBound = getViewport(scroller);
      var page = THUMB_STEP * THUMB_VISIBLE;

      btnPrevBound.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var vp = getViewport(scroller);
        if (!vp) return;
        if (isMobile()) {
          vp.scrollTo({ left: Math.max(0, vp.scrollLeft - page), behavior: 'smooth' });
        } else {
          vp.scrollTo({ top: Math.max(0, vp.scrollTop - page), behavior: 'smooth' });
        }
      });

      btnNextBound.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var vp = getViewport(scroller);
        if (!vp) return;
        if (isMobile()) {
          var maxX = Math.max(0, vp.scrollWidth - vp.clientWidth);
          vp.scrollTo({ left: Math.min(maxX, vp.scrollLeft + page), behavior: 'smooth' });
        } else {
          var maxY = Math.max(0, vp.scrollHeight - vp.clientHeight);
          vp.scrollTo({ top: Math.min(maxY, vp.scrollTop + page), behavior: 'smooth' });
        }
      });

      vpBound.addEventListener('scroll', function () {
        updateScrollerState(modal);
      });

      if (!window.__snizeQvExtraResizeBound) {
        window.__snizeQvExtraResizeBound = true;
        window.addEventListener('resize', function () {
          var m = getModal();
          if (m) {
            applyMobileLayout(m);
            updateScrollerState(m);
            syncMobileMainPreview(m);
          }
        });
      }
    }

    normalizeStrip(strip);
    strip.setAttribute('data-snize-qv-ready', '1');
    if (!layoutLock) applyMobileLayout(modal);
    updateScrollerState(modal);
  }

  function buildExtraThumb(item) {
    var fullUrl = normalizeUrl(item.url);
    var url = thumbUrl(item.url);
    var li = document.createElement('li');
    li.className = 'snize-quick-view-thumbnail snize-qv-pdp-extra';
    li.setAttribute('data-snize-qv-pdp-extra-thumb', '');
    li.setAttribute('data-snize-qv-thumb-url', fullUrl);
    var anchor = document.createElement('a');
    anchor.setAttribute('href', '#');
    var img = document.createElement('img');
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = item.alt || '';
    img.src = url;
    anchor.appendChild(img);
    li.appendChild(anchor);
    return li;
  }

  function removeExtraThumbs(strip) {
    strip.querySelectorAll('[data-snize-qv-pdp-extra-thumb]').forEach(function (node) {
      node.remove();
    });
  }

  // Thumbnail for the product's own (native) main image. Used when we have to
  // build a thumbnails strip from scratch for single-image products so the
  // shopper can switch back from an extra image to the main product image.
  function buildNativeThumb(url, alt) {
    var full = normalizeUrl(url);
    var li = document.createElement('li');
    li.className = 'snize-quick-view-thumbnail snize-qv-native-thumb active snize-active';
    li.setAttribute('data-snize-qv-native-thumb', '');
    li.setAttribute('data-snize-qv-thumb-url', full);
    var anchor = document.createElement('a');
    anchor.setAttribute('href', '#');
    var img = document.createElement('img');
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = alt || '';
    img.src = thumbUrl(url);
    anchor.appendChild(img);
    li.appendChild(anchor);
    return li;
  }

  // Single-image products (e.g. zero-variant products) get no native
  // `.snize-quick-view-thumbnails` strip from Searchanise, which means extra
  // product images + thumbnail controls never render. Create one, seeded with a
  // thumbnail of the main product image, placed next to the image like the
  // native strip would be.
  function createGeneratedThumbStrip(modal) {
    var wrap = modal.querySelector('.snize-quick-view-image-wrapper');
    if (!wrap) return null;
    var strip = document.createElement('ul');
    strip.className = 'snize-quick-view-thumbnails snize-qv-generated-thumbnails';
    strip.setAttribute('data-snize-qv-generated', '1');

    var mainImg = getNativeMainSlide(wrap) || pickMainImg(wrap);
    var mainUrl = '';
    if (mainImg) {
      mainUrl =
        mainImg.getAttribute('data-src') ||
        mainImg.getAttribute('data-original') ||
        mainImg.currentSrc ||
        mainImg.src ||
        '';
    }
    if (mainUrl) {
      strip.appendChild(buildNativeThumb(mainUrl, mainImg && mainImg.alt));
    }
    // Match the native layout: the thumbnails strip must be a DIRECT child of
    // `.snize-quick-view-content-left` (a flex row) so it sits parallel to the
    // main image instead of stacking below it. The image wrapper can be nested
    // deeper, so walk up to the content-left's direct child and insert alongside.
    var left = modal.querySelector('.snize-quick-view-content-left');
    if (left) {
      var reference = wrap;
      while (reference && reference.parentNode !== left) {
        reference = reference.parentNode;
      }
      if (reference && reference.parentNode === left) {
        left.insertBefore(strip, reference.nextSibling);
      } else {
        left.appendChild(strip);
      }
    } else if (wrap.parentNode) {
      wrap.parentNode.insertBefore(strip, wrap.nextSibling);
    } else {
      modal.appendChild(strip);
    }
    return strip;
  }


  function thumbUrlFromLi(li) {
    if (!li) return '';
    var forced = li.getAttribute('data-snize-qv-thumb-url') || '';
    if (forced) return normalizeUrl(forced);
    var img = li.querySelector('img');
    if (img) {
      var fromImg =
        img.getAttribute('data-src') ||
        img.getAttribute('data-original') ||
        img.currentSrc ||
        img.src ||
        '';
      if (fromImg) return normalizeUrl(fromImg);
    }
    var anchor = li.querySelector('a');
    if (anchor) {
      var bg = anchor.style.backgroundImage || '';
      if (!bg) {
        try {
          bg = window.getComputedStyle(anchor).backgroundImage || '';
        } catch (e) {}
      }
      var m = bg.match(/url\(["']?([^"')]+)["']?\)/i);
      if (m && m[1]) return normalizeUrl(m[1]);
    }
    return '';
  }

  function pickMainImg(wrap) {
    if (!wrap) return null;
    var byClass =
      wrap.querySelector('.snize-quick-view-main-image img') ||
      wrap.querySelector('.snize-quick-view-image-main img') ||
      wrap.querySelector('.snize-quick-view-image:not(.snize-hidden) img') ||
      wrap.querySelector('.snize-quick-view-image.active img') ||
      wrap.querySelector('.snize-quick-view-image.snize-active img') ||
      wrap.querySelector('.snize-quick-view-image img:not([data-snize-qv-main-preview-img])') ||
      wrap.querySelector('picture img:not([data-snize-qv-main-preview-img])');
    if (byClass) return byClass;
    var imgs = wrap.querySelectorAll('img[src]:not([data-snize-qv-main-preview-img])');
    var best = null;
    var bestArea = 0;
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.closest('[data-snize-qv-main-preview]')) continue;
      var r = img.getBoundingClientRect();
      var area = r.width * r.height;
      if (area < 25) continue;
      if (area > bestArea) {
        bestArea = area;
        best = img;
      }
    }
    return best || wrap.querySelector('img:not([data-snize-qv-main-preview-img])');
  }

  function setMainImageSrc(img, url) {
    if (!img || !url) return;
    var abs = previewUrl(url, 900);
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = abs;
    img.style.setProperty('display', 'block', 'important');
    img.style.removeProperty('visibility');
    img.style.removeProperty('opacity');
    var pic = img.closest('picture');
    if (pic) {
      var sources = pic.querySelectorAll('source');
      for (var si = 0; si < sources.length; si++) sources[si].remove();
    }
    var slide = img.closest('.snize-quick-view-image, .snize-quick-view-image-item');
    if (slide) {
      slide.removeAttribute('data-snize-qv-slide-suppressed');
      slide.style.removeProperty('display');
      slide.style.removeProperty('visibility');
      slide.style.removeProperty('opacity');
    }
  }

  function getNativeMainSlide(wrap) {
    if (!wrap) return null;
    var slides = wrap.querySelectorAll('.snize-quick-view-image');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-snize-qv-media-hidden') === '1') continue;
      var slideImg = slides[i].querySelector('img:not([data-snize-qv-main-preview-img])');
      if (slideImg) return slideImg;
      if (slides[i].tagName === 'IMG') return slides[i];
    }
    return pickMainImg(wrap);
  }

  function restoreNativeSlides(wrap) {
    if (!wrap) return;
    wrap.removeAttribute('data-snize-qv-using-preview');
    wrap.querySelectorAll('.snize-quick-view-image[data-snize-qv-slide-suppressed="1"]').forEach(function (slide) {
      slide.removeAttribute('data-snize-qv-slide-suppressed');
      slide.style.removeProperty('display');
      slide.style.removeProperty('opacity');
      slide.style.removeProperty('visibility');
      slide.style.removeProperty('pointer-events');
      slide.style.removeProperty('position');
      slide.style.removeProperty('width');
      slide.style.removeProperty('height');
      slide.style.removeProperty('overflow');
      slide.style.removeProperty('margin');
      slide.style.removeProperty('padding');
    });
    wrap.querySelectorAll('.snize-quick-view-image').forEach(function (slide) {
      if (slide.getAttribute('data-snize-qv-media-hidden') === '1') {
        slide.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function hideNativeSlidesForPreview(wrap) {
    if (!wrap || !isMobile()) return;
    wrap.setAttribute('data-snize-qv-using-preview', '1');
    wrap.querySelectorAll('.snize-quick-view-image').forEach(function (slide) {
      slide.setAttribute('data-snize-qv-slide-suppressed', '1');
      slide.style.setProperty('opacity', '0', 'important');
      slide.style.setProperty('visibility', 'hidden', 'important');
      slide.style.setProperty('pointer-events', 'none', 'important');
      slide.style.setProperty('position', 'absolute', 'important');
      slide.style.setProperty('width', '1px', 'important');
      slide.style.setProperty('height', '1px', 'important');
      slide.style.setProperty('overflow', 'hidden', 'important');
    });
  }

  function ensureMainPreviewLayer(wrap) {
    if (!wrap) return null;
    wrap.style.position = 'relative';
    var layer = wrap.querySelector('[data-snize-qv-main-preview]');
    if (!layer) {
      layer = document.createElement('div');
      layer.setAttribute('data-snize-qv-main-preview', '');
      var previewImg = document.createElement('img');
      previewImg.setAttribute('data-snize-qv-main-preview-img', '');
      previewImg.alt = '';
      layer.appendChild(previewImg);
      wrap.appendChild(layer);
    }
    return layer;
  }

  function showDesktopMainPreview(modal, url) {
    if (!modal || !url) return;
    var wrap = modal.querySelector('.snize-quick-view-image-wrapper');
    if (!wrap) return;
    var abs = previewUrl(url, 900);

    var layer = wrap.querySelector('[data-snize-qv-main-preview]');
    if (layer) {
      layer.style.display = 'none';
      layer.removeAttribute('data-snize-qv-main-preview-visible');
    }

    wrap.removeAttribute('data-snize-qv-using-preview');
    restoreNativeSlides(wrap);

    var nativeImg = getNativeMainSlide(wrap);
    if (nativeImg) {
      setMainImageSrc(nativeImg, abs);
      if (isMobile()) showActiveMobileSlide(wrap, nativeImg);
    }

    modal.setAttribute('data-snize-qv-custom-preview', '1');
    modal.setAttribute('data-snize-qv-custom-preview-url', abs);
    modal.removeAttribute('data-snize-qv-extra-preview');
  }

  function revealMobilePreviewLayer(layer) {
    if (!layer) return;
    layer.setAttribute('data-snize-qv-main-preview-visible', '1');
    layer.style.display = 'flex';
    layer.style.visibility = 'visible';
    layer.style.opacity = '1';
    layer.style.position = 'relative';
    layer.style.inset = 'auto';
    layer.style.top = 'auto';
    layer.style.left = 'auto';
    layer.style.right = 'auto';
    layer.style.bottom = 'auto';
    layer.style.width = '100%';
    layer.style.height = 'auto';
  }

  function showActiveMobileSlide(wrap, nativeImg) {
    if (!wrap || !nativeImg) return;
    var activeSlide = nativeImg.closest('.snize-quick-view-image, .snize-quick-view-image-item');
    if (!activeSlide) {
      nativeImg.style.setProperty('display', 'block', 'important');
      nativeImg.style.removeProperty('visibility');
      nativeImg.style.removeProperty('opacity');
      return;
    }
    var slides = wrap.querySelectorAll('.snize-quick-view-image, .snize-quick-view-image-item');
    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      slide.removeAttribute('data-snize-qv-mobile-active');
      slide.classList.remove('active', 'snize-active');
      slide.style.setProperty('display', 'none', 'important');
    }
    activeSlide.setAttribute('data-snize-qv-mobile-active', '1');
    activeSlide.classList.add('active', 'snize-active');
    activeSlide.style.setProperty('display', 'flex', 'important');
    activeSlide.style.removeProperty('visibility');
    activeSlide.style.removeProperty('opacity');
  }

  function showMobileMainPreview(modal, url, li, skipLayout) {
    if (!modal || !url) return;
    if (!skipLayout && !modal.classList.contains('snize-qv-mobile-layout')) {
      applyMobileLayout(modal);
    }
    var wrap = modal.querySelector('.snize-quick-view-image-wrapper');
    if (!wrap) return;
    ensureMobileImageSlot(wrap);
    var abs = previewUrl(url, 900);
    var isExtraThumb = li && li.hasAttribute('data-snize-qv-pdp-extra-thumb');

    var layer = wrap.querySelector('[data-snize-qv-main-preview]');

    if (!isExtraThumb) {
      showDesktopMainPreview(modal, url);
      return;
    }

    layer = ensureMainPreviewLayer(wrap);
    if (!layer) return;
    var img = layer.querySelector('[data-snize-qv-main-preview-img]');
    if (!img) return;

    modal.setAttribute('data-snize-qv-custom-preview', '1');
    modal.setAttribute('data-snize-qv-custom-preview-url', abs);

    var shown = img.getAttribute('data-snize-qv-shown-url') || '';
    if (shown === abs && img.complete && img.naturalHeight > 0) {
      revealMobilePreviewLayer(layer);
      hideNativeSlidesForPreview(wrap);
      return;
    }

    layer.removeAttribute('data-snize-qv-main-preview-visible');
    layer.style.display = 'flex';
    layer.style.visibility = 'hidden';
    layer.style.opacity = '0';

    var pre = new Image();
    pre.decoding = 'async';
    var applied = false;
    function applyReady() {
      if (applied) return;
      applied = true;
      img.removeAttribute('srcset');
      img.src = abs;
      img.setAttribute('data-snize-qv-shown-url', abs);
      revealMobilePreviewLayer(layer);
      hideNativeSlidesForPreview(wrap);
    }
    pre.onload = applyReady;
    pre.onerror = applyReady;
    pre.src = abs;
    if (pre.complete) applyReady();
  }

  function showMainPreview(modal, url, li, skipLayout) {
    if (!modal || !url) return;
    if (isMobile()) {
      showMobileMainPreview(modal, url, li, skipLayout);
    } else {
      showDesktopMainPreview(modal, url);
    }
  }

  function clearCustomPreview(modal) {
    if (!modal) return;
    modal.removeAttribute('data-snize-qv-custom-preview');
    modal.removeAttribute('data-snize-qv-custom-preview-url');
    modal.removeAttribute('data-snize-qv-extra-preview');
    var wrap = modal.querySelector('.snize-quick-view-image-wrapper');
    if (!wrap) return;
    var layer = wrap.querySelector('[data-snize-qv-main-preview]');
    if (layer) {
      layer.style.display = 'none';
      layer.removeAttribute('data-snize-qv-main-preview-visible');
    }
    restoreNativeSlides(wrap);
  }

  function ensureInitialMainPreview(modal) {
    if (!modal || modal.getAttribute('data-snize-qv-custom-preview') === '1') return;
    var wrap = modal.querySelector('.snize-quick-view-image-wrapper');
    if (!wrap) return;
    var main = pickMainImg(wrap);
    if (main) {
      try {
        var r = main.getBoundingClientRect();
        if (r.width > 40 && r.height > 40 && main.complete && main.naturalHeight > 0) return;
      } catch (e) {}
    }
    var strip = modal.querySelector('.snize-quick-view-thumbnails');
    if (!strip) return;
    var active =
      strip.querySelector('li.active, li.snize-active, .snize-quick-view-thumbnail.active, .snize-quick-view-thumbnail.snize-active') ||
      strip.querySelector('li:not([data-snize-qv-media-hidden="1"]), .snize-quick-view-thumbnail:not([data-snize-qv-media-hidden="1"])');
    if (!active) return;
    var url = thumbUrlFromLi(active);
    if (url) showMainPreview(modal, url, active);
  }

  function activateThumbLi(li, strip) {
    if (!strip || !li) return;
    strip.querySelectorAll('li, .snize-quick-view-thumbnail').forEach(function (t) {
      t.classList.remove('active', 'snize-active');
    });
    li.classList.add('active', 'snize-active');
  }

  function findThumbLi(target) {
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest(
      '.snize-quick-view-thumbnails li, .snize-quick-view-thumbnails .snize-quick-view-thumbnail, [data-snize-qv-pdp-extra-thumb], [data-snize-qv-supplement-facts-thumb]'
    );
  }

  window.__snizeQvExtraNormalizeStrip = function (modalOrStrip) {
    var strip =
      modalOrStrip && modalOrStrip.classList && modalOrStrip.classList.contains('snize-quick-view-thumbnails')
        ? modalOrStrip
        : modalOrStrip && modalOrStrip.querySelector
          ? modalOrStrip.querySelector('.snize-quick-view-thumbnails')
          : null;
    if (strip) normalizeStrip(strip);
  };

  window.__snizeQvExtraUpdateScroller = function (modal) {
    if (modal) updateScrollerState(modal);
  };

  function handleThumbActivate(e, li) {
    if (!li) return;
    var modal = getModal();
    if (!modal || !modal.contains(li)) return;
    if (li.getAttribute('data-snize-qv-media-hidden') === '1') return;
    if (e && e.target && e.target.closest('.snize-qv-thumb-scroller__btn')) return;
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
    var url = thumbUrlFromLi(li);
    if (!url) return;
    suppressScheduleUntil = Date.now() + 350;
    var savedScroll = getThumbViewportScroll(modal);
    showMainPreview(modal, url, li, true);
    var strip = li.closest('.snize-quick-view-thumbnails');
    if (strip) activateThumbLi(li, strip);
    restoreThumbViewportScroll(modal, savedScroll);
    scrollThumbIntoView(li);
    requestAnimationFrame(function () {
      restoreThumbViewportScroll(modal, savedScroll);
      scrollThumbIntoView(li);
      updateScrollerState(modal);
    });
  }

  function applyExtraThumbs(modal, force) {
    if (!modal) return;
    var strip = modal.querySelector('.snize-quick-view-thumbnails');
    // if (!strip) return;

    var handle = resolveHandle(modal) || '';
    if (strip) {
    var existing = strip.querySelectorAll('[data-snize-qv-pdp-extra-thumb]').length;
    if (
      !force &&
      handle &&
      modal.getAttribute('data-snize-qv-extras-applied') === handle &&
      existing > 0
    ) {
      if (!extrasCache || existing >= extrasCache.length) {
        ensureThumbScroller(modal);
        if (!layoutLock) applyMobileLayout(modal);
        return;
      }
    }
    }

    var gen = ++applyGen;

    fetchExtraImages(handle, function (items) {
      if (gen !== applyGen) return;
      var live = getModal();
      // if (!live || !live.contains(strip)) return;
      if (!live) return;

      var liveStrip = live.querySelector('.snize-quick-view-thumbnails');

      // Single-image products have no native thumbnails strip. Only build one
      // when there are extra images to show (otherwise a lone thumbnail would
      // look odd for a genuinely single-image product).
      if (!liveStrip) {
        if (!items || !items.length) return;
        liveStrip = createGeneratedThumbStrip(live);
        if (!liveStrip) return;
      } else if (!live.contains(liveStrip)) {
        return;
      }

      removeExtraThumbs(liveStrip);

      if (items && items.length) {
        for (var i = 0; i < items.length; i++) {
          if (!items[i] || !items[i].url) continue;
          // strip.appendChild(buildExtraThumb(items[i]));
          liveStrip.appendChild(buildExtraThumb(items[i]));
        }
      }

      ensureThumbScroller(live);
      if (handle) live.setAttribute('data-snize-qv-extras-applied', handle);
      setTimeout(function () {
        ensureInitialMainPreview(live);
        updateScrollerState(live);
        if (typeof window.__snizeQvScheduleSupplementFacts === 'function') {
          window.__snizeQvScheduleSupplementFacts(live);
        }
      }, 80);
    });
  }

  function scheduleApply(force) {
    if (!force && Date.now() < suppressScheduleUntil) return;
    if (applyTimer) clearTimeout(applyTimer);
    applyTimer = setTimeout(function () {
      if (!force && Date.now() < suppressScheduleUntil) return;
      applyTimer = null;
      var modal = getModal();
      if (!modal) return;
      applyExtraThumbs(modal, !!force);
      applyMobileLayout(modal);
      if (typeof window.__snizeQvScheduleSupplementFacts === 'function') {
        window.__snizeQvScheduleSupplementFacts(modal);
      }
      setTimeout(function () {
        var live = getModal();
        if (live) {
          applyMobileLayout(live);
          ensureInitialMainPreview(live);
          updateScrollerState(live);
          if (typeof window.__snizeQvScheduleSupplementFacts === 'function') {
            window.__snizeQvScheduleSupplementFacts(live);
          }
        }
      }, 150);
    }, 60);
  }

  function ensureModalObserver() {
    var modal = getModal();
    if (!modal || watchedModal === modal) return;
    watchedModal = modal;
    if (modalObserver) {
      try {
        modalObserver.disconnect();
      } catch (e) {}
    }
    modalObserver = new MutationObserver(function () {
      if (Date.now() < suppressScheduleUntil) return;
      if (observerDebounce) clearTimeout(observerDebounce);
      observerDebounce = setTimeout(function () {
        observerDebounce = null;
        scheduleApply(false);
      }, 200);
    });
    modalObserver.observe(modal, { childList: true, subtree: true });
    scheduleApply(true);
  }

  function boot() {
    fetchExtraImages('');
    ensureModalObserver();
    var obs = new MutationObserver(function () {
      if (getModal()) ensureModalObserver();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    if (getModal()) ensureModalObserver();
  }

  if (!window.__snizeQvThumbDelegateInstalled) {
    window.__snizeQvThumbDelegateInstalled = true;
    var lastTouchThumbAt = 0;

    function onThumbPointer(e) {
      var modal = getModal();
      if (!modal || !e.target || !modal.contains(e.target)) return;
      var li = findThumbLi(e.target);
      if (!li) return;
      if (e.type === 'touchend') lastTouchThumbAt = Date.now();
      if (e.type === 'click' && Date.now() - lastTouchThumbAt < 450) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      handleThumbActivate(e, li);
    }

    document.addEventListener('click', onThumbPointer, true);
    document.addEventListener('touchend', onThumbPointer, { capture: true, passive: false });

    document.addEventListener(
      'change',
      function (e) {
        var modal = getModal();
        if (!modal || !modal.contains(e.target)) return;
        if (!e.target.closest('select.snize-select-variant, select[name="id"], select[name="variant_id"]')) return;
        clearCustomPreview(modal);
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  document.addEventListener('Searchanise.Loaded', scheduleApply);
  document.addEventListener('click', function (ev) {
    if (ev.target.closest('li.snize-product, .snize-product')) {
      suppressScheduleUntil = 0;
      setTimeout(function () {
        scheduleApply(true);
      }, 0);
      setTimeout(function () {
        scheduleApply(true);
      }, 250);
    }
  }, true);
})();

/* === qv-supplement-facts === */

(function () {
  'use strict';

  var MODAL_ID = 'snize-modal-product-quick-view';
  var SF_SECTION = 'snize-quick-view-supplement-facts';
  var SF_MAP_SECTION = 'snize-variant-metafields';
  var SF_LS_PREFIX = 'snize_sf_v1_';

  var sfUrlCache = Object.create(null);
  var sfUrlPending = Object.create(null);
  var sfTimer = null;
  var sfApplyGen = 0;
  var productCache = Object.create(null);

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function resolveHandle(modal) {
    if (!modal) return '';
    var link = modal.querySelector('a[href*="/products/"]');
    if (link) {
      var href = link.getAttribute('href') || '';
      var m = href.match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    return '';
  }

  function normalizeUrl(u) {
    if (!u) return '';
    var s = String(u).trim();
    if (s.indexOf('//') === 0) s = 'https:' + s;
    return s;
  }

  function thumbSizedUrl(u) {
    var abs = normalizeUrl(u);
    if (!abs || abs.indexOf('cdn.shopify.com') === -1) return abs;
    if (/[?&]width=/.test(abs)) return abs;
    return abs + (abs.indexOf('?') >= 0 ? '&' : '?') + 'width=120';
  }

  function productSectionUrl(handle, sectionId, variantId) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url =
      root.replace(/\/?$/, '/') +
      'products/' +
      encodeURIComponent(handle) +
      '?sections=' +
      encodeURIComponent(sectionId) +
      '&_snize_sf=' +
      Date.now();
    if (variantId) url += '&variant=' + encodeURIComponent(variantId);
    return url;
  }

  function sfLsKey(handle) {
    return SF_LS_PREFIX + handle;
  }

  function sfFromLs(handle, vid) {
    try {
      var raw = localStorage.getItem(sfLsKey(handle));
      if (!raw) return '';
      var map = JSON.parse(raw);
      return (map && (map[String(vid)] || map.__product__)) || '';
    } catch (e) {
      return '';
    }
  }

  function saveSfLs(handle, vid, url) {
    if (!handle || !vid || !url) return;
    try {
      var map = {};
      var prev = localStorage.getItem(sfLsKey(handle));
      if (prev) map = JSON.parse(prev) || {};
      map[String(vid)] = url;
      localStorage.setItem(sfLsKey(handle), JSON.stringify(map));
    } catch (e2) {}
  }

  function parseSfUrlFromHtml(html) {
    if (!html) return '';
    var doc = new DOMParser().parseFromString(html || '', 'text/html');

    var pdpThumb = doc.querySelector('[data-snize-pdp-supplement-facts]');
    if (pdpThumb) {
      var pdpImg = pdpThumb.querySelector('img[src]');
      if (pdpImg) return normalizeUrl(pdpImg.getAttribute('src') || pdpImg.getAttribute('data-src') || '');
    }

    var entry = doc.querySelector('[data-snize-qv-sf-entry], [data-snize-qv-supplement-facts-thumb]');
    if (entry) {
      var u = (entry.getAttribute('data-img-url') || '').trim();
      if (u) return normalizeUrl(u);
      var img = entry.querySelector('img[src]');
      if (img) return normalizeUrl(img.getAttribute('src') || '');
    }

    var thumbs = doc.querySelectorAll('.slideshow-controls__thumbnail img[src]');
    if (thumbs.length >= 2) {
      return normalizeUrl(thumbs[1].getAttribute('src') || '');
    }
    return '';
  }

  function parseSfMapFromHtml(html, vid) {
    if (!html) return '';
    var doc = new DOMParser().parseFromString(html || '', 'text/html');
    var nodes = doc.querySelectorAll('[data-snize-qv-sf-entry]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var nodeVid = node.getAttribute('data-variant-id') || '';
      if (nodeVid && String(nodeVid) !== String(vid) && nodeVid !== '__product__') continue;
      var u = (node.getAttribute('data-img-url') || '').trim();
      if (!u) {
        var img = node.querySelector('img[src]');
        if (img) u = img.getAttribute('src') || '';
      }
      if (u) return normalizeUrl(u);
    }
    return '';
  }

  function fetchProduct(handle, cb) {
    if (!handle) {
      cb(null);
      return;
    }
    if (productCache[handle] !== undefined) {
      cb(productCache[handle]);
      return;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (p) {
        productCache[handle] = p || null;
        cb(productCache[handle]);
      })
      .catch(function () {
        productCache[handle] = null;
        cb(null);
      });
  }

  function variantIdFromProduct(modal, product) {
    if (!modal || !product || !product.variants || !product.variants.length) return '';
    var active = modal.querySelector(
      '.snize-size-select-box .snize-size-active, .snize-size.snize-active, .snize-product-swatches-option.snize-active, .snize-product-swatches-option.active'
    );
    if (active) {
      var fromAttr =
        active.getAttribute('data-variant-id') ||
        active.getAttribute('data-snize-variant-id') ||
        active.getAttribute('data-variant');
      if (fromAttr) return String(fromAttr).trim();
      var label = (active.getAttribute('data-value') || active.textContent || '').trim().toLowerCase();
      if (label) {
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          var fields = [v.title, v.option1, v.option2, v.option3];
          for (var f = 0; f < fields.length; f++) {
            if (fields[f] && String(fields[f]).trim().toLowerCase() === label) return String(v.id);
          }
        }
      }
    }
    var form = modal.querySelector('form[action*="/cart/add"]');
    if (form) {
      var sel = form.querySelector('select[name="id"]');
      if (sel && sel.value) return String(sel.value).trim();
      var hid = form.querySelector('input[name="id"][type="hidden"]');
      if (hid && hid.value) return String(hid.value).trim();
    }
    if (product.variants.length === 1) return String(product.variants[0].id);
    return '';
  }

  function variantId(modal, product) {
    var fromProduct = variantIdFromProduct(modal, product);
    if (fromProduct) return fromProduct;
    var form = modal.querySelector('form[action*="/cart/add"]');
    if (!form) return '';
    var sel = form.querySelector('select[name="id"]');
    if (sel && sel.value) return String(sel.value).trim();
    return '';
  }

  function fetchSfUrl(handle, vid, cb) {
    if (!handle || !vid) {
      cb('');
      return;
    }
    var cacheKey = handle + ':' + vid;
    if (sfUrlCache[cacheKey]) {
      cb(sfUrlCache[cacheKey]);
      return;
    }
    var fromLs = sfFromLs(handle, vid);
    if (fromLs) {
      sfUrlCache[cacheKey] = fromLs;
      cb(fromLs);
      return;
    }
    if (sfUrlPending[cacheKey]) {
      sfUrlPending[cacheKey].push(cb);
      return;
    }
    sfUrlPending[cacheKey] = [cb];

    function finish(url) {
      sfUrlCache[cacheKey] = url || '';
      if (url) saveSfLs(handle, vid, url);
      var queue = sfUrlPending[cacheKey] || [];
      delete sfUrlPending[cacheKey];
      for (var i = 0; i < queue.length; i++) {
        try {
          queue[i](sfUrlCache[cacheKey]);
        } catch (e) {}
      }
    }

    fetch(productSectionUrl(handle, SF_SECTION, vid), { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : {};
      })
      .then(function (json) {
        var url = parseSfUrlFromHtml(json[SF_SECTION] || '');
        if (url) {
          finish(url);
          return;
        }
        return fetch(productSectionUrl(handle, SF_MAP_SECTION), { credentials: 'same-origin' })
          .then(function (r2) {
            return r2.ok ? r2.json() : {};
          })
          .then(function (json2) {
            return parseSfMapFromHtml(json2[SF_MAP_SECTION] || '', vid) || '';
          });
      })
      .then(function (fromMap) {
        if (fromMap) {
          finish(fromMap);
          return;
        }
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return fetch(root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle), {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        })
          .then(function (r3) {
            return r3.ok ? r3.text() : '';
          })
          .then(function (html) {
            finish(parseSfUrlFromHtml(html));
          });
      })
      .catch(function () {
        finish('');
      });
  }

  function isProductThumb(el, skipLi) {
    if (!el || el === skipLi) return false;
    if (el.hasAttribute('data-snize-qv-supplement-facts-thumb')) return false;
    if (el.hasAttribute('data-snize-qv-pdp-extra-thumb')) return false;
    var tag = (el.tagName || '').toUpperCase();
    return tag === 'LI' || (el.classList && el.classList.contains('snize-quick-view-thumbnail'));
  }

  function isThumbHidden(el) {
    if (!el) return true;
    if (el.getAttribute('data-snize-qv-media-hidden') === '1') return true;
    try {
      var st = window.getComputedStyle(el);
      if (st.display === 'none' || st.visibility === 'hidden') return true;
    } catch (e) {}
    return false;
  }

  function firstVisibleProductThumb(strip, skipLi) {
    if (!strip) return null;
    var kids = strip.children;
    for (var i = 0; i < kids.length; i++) {
      if (!isProductThumb(kids[i], skipLi)) continue;
      if (!isThumbHidden(kids[i])) return kids[i];
    }
    return null;
  }

  function firstProductThumb(strip, skipLi) {
    if (!strip) return null;
    var kids = strip.children;
    for (var i = 0; i < kids.length; i++) {
      if (isProductThumb(kids[i], skipLi)) return kids[i];
    }
    return null;
  }

  function placeSfThumb(strip, li) {
    if (!strip || !li) return;
    var anchor = firstVisibleProductThumb(strip, li) || firstProductThumb(strip, li);
    if (anchor) {
      if (anchor.nextElementSibling === li) return;
      if (anchor.nextSibling) strip.insertBefore(li, anchor.nextSibling);
      else strip.appendChild(li);
    } else {
      strip.insertBefore(li, strip.firstChild);
    }
  }

  function removeSfThumb(strip) {
    if (!strip) return;
    strip.querySelectorAll('[data-snize-qv-supplement-facts-thumb]').forEach(function (node) {
      node.remove();
    });
  }

  function buildSfThumb(strip, imgUrl) {
    var proto = strip.querySelector(
      'li.snize-quick-view-thumbnail:not([data-snize-qv-supplement-facts-thumb]):not([data-snize-qv-pdp-extra-thumb])'
    );
    var li;
    var sized = thumbSizedUrl(imgUrl);
    if (proto) {
      li = proto.cloneNode(true);
      li.classList.remove('active', 'snize-active', 'snize-size-active');
      li.classList.add('snize-qv-supplement-facts');
      li.removeAttribute('data-snize-qv-media-hidden');
      li.removeAttribute('data-snize-qv-pdp-extra-thumb');
      var img = li.querySelector('img');
      if (img) {
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = 'Supplement facts';
        img.removeAttribute('srcset');
        img.src = sized;
      }
    } else {
      li = document.createElement('li');
      li.className = 'snize-quick-view-thumbnail snize-qv-supplement-facts';
      var anchor = document.createElement('a');
      anchor.setAttribute('href', '#');
      var imgNew = document.createElement('img');
      imgNew.loading = 'lazy';
      imgNew.decoding = 'async';
      imgNew.alt = 'Supplement facts';
      imgNew.src = sized;
      anchor.appendChild(imgNew);
      li.appendChild(anchor);
    }
    li.setAttribute('data-snize-qv-supplement-facts-thumb', '');
    li.setAttribute('data-snize-qv-thumb-url', normalizeUrl(imgUrl));
    return li;
  }

  function upsertSfThumb(modal, vid, imgUrl) {
    var strip = modal.querySelector('.snize-quick-view-thumbnails');
    if (!strip || !imgUrl) return false;

    removeSfThumb(strip);
    var li = buildSfThumb(strip, imgUrl);
    li.setAttribute('data-snize-qv-sf-vid', String(vid));
    placeSfThumb(strip, li);

    if (typeof window.__snizeQvExtraNormalizeStrip === 'function') {
      window.__snizeQvExtraNormalizeStrip(strip.closest('[data-snize-qv-thumb-scroller]') ? strip : modal);
    }
    if (typeof window.__snizeQvExtraUpdateScroller === 'function') {
      window.__snizeQvExtraUpdateScroller(modal);
    }
    return true;
  }

  function applySupplementFacts(modal) {
    if (!modal) return;
    var handle = resolveHandle(modal);
    if (!handle) return;

    var gen = ++sfApplyGen;
    fetchProduct(handle, function (product) {
      if (gen !== sfApplyGen) return;
      var live = getModal();
      if (!live || !live.contains(modal)) return;

      var vid = variantId(live, product);
      if (!vid) return;

      var strip = live.querySelector('.snize-quick-view-thumbnails');
      if (!strip) return;

      var cached = sfUrlCache[handle + ':' + vid] || sfFromLs(handle, vid);
      if (cached) upsertSfThumb(live, vid, cached);

      fetchSfUrl(handle, vid, function (url) {
        if (gen !== sfApplyGen) return;
        var modalLive = getModal();
        if (!modalLive) return;
        var stripLive = modalLive.querySelector('.snize-quick-view-thumbnails');
        if (!stripLive) return;
        if (!url) {
          removeSfThumb(stripLive);
          return;
        }
        upsertSfThumb(modalLive, vid, url);
      });
    });
  }

  function scheduleSupplementFacts(modal) {
    modal = modal || getModal();
    if (!modal) return;
    if (sfTimer) clearTimeout(sfTimer);
    sfTimer = setTimeout(function () {
      sfTimer = null;
      applySupplementFacts(modal);
    }, 80);
  }

  window.__snizeQvScheduleSupplementFacts = scheduleSupplementFacts;

  document.addEventListener('click', function (e) {
    var modal = getModal();
    if (!modal || !modal.contains(e.target)) return;
    if (
      e.target.closest(
        '.snize-size-select-box .snize-size, .snize-size.snize-active, .snize-product-swatches-option, .snize-select-variant'
      )
    ) {
      scheduleSupplementFacts(modal);
    }
  }, true);

  document.addEventListener(
    'change',
    function (e) {
      var modal = getModal();
      if (!modal || !modal.contains(e.target)) return;
      if (e.target.closest('select[name="id"], select[name="variant_id"], select.snize-select-variant')) {
        scheduleSupplementFacts(modal);
      }
    },
    true
  );

  document.addEventListener('Searchanise.Loaded', function () {
    scheduleSupplementFacts(getModal());
  });

  document.addEventListener('click', function (ev) {
    if (ev.target.closest('li.snize-product, .snize-product')) {
      sfApplyGen++;
      setTimeout(function () {
        scheduleSupplementFacts(getModal());
      }, 300);
    }
  }, true);
})();

/* === qv-share === */

(function () {
  var SNIZE_QV_SHARE_ICON =
    '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path d="M16.4142 13.7279L18.5355 11.6066C20.4882 9.65398 20.4882 6.48816 18.5355 4.53553V4.53553C16.5829 2.58291 13.4171 2.58291 11.4645 4.53553L9.34315 6.65685M13.5858 16.5563L11.4645 18.6777C9.51184 20.6303 6.34602 20.6303 4.3934 18.6777V18.6777C2.44078 16.725 2.44078 13.5592 4.3934 11.6066L6.51472 9.48528" stroke="#14328C" stroke-width="1.5" stroke-linecap="round"></path>' +
    '<path d="M13.5854 9.4849L9.34277 13.7275" stroke="#14328C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  var snizeQvShareLastHandle = '';
  var snizeQvShareOpenPopup = null;
  var snizeQvShareOutsideListener = null;

  function shopifyRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/');
  }

  function productHandleFromHref(href) {
    if (!href || typeof href !== 'string') return '';
    var m = href.match(/\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)/i);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function getQvModal() {
    return document.getElementById('snize-modal-product-quick-view');
  }

  function resolveQvHandle(modal) {
    if (!modal) return snizeQvShareLastHandle || '';
    if (typeof window.snizeResolveQuickViewHandle === 'function') {
      var fromApi = window.snizeResolveQuickViewHandle(modal);
      if (fromApi) return fromApi;
    }
    var links = modal.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var h = productHandleFromHref(links[i].getAttribute('href'));
      if (h) return h;
    }
    var showMore = modal.querySelector('.snize-quick-view-show-more');
    if (showMore) {
      var smHandle = productHandleFromHref(showMore.getAttribute('href'));
      if (smHandle) return smHandle;
    }
    return snizeQvShareLastHandle || '';
  }

  function buildProductUrl(handle) {
    if (!handle) return window.location.href;
    return (window.location.origin || '') + shopifyRoot() + 'products/' + encodeURIComponent(handle);
  }

  function encodeSafe(v) {
    return encodeURIComponent(String(v || ''));
  }

  function shareWindow(url) {
    var w = 600;
    var h = 500;
    var left = window.screenX + window.outerWidth / 2 - w / 2;
    var top = window.screenY + window.outerHeight / 2 - h / 2;
    window.open(
      url,
      'ShareWindow',
      'width=' + w + ',height=' + h + ',left=' + left + ',top=' + top + ',resizable=yes,scrollbars=yes'
    );
  }

  function clearPopupStyles(popup) {
    if (!popup) return;
    popup.removeAttribute('style');
    popup.setAttribute('hidden', '');
    popup.setAttribute('aria-hidden', 'true');
  }

  function showPopup(popup, btn) {
    if (!popup || !btn) return;
    var rect = btn.getBoundingClientRect();
    var w = 300;
    var h = 300;
    var margin = 8;
    var left = rect.right - w;
    var top = rect.bottom + margin;
    if (left < 10) left = 10;
    if (left + w > window.innerWidth - 10) left = window.innerWidth - w - 10;
    if (top + h > window.innerHeight - 10) top = Math.max(10, rect.top - h - margin);

    document.body.appendChild(popup);
    popup.removeAttribute('hidden');
    popup.setAttribute('aria-hidden', 'false');
    popup.style.cssText =
      'display:block;visibility:visible;opacity:1;pointer-events:auto;position:fixed;' +
      'left:' + Math.round(left) + 'px;top:' + Math.round(top) + 'px;' +
      'width:300px;max-width:92vw;z-index:2147483647;';
    snizeQvShareOpenPopup = popup;
    armOutsideClose();
  }

  function closePopup(popup) {
    if (!popup) return;
    clearPopupStyles(popup);
    var block = document.querySelector('[data-snize-qv-share-block="1"]');
    if (block && popup.parentNode === document.body) block.appendChild(popup);
    if (snizeQvShareOpenPopup === popup) snizeQvShareOpenPopup = null;
    disarmOutsideClose();
  }

  function closeAllPopups() {
    if (snizeQvShareOpenPopup) {
      closePopup(snizeQvShareOpenPopup);
      return;
    }
    var popups = document.querySelectorAll('.snize-qv-share-popup');
    for (var i = 0; i < popups.length; i++) {
      if (!popups[i].hasAttribute('hidden')) closePopup(popups[i]);
    }
  }

  function armOutsideClose() {
    disarmOutsideClose();
    snizeQvShareOutsideListener = function (ev) {
      if (!snizeQvShareOpenPopup) return;
       // Only a genuine user click should close the popup. Out-of-stock quick
      // views fire synthetic click/variant events (stock check + Klaviyo BIS
      // wiring) that would otherwise snap the popup shut on their own.
      if (ev && ev.isTrusted === false) return;
      if (!ev.target) return;
      if (snizeQvShareOpenPopup.contains(ev.target)) return;
      if (ev.target.closest && ev.target.closest('[data-snize-qv-share-btn="1"]')) return;
      closePopup(snizeQvShareOpenPopup);
    };
    setTimeout(function () {
      document.addEventListener('click', snizeQvShareOutsideListener, true);
    }, 0);
  }

  function disarmOutsideClose() {
    if (!snizeQvShareOutsideListener) return;
    document.removeEventListener('click', snizeQvShareOutsideListener, true);
    snizeQvShareOutsideListener = null;
  }

  function copyLink(btn) {
    var popup = btn.closest('.snize-qv-share-popup');
    var input = popup ? popup.querySelector('.snize-qv-share-popup__input') : null;
    if (!input || !input.value) return;
    function done() {
      btn.textContent = 'Copied!';
      setTimeout(function () {
        btn.textContent = 'Copy Link';
      }, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(input.value).then(done).catch(function () {
        input.select();
        try {
          document.execCommand('copy');
          done();
        } catch (e) {}
      });
    } else {
      input.select();
      try {
        document.execCommand('copy');
        done();
      } catch (e2) {}
    }
  }

  function wirePopup(popup) {
    if (!popup || popup.getAttribute('data-snize-qv-share-wired') === '1') return;
    popup.setAttribute('data-snize-qv-share-wired', '1');
    popup.setAttribute('hidden', '');
    var copyBtn = popup.querySelector('.snize-qv-share-popup__copy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        copyLink(copyBtn);
      });
    }
    popup.querySelectorAll('[data-snize-share]').forEach(function (link) {
      link.addEventListener('click', function (ev) {
        ev.preventDefault();
        var kind = link.getAttribute('data-snize-share');
        var url = link.getAttribute('data-share-url') || '';
        var title = link.getAttribute('data-share-title') || '';
        if (!url) return;
        if (kind === 'facebook') {
          shareWindow('https://www.facebook.com/sharer/sharer.php?u=' + encodeSafe(url));
        } else if (kind === 'twitter') {
          shareWindow('https://twitter.com/intent/tweet?url=' + encodeSafe(url) + '&text=' + encodeSafe(title));
        } else if (kind === 'linkedin') {
          shareWindow('https://www.linkedin.com/sharing/share-offsite/?url=' + encodeSafe(url));
        } else if (kind === 'email') {
          window.location.href = 'mailto:?subject=' + encodeSafe(title) + '&body=' + encodeSafe(url);
        }
      });
    });
  }

  function createShareBlock() {
    var block = document.createElement('div');
    block.className = 'snize-qv-share-block';
    block.setAttribute('data-snize-qv-share-block', '1');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'snize-qv-share-btn';
    btn.setAttribute('data-snize-qv-share-btn', '1');
    btn.innerHTML = SNIZE_QV_SHARE_ICON + ' Share';

    var popup = document.createElement('div');
    popup.className = 'snize-qv-share-popup';
    popup.innerHTML =
      '<p class="snize-qv-share-popup__title">Share on social media</p>' +
      '<div class="share-icons">' +
      '<a href="#" data-snize-share="facebook" style="color:#1877F2;" aria-label="Facebook">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg></a>' +
      '<a href="#" data-snize-share="twitter" style="color:#000;" aria-label="X">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.259 5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg></a>' +
      '<a href="#" data-snize-share="linkedin" style="color:#0A66C2;" aria-label="LinkedIn">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg></a>' +
      '<a href="#" data-snize-share="email" style="color:#14328c;" aria-label="Email">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 7 10-7"/></svg></a>' +
      '</div>' +
      '<p class="snize-qv-share-popup__label">Link</p>' +
      '<input class="snize-qv-share-popup__input" type="text" readonly value="">' +
      '<button type="button" class="snize-qv-share-popup__copy">Copy Link</button>';

    wirePopup(popup);
    block.appendChild(btn);
    block.appendChild(popup);
    return block;
  }

  function updateShareBlock(block, handle, title) {
    if (!block || !handle) return;
    var url = buildProductUrl(handle);
    var popup = block.querySelector('.snize-qv-share-popup');
    var input = popup ? popup.querySelector('.snize-qv-share-popup__input') : null;
    if (input) input.value = url;
    block.querySelectorAll('[data-snize-share]').forEach(function (link) {
      link.setAttribute('data-share-url', url);
      link.setAttribute('data-share-title', title || '');
    });
    block.setAttribute('data-snize-qv-share-handle', handle);
  }

  function findSubtitleAnchor(modal) {
    if (!modal) return null;
    var attrs = modal.querySelectorAll('.snize-quick-view-attribute');
    if (attrs.length) return attrs[attrs.length - 1];
    return modal.querySelector('.snize-quick-view-title');
  }

  function findQvReviewsNode(modal) {
    if (!modal) return null;
    var selectors = [
      '.snize-quick-view-reviews-wrapper',
      '.snize-quick-view-reviews',
      '[class*="snize-quick-view-reviews"]',
      '.snize-reviews',
      '.yotpo-widget-instance',
      '.yotpo-bottomline',
      '[data-yotpo-product-id]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var node = modal.querySelector(selectors[i]);
      if (node && !node.closest('[data-snize-qv-reviews-slot="1"]')) return node;
    }
    return null;
  }

  function getOrCreateMetaRow(modal) {
    var row = modal.querySelector('[data-snize-qv-meta-row="1"]');
    if (row) return row;
    row = document.createElement('div');
    row.className = 'snize-qv-meta-row';
    row.setAttribute('data-snize-qv-meta-row', '1');
    var reviewsSlot = document.createElement('div');
    reviewsSlot.className = 'snize-qv-reviews-slot';
    reviewsSlot.setAttribute('data-snize-qv-reviews-slot', '1');
    var shareSlot = document.createElement('div');
    shareSlot.className = 'snize-qv-share-slot';
    shareSlot.setAttribute('data-snize-qv-share-slot', '1');
    row.appendChild(reviewsSlot);
    row.appendChild(shareSlot);
    return row;
  }

  function placeSnizeQvMetaRow(modal, row) {
    if (!modal || !row) return;
    var anchor = findSubtitleAnchor(modal);
    if (anchor && anchor.parentNode) {
      if (row.parentNode !== anchor.parentNode || row.previousElementSibling !== anchor) {
        anchor.parentNode.insertBefore(row, anchor.nextSibling);
      }
      return;
    }
    if (!modal.contains(row)) {
      var contentRight = modal.querySelector('.snize-quick-view-content-right') || modal;
      contentRight.insertBefore(row, contentRight.firstChild);
    }
  }

  function snizeQvAttachReviewsObs(modal) {
    if (!modal || modal.__snizeQvReviewsObsAttached) return;
    modal.__snizeQvReviewsObsAttached = true;
    var obsTimer = null;
    var obs = new MutationObserver(function () {
      if (obsTimer) clearTimeout(obsTimer);
      obsTimer = setTimeout(function () {
        obsTimer = null;
        if (!modal.isConnected) return;
        snizeQvTryMountReviews(modal);
      }, 16);
    });
    obs.observe(modal, { childList: true, subtree: true });
  }

  function ensureSnizeQvMetaRowShell(modal) {
    modal = modal || getQvModal();
    if (!modal) return null;
    var row = getOrCreateMetaRow(modal);
    placeSnizeQvMetaRow(modal, row);
    snizeQvAttachReviewsObs(modal);
    return row;
  }

  function mountReviewsIntoMetaRow(modal, row) {
    if (!modal || !row) return false;
    var slot = row.querySelector('[data-snize-qv-reviews-slot="1"]');
    if (!slot) return false;
    var reviews = findQvReviewsNode(modal);
    if (!reviews) return false;
    if (reviews.parentNode === slot) return true;
    slot.appendChild(reviews);
    reviews.setAttribute('data-snize-qv-reviews-placed', '1');
    return true;
  }

  function mountMetaRow(modal, block) {
    if (!modal || !block) return;
    var row = ensureSnizeQvMetaRowShell(modal);
    if (!row) return;
    var shareSlot = row.querySelector('[data-snize-qv-share-slot="1"]');
    if (shareSlot && block.parentNode !== shareSlot) shareSlot.appendChild(block);
    mountReviewsIntoMetaRow(modal, row);
  }

  function snizeQvTryMountReviews(modal) {
    modal = modal || getQvModal();
    if (!modal) return;
    var row = modal.querySelector('[data-snize-qv-meta-row="1"]') || ensureSnizeQvMetaRowShell(modal);
    if (row) mountReviewsIntoMetaRow(modal, row);
  }

  function ensureSnizeQuickViewShare(modal) {
    modal = modal || getQvModal();
    if (!modal) return;

    var handle = resolveQvHandle(modal);
    if (!handle) return;

    var block = modal.querySelector('[data-snize-qv-share-block="1"]');
    if (!block) block = createShareBlock();
    mountMetaRow(modal, block);

    var titleEl = modal.querySelector('.snize-quick-view-title');
    var title = titleEl ? String(titleEl.textContent || '').trim() : '';

    function apply(productTitle) {
      if (!modal.isConnected) return;
      updateShareBlock(block, handle, productTitle || title);
      mountMetaRow(modal, block);
    }

    if (window.__snizeProductApi && typeof window.__snizeProductApi.fetchProduct === 'function') {
      window.__snizeProductApi.fetchProduct(handle, function (product) {
        apply(product && product.title);
      });
    } else {
      apply(title);
    }
  }

  var scheduleTimer = null;
  var scheduleTries = 0;

  function scheduleSnizeQuickViewShare() {
    snizeQvTryMountReviews();
    if (scheduleTimer) clearTimeout(scheduleTimer);
    scheduleTimer = setTimeout(function () {
      scheduleTimer = null;
      var modal = getQvModal();
      if (!modal) return;
      ensureSnizeQvMetaRowShell(modal);
      snizeQvTryMountReviews();
      var handle = resolveQvHandle(modal);
      if (!handle && scheduleTries < 12) {
        scheduleTries += 1;
        scheduleSnizeQuickViewShare();
        return;
      }
      scheduleTries = 0;
      ensureSnizeQuickViewShare(modal);
      snizeQvTryMountReviews();
    }, 50);
  }

  function snizeQvRunShareBoot() {
    scheduleTries = 0;
    var modal = getQvModal();
    if (modal) ensureSnizeQvMetaRowShell(modal);
    scheduleSnizeQuickViewShare();
    requestAnimationFrame(function () {
      snizeQvTryMountReviews();
      var m = getQvModal();
      if (m) ensureSnizeQuickViewShare(m);
    });
  }

  function onShareButtonClick(ev) {
    var btn = ev.target.closest('[data-snize-qv-share-btn="1"]');
    if (!btn) return;

    ev.preventDefault();
    ev.stopPropagation();

    var block = btn.closest('[data-snize-qv-share-block="1"]');
    if (!block) return;
    var popup = block.querySelector('.snize-qv-share-popup');
    if (!popup) return;

    if (snizeQvShareOpenPopup === popup && !popup.hasAttribute('hidden')) {
      closePopup(popup);
      return;
    }

    closeAllPopups();
    var modal = getQvModal();
    if (modal) ensureSnizeQuickViewShare(modal);
    showPopup(popup, btn);
  }

  if (!window.__snizeQvShareBound) {
    window.__snizeQvShareBound = true;
    document.addEventListener('click', onShareButtonClick, false);
  }

  document.addEventListener(
    'click',
    function (ev) {
      var card = ev.target.closest('#snize_results li.snize-product, #snize_results .snize-product');
      if (!card) return;
      var link = card.querySelector('a[href*="/products/"]');
      var h = link ? productHandleFromHref(link.getAttribute('href')) : '';
      if (h) snizeQvShareLastHandle = h;
      snizeQvRunShareBoot();
    },
    true
  );

  document.addEventListener(
    'click',
    function (ev) {
      // Ignore synthetic clicks (e.g. programmatic variant/stock syncing on
      // out-of-stock quick views); only close on a real user size/swatch pick.
      if (ev && ev.isTrusted === false) return;
      if (!ev.target || !ev.target.closest) return;
      if (
        ev.target.closest(
          '#snize-modal-product-quick-view .snize-size, #snize-modal-product-quick-view .snize-product-swatches-option'
        )
      ) {
        closeAllPopups();
      }
    },
    true
  );

  window.snizeEnsureQuickViewShare = ensureSnizeQuickViewShare;
  window.snizeScheduleQuickViewShare = scheduleSnizeQuickViewShare;
  window.snizeEnsureQvMetaRowShell = ensureSnizeQvMetaRowShell;
  window.snizeQvTryMountReviews = snizeQvTryMountReviews;
})();


/* === plp-badge-watch (shared) === */

(function () {
  function attachRootObserver(key, onMutate) {
    var root = document.getElementById('snize_results');
    if (!root) return false;
    if (root[key]) return false;
    root[key] = true;
    new MutationObserver(onMutate).observe(root, { childList: true, subtree: true });
    return true;
  }

  window.__snizePlpBadgeWatch = function (key, onMutate) {
    function ensure() {
      return attachRootObserver(key, onMutate);
    }
    if (ensure()) onMutate();
    if (!document.documentElement[key + 'Body']) {
      document.documentElement[key + 'Body'] = true;
      if (document.body) {
        new MutationObserver(function () {
          if (ensure()) onMutate();
        }).observe(document.body, { childList: true, subtree: true });
      }
    }
  };

  window.__snizePlpBadgeBurst = function (injectFn) {
    if (typeof injectFn !== 'function') return;
    injectFn();
    [100, 300, 700, 1400, 2500].forEach(function (ms) {
      setTimeout(injectFn, ms);
    });
  };

  /** Left-side badges share one flex stack so they never overlap. */
  window.__snizeEnsurePlpBadgeStack = function (host) {
    if (!host) return null;
    var stack = host.querySelector('.snize-plp-badge-stack');
    if (!stack || stack.parentNode !== host) {
      stack = document.createElement('div');
      stack.className = 'snize-plp-badge-stack';
      host.insertBefore(stack, host.firstChild);
    }
    return stack;
  };

  window.__snizePlaceLeftBadge = function (host, badge) {
    if (!host || !badge) return;
    var stack = window.__snizeEnsurePlpBadgeStack(host);
    if (!stack) return;
    if (badge.parentNode !== stack) stack.appendChild(badge);
  };

  window.__snizeSyncPlpBadgeStack = function (host) {
    if (!host) return;
    var stack = host.querySelector('.snize-plp-badge-stack');
    if (!stack || stack.parentNode !== host) return;
    if (!stack.children.length) {
      stack.remove();
      return;
    }
    // Keep a stable visual order: Surplus → NEW → Best Seller → Out of Stock
    // Surplus must sit above NEW so it cannot be visually covered.
    var order = [
      '.snize-pure-surplus-badge',
      '.snize-new-badge',
      '.snize-best-seller-badge',
      '.snize-oos-badge'
    ];
    for (var i = 0; i < order.length; i++) {
      var el = stack.querySelector(order[i]);
      if (el) stack.appendChild(el);
    }
  };

  /** Surplus wins over NEW / Best Seller on the same card.
   *  Collection PLP: driven by selected variant metafield display_sale_badge. */
  window.__snizeIsSurplusCard = function (card) {
    if (!card) return false;

    // Authoritative check from Pure Surplus injector (selected-variant metafield).
    if (window.__pureSurplusSnize && typeof window.__pureSurplusSnize.isSelectedSurplus === 'function') {
      if (window.__pureSurplusSnize.isSelectedSurplus(card)) return true;
    }

    if (card.getAttribute('data-snize-surplus-wins') === '1') return true;
    var host = card.querySelector('.snize-thumbnail-wrapper, .snize-overhidden');
    if (host && host.getAttribute('data-snize-pure-surplus') === '1') return true;
    if (card.querySelector('.snize-pure-surplus-badge')) return true;

    var link = card.querySelector('a[href*="/products/"]');
    var href = link && (link.getAttribute('href') || link.href || '');
    var match = String(href).match(/\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)/i);
    var handle = match ? decodeURIComponent(match[1]) : '';
    if (!handle) return false;

    var variantMap = window.__pureSurplusVariantMap && window.__pureSurplusVariantMap[handle];
    if (!variantMap || !variantMap.byId) return false;

    var ids = Object.keys(variantMap.byId);
    // Single Shopify variant: qty pills are not real variants — use metafield directly.
    if (ids.length === 1) return !!variantMap.byId[ids[0]];

    var active = card.querySelector(
      '.snize-size-select-box:not([data-snize-qty-variant]) .snize-size-active, .snize-size-select-box:not([data-snize-qty-variant]) .snize-size.snize-active, .snize-size-select-box .snize-size-active, .snize-size.snize-active, .snize-product-swatches-option.snize-active, .snize-product-swatches-option.active'
    );
    if (!active) return false;
    // Fake qty pill on multi-variant cards without variant id — not authoritative.
    if (active.closest && active.closest('[data-snize-qty-variant]') && !active.getAttribute('data-variant-id')) {
      return false;
    }

    var vid =
      active.getAttribute('data-variant-id') ||
      active.getAttribute('data-snize-variant-id') ||
      active.getAttribute('data-variant');
    if (vid && Object.prototype.hasOwnProperty.call(variantMap.byId, String(vid))) {
      return !!variantMap.byId[String(vid)];
    }

    var label = String(
      active.getAttribute('data-value') ||
        active.getAttribute('title') ||
        active.getAttribute('aria-label') ||
        active.textContent ||
        ''
    )
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    var parts = label.split(':');
    if (parts.length > 1) label = parts[parts.length - 1].trim();

    var countMatch = label.match(/\b(\d+)\b/);
    var count = countMatch ? countMatch[1] : '';
    if (count && variantMap.byCount && Object.prototype.hasOwnProperty.call(variantMap.byCount, count)) {
      return !!variantMap.byCount[count];
    }
    if (label && variantMap.byLabel && Object.prototype.hasOwnProperty.call(variantMap.byLabel, label)) {
      return !!variantMap.byLabel[label];
    }
    return false;
  };

  /** True when the entire product is unavailable (every variant OOS). */
  window.__snizeCardLooksSoldOut = function (card) {
    if (!card) return false;

    var handle = '';
    var link = card.querySelector('a[href*="/products/"]');
    var href = link && (link.getAttribute('href') || link.href || '');
    var match = String(href || '').match(/\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)/i);
    if (match) handle = decodeURIComponent(match[1]);

    // Authoritative: Shopify product availability (all variants).
    var availMap = window.__snizeProductFullyOos;
    if (handle && availMap && Object.prototype.hasOwnProperty.call(availMap, handle)) {
      return !!availMap[handle];
    }

    function pillLooksUnavailable(pill) {
      if (!pill) return false;
      var cls = String(pill.className || '').toLowerCase();
      if (
        cls.indexOf('sold-out') !== -1 ||
        cls.indexOf('out-of-stock') !== -1 ||
        cls.indexOf('unavailable') !== -1 ||
        cls.indexOf('disabled') !== -1
      ) {
        return true;
      }
      if (pill.getAttribute('aria-disabled') === 'true') return true;
      if (pill.getAttribute('data-available') === 'false') return true;
      if (pill.hasAttribute('disabled')) return true;
      return false;
    }

    // Searchanise often renders only the selected size. A single OOS pill must NOT
    // mean the whole product is sold out (e.g. Magnesium 30ct OOS, 90ct in stock).
    var pills = card.querySelectorAll(
      '.snize-size-select-box .snize-size, .snize-product-swatches-option'
    );
    if (pills.length >= 2) {
      for (var p = 0; p < pills.length; p++) {
        if (!pillLooksUnavailable(pills[p])) return false;
      }
      return true;
    }

    // Incomplete size UI — wait for product.js; do not badge from selected-variant CTA.
    return false;
  };

  /** Out of Stock badge / priority: whole product unavailable only. */
  window.__snizeIsOosCard = function (card) {
    return !!(window.__snizeCardLooksSoldOut && window.__snizeCardLooksSoldOut(card));
  };

  window.__snizeClearCompetingLeftBadges = function (host) {
    if (!host) return;
    var stack = host.querySelector('.snize-plp-badge-stack');
    var root = stack || host;
    var newBadge = root.querySelector('.snize-new-badge');
    var bestBadge = root.querySelector('.snize-best-seller-badge');
    if (newBadge) newBadge.remove();
    if (bestBadge) bestBadge.remove();
    // Also clear any stray badges outside the stack (Searchanise re-renders).
    var card = host.closest('li.snize-product, .snize-product');
    if (card) {
      var extras = card.querySelectorAll('.snize-new-badge, .snize-best-seller-badge');
      for (var i = 0; i < extras.length; i++) extras[i].remove();
      card.removeAttribute('data-snize-new');
    }
    host.removeAttribute('data-snize-new');
    host.removeAttribute('data-snize-best-seller');
    if (window.__snizeSyncPlpBadgeStack) window.__snizeSyncPlpBadgeStack(host);
  };

  /** When OOS is present, remove every other left badge. */
  window.__snizeClearNonOosLeftBadges = function (host) {
    if (!host) return;
    var stack = host.querySelector('.snize-plp-badge-stack');
    var root = stack || host;
    var selectors = ['.snize-new-badge', '.snize-best-seller-badge', '.snize-pure-surplus-badge'];
    for (var i = 0; i < selectors.length; i++) {
      var el = root.querySelector(selectors[i]);
      if (el) el.remove();
    }
    host.removeAttribute('data-snize-new');
    host.removeAttribute('data-snize-best-seller');
    host.removeAttribute('data-snize-pure-surplus');
    if (window.__snizeSyncPlpBadgeStack) window.__snizeSyncPlpBadgeStack(host);
  };
})();

/* === new-collection-badge === */

(function () {
  var config = window.__snizeNewCollectionConfig || {};
  var COLLECTION_HANDLES = config.handles || ['new', 'new-products', 'new-in'];
  var BADGE_LABEL = config.label || 'NEW';
  var ON_NEW_COLLECTION_PAGE = !!config.onNewCollectionPage;
  var waiters = window.__newCollectionWaiters || (window.__newCollectionWaiters = []);

  function normalizeHandle(handle) {
    return String(handle || '').trim().toLowerCase();
  }

  function isNewCollectionHandle(handle) {
    var h = normalizeHandle(handle);
    for (var i = 0; i < COLLECTION_HANDLES.length; i++) {
      if (h === normalizeHandle(COLLECTION_HANDLES[i])) return true;
    }
    return false;
  }

  function shopifyRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/');
  }

  function loadHandles(done) {
    if (window.__newCollectionHandles) return done(window.__newCollectionHandles);
    waiters.push(done);
    if (window.__newCollectionLoading) return;
    window.__newCollectionLoading = true;
    var map = Object.create(null);
    var handleIndex = 0;

    function fetchCollectionProducts(collectionHandle, page) {
      fetch(
        shopifyRoot() + 'collections/' + encodeURIComponent(collectionHandle) + '/products.json?limit=250&page=' + page,
        { credentials: 'same-origin' }
      )
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (data) {
          if (data && data.products && data.products.length) {
            for (var i = 0; i < data.products.length; i++) {
              if (data.products[i].handle) map[data.products[i].handle] = true;
            }
            if (data.products.length === 250) {
              fetchCollectionProducts(collectionHandle, page + 1);
              return;
            }
          }
          handleIndex++;
          if (handleIndex < COLLECTION_HANDLES.length) {
            fetchCollectionProducts(COLLECTION_HANDLES[handleIndex], 1);
            return;
          }
          window.__newCollectionHandles = map;
          var pending = waiters.slice();
          waiters.length = 0;
          for (var j = 0; j < pending.length; j++) pending[j](map);
        })
        .catch(function () {
          handleIndex++;
          if (handleIndex < COLLECTION_HANDLES.length) {
            fetchCollectionProducts(COLLECTION_HANDLES[handleIndex], 1);
            return;
          }
          window.__newCollectionHandles = map;
          var pending = waiters.slice();
          waiters.length = 0;
          for (var k = 0; k < pending.length; k++) pending[k](map);
        });
    }

    fetchCollectionProducts(COLLECTION_HANDLES[0], 1);
  }

  function handleFromHref(href) {
    var match = String(href || '').match(/\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function handleFromCard(card) {
    if (!card) return '';
    var nodes = card.querySelectorAll(
      '[data-product-handle],[data-snize-product-handle],[data-handle],[data-product-url],[data-url],a[href*="/products/"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var handle =
        el.getAttribute('data-product-handle') ||
        el.getAttribute('data-snize-product-handle') ||
        el.getAttribute('data-handle');
      if (handle) return String(handle).trim();
      handle = handleFromHref(
        el.getAttribute('data-product-url') || el.getAttribute('data-url') || el.getAttribute('href')
      );
      if (handle) return handle;
    }
    return '';
  }

  function isCollectionPage() {
    var ctx = window.__snizeCollectionContext || {};
    if (ctx.mode === 'collection' && ctx.handle) return true;
    var match = String(window.location.pathname || '').match(/\/collections\/([^/?#]+)/i);
    if (!match) return false;
    var handle = decodeURIComponent(match[1]).toLowerCase();
    return handle !== 'all' && handle !== 'frontpage';
  }

  function isNewCollectionPage() {
    if (ON_NEW_COLLECTION_PAGE) return true;
    var ctx = window.__snizeCollectionContext || {};
    if (ctx.mode === 'collection' && isNewCollectionHandle(ctx.handle)) return true;
    var match = String(window.location.pathname || '').match(/\/collections\/([^/?#]+)/i);
    return !!(match && isNewCollectionHandle(decodeURIComponent(match[1])));
  }

  function findBadgeHost(card) {
    if (!card) return null;
    return (
      card.querySelector('.snize-thumbnail-wrapper') ||
      card.querySelector('.snize-overhidden') ||
      card.querySelector('span.snize-thumbnail') ||
      card.querySelector('.snize-thumbnail')
    );
  }

  function cardHasNewTag(card) {
    if (!card || !card.classList) return false;
    if (card.classList.contains('snize-product-tag-new')) return true;
    var classes = String(card.className || '').toLowerCase();
    return classes.indexOf('snize-product-tag-new') !== -1;
  }

  function shouldShowBadge(handle, map, card) {
    if (!isCollectionPage()) return false;
    // Out of Stock takes priority over every other badge.
    if (window.__snizeIsOosCard && window.__snizeIsOosCard(card)) return false;
    // Pure Surplus (display_sale_badge) takes priority over NEW — never stack/replace.
    if (card && card.getAttribute('data-snize-surplus-wins') === '1') return false;
    if (window.__snizeIsSurplusCard && window.__snizeIsSurplusCard(card)) return false;
    if (isNewCollectionPage()) return true;
    if (cardHasNewTag(card)) return true;
    return !!(handle && map && map[handle]);
  }

  function renderBadge(host, show) {
    if (!host) return;
    var badge =
      host.querySelector('.snize-plp-badge-stack .snize-new-badge') || host.querySelector('.snize-new-badge');
    if (!show) {
      if (badge) badge.remove();
      host.removeAttribute('data-snize-new');
      if (window.__snizeSyncPlpBadgeStack) window.__snizeSyncPlpBadgeStack(host);
      return;
    }
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'snize-new-badge';
      badge.setAttribute('aria-hidden', 'true');
    }
    badge.textContent = BADGE_LABEL;
    if (window.__snizePlaceLeftBadge) window.__snizePlaceLeftBadge(host, badge);
    else host.appendChild(badge);
    host.setAttribute('data-snize-new', '1');
    if (window.__snizeSyncPlpBadgeStack) window.__snizeSyncPlpBadgeStack(host);
  }

  function injectCard(card, map) {
    if (!card) return;
    var host = findBadgeHost(card);
    // Hard block: if Pure Surplus wins for this card, never paint NEW.
    if (
      (card.getAttribute && card.getAttribute('data-snize-surplus-wins') === '1') ||
      card.querySelector('.snize-pure-surplus-badge') ||
      (host && host.getAttribute('data-snize-pure-surplus') === '1') ||
      (window.__snizeIsSurplusCard && window.__snizeIsSurplusCard(card))
    ) {
      renderBadge(host, false);
      return;
    }
    var handle = handleFromCard(card);
    var show = shouldShowBadge(handle, map, card);
    renderBadge(host, show);
  }

  function injectCards(map) {
    var cards = document.querySelectorAll(
      '#snize-search-results-grid-mode li.snize-product, #snize-search-results-list-mode li.snize-product, #snize_results li.snize-product'
    );
    for (var i = 0; i < cards.length; i++) injectCard(cards[i], map);
  }

  function injectQuickView(map) {
    // Badges are PLP-only — never inject into Quick View.
    return;
  }

  function injectAll() {
    if (!isCollectionPage()) return;
    if (isNewCollectionPage()) {
      injectCards(null);
      return;
    }
    // Fast path: tag classes already on cards; still hydrate collection map for completeness.
    injectCards(window.__newCollectionHandles || null);
    loadHandles(function (map) {
      injectCards(map);
    });
  }

  function schedule() {
    if (schedule.timer) clearTimeout(schedule.timer);
    schedule.timer = setTimeout(function () {
      schedule.timer = null;
      injectAll();
    }, 80);
  }

  function start() {
    window.__snizePlpBadgeBurst(injectAll);
    window.__snizePlpBadgeWatch('__snizeNewBadgeObs', schedule);
  }

  window.__newCollectionSnize = {
    injectCard: function (card) {
      if (!isCollectionPage()) return;
      if (isNewCollectionPage() || cardHasNewTag(card)) {
        injectCard(card, null);
        return;
      }
      loadHandles(function (map) {
        injectCard(card, map);
      });
    },
    injectAll: injectAll
  };

  function boot() {
    if (window.__snizePlpReady && window.__snizePlpReady.onReady) {
      window.__snizePlpReady.onReady(start);
    } else {
      start();
    }
    // Also burst immediately so late Searchanise renders still get badges.
    window.__snizePlpBadgeBurst(injectAll);
  }

  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  document.addEventListener('Searchanise.Loaded', function () {
    if (window.__snizePlpReady && window.__snizePlpReady.flush) {
      window.__snizePlpReady.flush();
    }
    start();
  });
})();

/* === best-seller-badge === */

(function () {
  var config = window.__snizeBestSellerConfig || {};
  var BADGE_LABEL = config.label || 'BEST SELLER';
  var TAG = String(config.tag || 'best-seller').trim().toLowerCase();
  var TAG_COLLECTION = String(config.tagCollection || 'all').trim() || 'all';
  var TAG_CLASS = 'snize-product-tag-' + TAG.replace(/\s+/g, '-');
  var waiters = window.__bestSellerWaiters || (window.__bestSellerWaiters = []);
  // Bust previous top-10 / collection-membership caches.
  if (window.__bestSellerHandlesSource !== 'tag:' + TAG) {
    window.__bestSellerHandles = null;
    window.__bestSellerLoading = false;
  }

  function shopifyRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/');
  }

  function hasBestSellerTag(product) {
    if (!product || !TAG) return false;
    var tags = product.tags;
    if (typeof tags === 'string') tags = tags.split(',');
    if (!tags || !tags.length) return false;
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).trim().toLowerCase() === TAG) return true;
    }
    return false;
  }

  function cardHasBestSellerTag(card) {
    if (!card || !card.classList) return false;
    if (card.classList.contains(TAG_CLASS)) return true;
    var classes = String(card.className || '').toLowerCase();
    return classes.indexOf(TAG_CLASS) !== -1;
  }

  function loadHandles(done) {
    if (window.__bestSellerHandles && window.__bestSellerHandlesSource === 'tag:' + TAG) {
      return done(window.__bestSellerHandles);
    }
    waiters.push(done);
    if (window.__bestSellerLoading) return;
    window.__bestSellerLoading = true;
    var map = Object.create(null);

    function finish() {
      window.__bestSellerHandles = map;
      window.__bestSellerHandlesSource = 'tag:' + TAG;
      window.__bestSellerLoading = false;
      var pending = waiters.slice();
      waiters.length = 0;
      for (var i = 0; i < pending.length; i++) pending[i](map);
    }

    function pageUrl(useTagPath, page) {
      return (
        shopifyRoot() +
        'collections/' +
        encodeURIComponent(TAG_COLLECTION) +
        (useTagPath ? '/' + encodeURIComponent(TAG) : '') +
        '/products.json?limit=250&page=' +
        page
      );
    }

    function fetchPage(useTagPath, page) {
      fetch(pageUrl(useTagPath, page), { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) {
            // Tagged collection URL unavailable — rely on Searchanise
            // card class snize-product-tag-best-seller (no full-catalog scan).
            finish();
            return null;
          }
          return r.json();
        })
        .then(function (data) {
          if (data === null) return;
          if (data && data.products && data.products.length) {
            for (var i = 0; i < data.products.length; i++) {
              var p = data.products[i];
              if (!p || !p.handle) continue;
              if (useTagPath || hasBestSellerTag(p)) map[p.handle] = true;
            }
            if (data.products.length === 250) {
              fetchPage(useTagPath, page + 1);
              return;
            }
          }
          finish();
        })
        .catch(function () {
          finish();
        });
    }

    // Prefer /collections/{tagCollection}/{tag} when Shopify exposes it.
    fetchPage(true, 1);
  }

  function handleFromHref(href) {
    var match = String(href || '').match(/\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function handleFromCard(card) {
    if (!card) return '';
    var nodes = card.querySelectorAll(
      '[data-product-handle],[data-snize-product-handle],[data-handle],[data-product-url],[data-url],a[href*="/products/"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var handle =
        el.getAttribute('data-product-handle') ||
        el.getAttribute('data-snize-product-handle') ||
        el.getAttribute('data-handle');
      if (handle) return String(handle).trim();
      handle = handleFromHref(
        el.getAttribute('data-product-url') || el.getAttribute('data-url') || el.getAttribute('href')
      );
      if (handle) return handle;
    }
    return '';
  }

  function findBadgeHost(card) {
    if (!card) return null;
    return (
      card.querySelector('.snize-thumbnail-wrapper') ||
      card.querySelector('.snize-overhidden') ||
      card.querySelector('span.snize-thumbnail') ||
      card.querySelector('.snize-thumbnail')
    );
  }

  function shouldShowBadge(handle, map, card) {
    // Out of Stock takes priority over every other badge.
    if (window.__snizeIsOosCard && window.__snizeIsOosCard(card)) return false;
    // Pure Surplus (display_sale_badge) takes priority over Best Seller.
    if (card && card.getAttribute('data-snize-surplus-wins') === '1') return false;
    if (window.__snizeIsSurplusCard && window.__snizeIsSurplusCard(card)) return false;
    if (cardHasBestSellerTag(card)) return true;
    return !!(handle && map && map[handle]);
  }

  function renderBadge(host, show) {
    if (!host) return;
    var badge =
      host.querySelector('.snize-plp-badge-stack .snize-best-seller-badge') ||
      host.querySelector('.snize-best-seller-badge');
    if (!show) {
      if (badge) badge.remove();
      host.removeAttribute('data-snize-best-seller');
      if (window.__snizeSyncPlpBadgeStack) window.__snizeSyncPlpBadgeStack(host);
      return;
    }
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'snize-best-seller-badge';
      badge.setAttribute('aria-hidden', 'true');
    }
    badge.textContent = BADGE_LABEL;
    if (window.__snizePlaceLeftBadge) window.__snizePlaceLeftBadge(host, badge);
    else host.appendChild(badge);
    host.setAttribute('data-snize-best-seller', '1');
    if (window.__snizeSyncPlpBadgeStack) window.__snizeSyncPlpBadgeStack(host);
  }

  function injectCard(card, map) {
    if (!card) return;
    var host = findBadgeHost(card);
    if (
      (card.getAttribute && card.getAttribute('data-snize-surplus-wins') === '1') ||
      card.querySelector('.snize-pure-surplus-badge') ||
      (host && host.getAttribute('data-snize-pure-surplus') === '1') ||
      (window.__snizeIsSurplusCard && window.__snizeIsSurplusCard(card))
    ) {
      renderBadge(host, false);
      return;
    }
    var handle = handleFromCard(card);
    var show = shouldShowBadge(handle, map, card);
    renderBadge(host, show);
  }

  function injectCards(map) {
    var cards = document.querySelectorAll(
      '#snize-search-results-grid-mode li.snize-product, #snize-search-results-list-mode li.snize-product, #snize_results li.snize-product'
    );
    for (var i = 0; i < cards.length; i++) injectCard(cards[i], map);
  }

  function injectQuickView(map) {
    // Badges are PLP-only — never inject into Quick View.
    return;
  }

  function injectAll() {
    // Fast path via Searchanise tag classes, then hydrate from tag map.
    injectCards(window.__bestSellerHandles || null);
    loadHandles(function (map) {
      injectCards(map);
    });
  }

  function schedule() {
    if (schedule.timer) clearTimeout(schedule.timer);
    schedule.timer = setTimeout(function () {
      schedule.timer = null;
      injectAll();
    }, 80);
  }

  function start() {
    window.__snizePlpBadgeBurst(injectAll);
    window.__snizePlpBadgeWatch('__snizeBestBadgeObs', schedule);
  }

  window.__bestSellerSnize = {
    injectCard: function (card) {
      if (cardHasBestSellerTag(card) && !(window.__snizeIsSurplusCard && window.__snizeIsSurplusCard(card))) {
        injectCard(card, null);
        return;
      }
      loadHandles(function (map) {
        injectCard(card, map);
      });
    },
    injectAll: injectAll
  };

  function boot() {
    if (window.__snizePlpReady && window.__snizePlpReady.onReady) {
      window.__snizePlpReady.onReady(start);
    } else {
      start();
    }
    window.__snizePlpBadgeBurst(injectAll);
  }

  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  document.addEventListener('Searchanise.Loaded', function () {
    if (window.__snizePlpReady && window.__snizePlpReady.flush) {
      window.__snizePlpReady.flush();
    }
    start();
  });
})();

/* === out-of-stock-badge === */

(function () {
  var BADGE_LABEL = 'OUT OF STOCK';
  var fullyOosMap = (window.__snizeProductFullyOos =
    window.__snizeProductFullyOos || Object.create(null));
  var pendingByHandle = Object.create(null);

  function shopifyRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/');
  }

  function handleFromCard(card) {
    if (!card) return '';
    var link = card.querySelector('a[href*="/products/"]');
    var href = link && (link.getAttribute('href') || link.href || '');
    var match = String(href || '').match(/\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function productIsFullyOos(product) {
    if (!product) return false;
    if (product.available === false) return true;
    var variants = product.variants || [];
    if (!variants.length) return product.available === false;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].available) return false;
    }
    return true;
  }

  function ensureFullyOosKnown(handle, done) {
    if (!handle) {
      if (done) done(null);
      return;
    }
    if (Object.prototype.hasOwnProperty.call(fullyOosMap, handle)) {
      if (done) done(fullyOosMap[handle]);
      return;
    }
    if (!pendingByHandle[handle]) pendingByHandle[handle] = [];
    if (done) pendingByHandle[handle].push(done);
    if (pendingByHandle[handle].length > 1) return;

    fetch(shopifyRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (product) {
        fullyOosMap[handle] = productIsFullyOos(product);
        var cbs = pendingByHandle[handle] || [];
        delete pendingByHandle[handle];
        for (var i = 0; i < cbs.length; i++) cbs[i](fullyOosMap[handle]);
      })
      .catch(function () {
        // Leave unset so DOM heuristics can still decide.
        var cbs = pendingByHandle[handle] || [];
        delete pendingByHandle[handle];
        for (var i = 0; i < cbs.length; i++) cbs[i](null);
      });
  }

  function findBadgeHost(card) {
    if (!card) return null;
    return (
      card.querySelector('.snize-thumbnail-wrapper') ||
      card.querySelector('.snize-overhidden') ||
      card.querySelector('span.snize-thumbnail') ||
      card.querySelector('.snize-thumbnail')
    );
  }

  function cardLooksFullySoldOut(card) {
    if (window.__snizeCardLooksSoldOut) return window.__snizeCardLooksSoldOut(card);
    return false;
  }

  function reapplyOtherBadges(card) {
    if (!card) return;
    if (window.__newCollectionSnize && window.__newCollectionSnize.injectCard) {
      window.__newCollectionSnize.injectCard(card);
    }
    if (window.__bestSellerSnize && window.__bestSellerSnize.injectCard) {
      window.__bestSellerSnize.injectCard(card);
    }
    if (window.__pureSurplusSnize && window.__pureSurplusSnize.injectCard) {
      window.__pureSurplusSnize.injectCard(card);
    }
  }

  function renderBadge(host, show) {
    if (!host) return;
    var badge =
      host.querySelector('.snize-plp-badge-stack .snize-oos-badge') || host.querySelector('.snize-oos-badge');
    if (!show) {
      if (badge) badge.remove();
      host.removeAttribute('data-snize-oos');
      if (window.__snizeSyncPlpBadgeStack) window.__snizeSyncPlpBadgeStack(host);
      return;
    }
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'snize-oos-badge';
      badge.setAttribute('aria-hidden', 'true');
    }
    badge.textContent = BADGE_LABEL;
    if (window.__snizePlaceLeftBadge) window.__snizePlaceLeftBadge(host, badge);
    else host.appendChild(badge);
    host.setAttribute('data-snize-oos', '1');
    // OOS wins: remove NEW / Best Seller / Surplus on this card.
    if (window.__snizeClearNonOosLeftBadges) window.__snizeClearNonOosLeftBadges(host);
    if (window.__snizeSyncPlpBadgeStack) window.__snizeSyncPlpBadgeStack(host);
  }

  function injectCard(card) {
    if (!card) return;
    var handle = handleFromCard(card);
    var host = findBadgeHost(card);
    var wasShowing = !!(host && host.getAttribute('data-snize-oos') === '1');

    function apply(show) {
      renderBadge(host, !!show);
      if (show) {
        reapplyOtherBadges(card);
      } else if (wasShowing) {
        // Cleared false OOS badge — restore surplus/new/best if eligible.
        reapplyOtherBadges(card);
      }
    }

    // Prefer Shopify product availability (whole product).
    if (handle && Object.prototype.hasOwnProperty.call(fullyOosMap, handle)) {
      apply(!!fullyOosMap[handle]);
      return;
    }

    // Until product.js returns, only show badge for strong multi-size DOM evidence.
    // Never badge from a single selected OOS size (common Searchanise layout).
    apply(cardLooksFullySoldOut(card));

    if (!handle) return;
    ensureFullyOosKnown(handle, function (isFullyOos) {
      if (isFullyOos == null) return;
      if (!card.isConnected) return;
      apply(!!isFullyOos);
    });
  }

  function injectCards() {
    var cards = document.querySelectorAll(
      '#snize-search-results-grid-mode li.snize-product, #snize-search-results-list-mode li.snize-product, #snize_results li.snize-product'
    );
    for (var i = 0; i < cards.length; i++) injectCard(cards[i]);
  }

  function injectQuickView() {
    // Badges are PLP-only — never inject into Quick View.
    return;
  }

  function injectAll() {
    injectCards();
  }

  function schedule() {
    if (schedule.timer) clearTimeout(schedule.timer);
    schedule.timer = setTimeout(function () {
      schedule.timer = null;
      injectAll();
    }, 80);
  }

  function start() {
    window.__snizePlpBadgeBurst(injectAll);
    window.__snizePlpBadgeWatch('__snizeOosBadgeObs', schedule);
  }

  window.__oosBadgeSnize = {
    injectCard: injectCard,
    injectAll: injectAll
  };

  function boot() {
    if (window.__snizePlpReady && window.__snizePlpReady.onReady) {
      window.__snizePlpReady.onReady(start);
    } else {
      start();
    }
    window.__snizePlpBadgeBurst(injectAll);
  }

  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  document.addEventListener('Searchanise.Loaded', function () {
    if (window.__snizePlpReady && window.__snizePlpReady.flush) {
      window.__snizePlpReady.flush();
    }
    start();
  });
})();

/* === pagination-top (collection + search) === */

(function () {
  if (window.__snizePaginationTopBound) return;
  window.__snizePaginationTopBound = true;

  function isPagerTarget(t) {
    return t && t.closest && t.closest('[class*="snize-pagination"], [class*="snize-pages"], [class*="snize-page"]');
  }

  function manualScrollRestore() {
    try {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    } catch (err) {}
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !isPagerTarget(e.target)) return;

      var link = e.target.closest('a');
      var href = link && link.getAttribute('href');

      if (href && href.charAt(0) !== '#' && href.toLowerCase().indexOf('javascript:') !== 0) {
        e.preventDefault();
        e.stopPropagation();
        manualScrollRestore();
        window.location.href = link.href;
        return;
      }

      var startUrl = window.location.href;
      var tries = 0;
      var poll = setInterval(function () {
        tries++;
        if (window.location.href !== startUrl) {
          clearInterval(poll);
          manualScrollRestore();
          window.scrollTo(0, 0);
          window.location.reload();
        } else if (tries > 40) {
          clearInterval(poll);
        }
      }, 50);
    },
    true
  );
})();

